var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
var __privateMethod = (obj, member, method) => {
  __accessCheck(obj, member, "access private method");
  return method;
};
var _portalContract, _apiDepositMigration, _apiDeposit, _approveAndDeposit, approveAndDeposit_fn, _getDepositIdFromTransaction, getDepositIdFromTransaction_fn, _apiWithdrawal, _apiTbtc, _apiDeposit2, _apiWithdrawal2, _tbtcSdkPromise, _getTbtcSdk, getTbtcSdk_fn, _apiReceiptToken, _contracts, _calculateNominalCollateralRatio, calculateNominalCollateralRatio_fn, _calculateNominalCollateralRatioForExistingLoan, calculateNominalCollateralRatioForExistingLoan_fn, _calculateHint, calculateHint_fn, _calculateHintsForExistingLoan, calculateHintsForExistingLoan_fn, _contracts2, _apiUrl, _wallet, _contracts3, _bitcoinWallet, _address, _orangekitSmartAccount, _contracts4, _initializeContracts, initializeContracts_fn, _getSupportedTokens, getSupportedTokens_fn;
import { SignInWithWalletMessage } from "@orangekit/sign-in-with-wallet";
import { BitcoinAddressConverter, BitcoinNetwork, BitcoinScriptUtils, EthereumAddress, EthereumBridge, BitcoinTxHash, TBTC, Hex } from "@keep-network/tbtc-v2.ts";
import * as Sentry from "@sentry/browser";
import { BaseContract, Signature, ethers, AbstractSigner } from "ethers";
import { utils, BigNumber } from "ethers-v5";
import { mezoMatsnetTestnet, OrangeKitSmartAccount, MezoTransactionSender } from "@mezo-org/orangekit-smart-account";
const abi$4 = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "target",
        type: "address"
      }
    ],
    name: "AddressEmptyCode",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "AddressInsufficientBalance",
    type: "error"
  },
  {
    inputs: [],
    name: "FailedInnerCall",
    type: "error"
  },
  {
    inputs: [],
    name: "InvalidInitialization",
    type: "error"
  },
  {
    inputs: [],
    name: "NotInitializing",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "SafeERC20FailedOperation",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "enum BitcoinDepositor.DepositState",
        name: "actualState",
        type: "uint8"
      },
      {
        internalType: "enum BitcoinDepositor.DepositState",
        name: "expectedState",
        type: "uint8"
      }
    ],
    name: "UnexpectedDepositState",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "actualExtraData",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "expectedExtraData",
        type: "bytes32"
      }
    ],
    name: "UnexpectedExtraData",
    type: "error"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "depositKey",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "initialAmount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tbtcAmount",
        type: "uint256"
      }
    ],
    name: "DepositFinalized",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "depositKey",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "depositOwner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "depositLockPeriod",
        type: "uint256"
      }
    ],
    name: "DepositInitialized",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint64",
        name: "version",
        type: "uint64"
      }
    ],
    name: "Initialized",
    type: "event"
  },
  {
    inputs: [],
    name: "SATOSHI_MULTIPLIER",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "bridge",
    outputs: [
      {
        internalType: "contract IBridge",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "deposits",
    outputs: [
      {
        internalType: "enum BitcoinDepositor.DepositState",
        name: "",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "depositKey",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "depositOwner",
        type: "address"
      },
      {
        internalType: "uint32",
        name: "depositLockPeriod",
        type: "uint32"
      }
    ],
    name: "finalizeDeposit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_bridge",
        type: "address"
      },
      {
        internalType: "address",
        name: "_tbtcVault",
        type: "address"
      },
      {
        internalType: "address",
        name: "_tbtcToken",
        type: "address"
      },
      {
        internalType: "address",
        name: "_portal",
        type: "address"
      }
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "bytes4",
            name: "version",
            type: "bytes4"
          },
          {
            internalType: "bytes",
            name: "inputVector",
            type: "bytes"
          },
          {
            internalType: "bytes",
            name: "outputVector",
            type: "bytes"
          },
          {
            internalType: "bytes4",
            name: "locktime",
            type: "bytes4"
          }
        ],
        internalType: "struct IBridgeTypes.BitcoinTxInfo",
        name: "fundingTx",
        type: "tuple"
      },
      {
        components: [
          {
            internalType: "uint32",
            name: "fundingOutputIndex",
            type: "uint32"
          },
          {
            internalType: "bytes8",
            name: "blindingFactor",
            type: "bytes8"
          },
          {
            internalType: "bytes20",
            name: "walletPubKeyHash",
            type: "bytes20"
          },
          {
            internalType: "bytes20",
            name: "refundPubKeyHash",
            type: "bytes20"
          },
          {
            internalType: "bytes4",
            name: "refundLocktime",
            type: "bytes4"
          },
          {
            internalType: "address",
            name: "vault",
            type: "address"
          }
        ],
        internalType: "struct IBridgeTypes.DepositRevealInfo",
        name: "reveal",
        type: "tuple"
      },
      {
        internalType: "address",
        name: "depositOwner",
        type: "address"
      },
      {
        internalType: "uint32",
        name: "depositLockPeriod",
        type: "uint32"
      }
    ],
    name: "initializeDeposit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "portal",
    outputs: [
      {
        internalType: "contract Portal",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "tbtcToken",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "tbtcVault",
    outputs: [
      {
        internalType: "contract ITBTCVault",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  }
];
const bitcoinDepositorAbi = abi$4;
const crvusdAbi = [
  {
    name: "Approval",
    inputs: [
      { name: "owner", type: "address", indexed: true },
      { name: "spender", type: "address", indexed: true },
      { name: "value", type: "uint256", indexed: false }
    ],
    anonymous: false,
    type: "event"
  },
  {
    name: "Transfer",
    inputs: [
      { name: "sender", type: "address", indexed: true },
      { name: "receiver", type: "address", indexed: true },
      { name: "value", type: "uint256", indexed: false }
    ],
    anonymous: false,
    type: "event"
  },
  {
    name: "SetMinter",
    inputs: [{ name: "minter", type: "address", indexed: true }],
    anonymous: false,
    type: "event"
  },
  {
    stateMutability: "nonpayable",
    type: "constructor",
    inputs: [
      { name: "_name", type: "string" },
      { name: "_symbol", type: "string" }
    ],
    outputs: []
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "transferFrom",
    inputs: [
      { name: "_from", type: "address" },
      { name: "_to", type: "address" },
      { name: "_value", type: "uint256" }
    ],
    outputs: [{ name: "", type: "bool" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "transfer",
    inputs: [
      { name: "_to", type: "address" },
      { name: "_value", type: "uint256" }
    ],
    outputs: [{ name: "", type: "bool" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "approve",
    inputs: [
      { name: "_spender", type: "address" },
      { name: "_value", type: "uint256" }
    ],
    outputs: [{ name: "", type: "bool" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "permit",
    inputs: [
      { name: "_owner", type: "address" },
      { name: "_spender", type: "address" },
      { name: "_value", type: "uint256" },
      { name: "_deadline", type: "uint256" },
      { name: "_v", type: "uint8" },
      { name: "_r", type: "bytes32" },
      { name: "_s", type: "bytes32" }
    ],
    outputs: [{ name: "", type: "bool" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "increaseAllowance",
    inputs: [
      { name: "_spender", type: "address" },
      { name: "_add_value", type: "uint256" }
    ],
    outputs: [{ name: "", type: "bool" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "decreaseAllowance",
    inputs: [
      { name: "_spender", type: "address" },
      { name: "_sub_value", type: "uint256" }
    ],
    outputs: [{ name: "", type: "bool" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "burnFrom",
    inputs: [
      { name: "_from", type: "address" },
      { name: "_value", type: "uint256" }
    ],
    outputs: [{ name: "", type: "bool" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "burn",
    inputs: [{ name: "_value", type: "uint256" }],
    outputs: [{ name: "", type: "bool" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "mint",
    inputs: [
      { name: "_to", type: "address" },
      { name: "_value", type: "uint256" }
    ],
    outputs: [{ name: "", type: "bool" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "set_minter",
    inputs: [{ name: "_minter", type: "address" }],
    outputs: []
  },
  {
    stateMutability: "view",
    type: "function",
    name: "DOMAIN_SEPARATOR",
    inputs: [],
    outputs: [{ name: "", type: "bytes32" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "decimals",
    inputs: [],
    outputs: [{ name: "", type: "uint8" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "version",
    inputs: [],
    outputs: [{ name: "", type: "string" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "name",
    inputs: [],
    outputs: [{ name: "", type: "string" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "symbol",
    inputs: [],
    outputs: [{ name: "", type: "string" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "salt",
    inputs: [],
    outputs: [{ name: "", type: "bytes32" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "allowance",
    inputs: [
      { name: "arg0", type: "address" },
      { name: "arg1", type: "address" }
    ],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "balanceOf",
    inputs: [{ name: "arg0", type: "address" }],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "totalSupply",
    inputs: [],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "nonces",
    inputs: [{ name: "arg0", type: "address" }],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "minter",
    inputs: [],
    outputs: [{ name: "", type: "address" }]
  }
];
const daiAbi = [
  {
    inputs: [{ internalType: "uint256", name: "chainId_", type: "uint256" }],
    payable: false,
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "src", type: "address" },
      { indexed: true, internalType: "address", name: "guy", type: "address" },
      { indexed: false, internalType: "uint256", name: "wad", type: "uint256" }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: true,
    inputs: [
      { indexed: true, internalType: "bytes4", name: "sig", type: "bytes4" },
      { indexed: true, internalType: "address", name: "usr", type: "address" },
      { indexed: true, internalType: "bytes32", name: "arg1", type: "bytes32" },
      { indexed: true, internalType: "bytes32", name: "arg2", type: "bytes32" },
      { indexed: false, internalType: "bytes", name: "data", type: "bytes" }
    ],
    name: "LogNote",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "src", type: "address" },
      { indexed: true, internalType: "address", name: "dst", type: "address" },
      { indexed: false, internalType: "uint256", name: "wad", type: "uint256" }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    constant: true,
    inputs: [],
    name: "DOMAIN_SEPARATOR",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "PERMIT_TYPEHASH",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      { internalType: "address", name: "", type: "address" },
      { internalType: "address", name: "", type: "address" }
    ],
    name: "allowance",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      { internalType: "address", name: "usr", type: "address" },
      { internalType: "uint256", name: "wad", type: "uint256" }
    ],
    name: "approve",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [{ internalType: "address", name: "", type: "address" }],
    name: "balanceOf",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      { internalType: "address", name: "usr", type: "address" },
      { internalType: "uint256", name: "wad", type: "uint256" }
    ],
    name: "burn",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "decimals",
    outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [{ internalType: "address", name: "guy", type: "address" }],
    name: "deny",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      { internalType: "address", name: "usr", type: "address" },
      { internalType: "uint256", name: "wad", type: "uint256" }
    ],
    name: "mint",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      { internalType: "address", name: "src", type: "address" },
      { internalType: "address", name: "dst", type: "address" },
      { internalType: "uint256", name: "wad", type: "uint256" }
    ],
    name: "move",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "name",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [{ internalType: "address", name: "", type: "address" }],
    name: "nonces",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      { internalType: "address", name: "holder", type: "address" },
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "uint256", name: "nonce", type: "uint256" },
      { internalType: "uint256", name: "expiry", type: "uint256" },
      { internalType: "bool", name: "allowed", type: "bool" },
      { internalType: "uint8", name: "v", type: "uint8" },
      { internalType: "bytes32", name: "r", type: "bytes32" },
      { internalType: "bytes32", name: "s", type: "bytes32" }
    ],
    name: "permit",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      { internalType: "address", name: "usr", type: "address" },
      { internalType: "uint256", name: "wad", type: "uint256" }
    ],
    name: "pull",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      { internalType: "address", name: "usr", type: "address" },
      { internalType: "uint256", name: "wad", type: "uint256" }
    ],
    name: "push",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [{ internalType: "address", name: "guy", type: "address" }],
    name: "rely",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "symbol",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "totalSupply",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      { internalType: "address", name: "dst", type: "address" },
      { internalType: "uint256", name: "wad", type: "uint256" }
    ],
    name: "transfer",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      { internalType: "address", name: "src", type: "address" },
      { internalType: "address", name: "dst", type: "address" },
      { internalType: "uint256", name: "wad", type: "uint256" }
    ],
    name: "transferFrom",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "version",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [{ internalType: "address", name: "", type: "address" }],
    name: "wards",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    payable: false,
    stateMutability: "view",
    type: "function"
  }
];
const fbtcAbi = [
  {
    inputs: [
      { internalType: "address", name: "_owner", type: "address" },
      { internalType: "address", name: "_bridge", type: "address" }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    inputs: [{ internalType: "address", name: "target", type: "address" }],
    name: "AddressEmptyCode",
    type: "error"
  },
  {
    inputs: [{ internalType: "address", name: "account", type: "address" }],
    name: "AddressInsufficientBalance",
    type: "error"
  },
  {
    inputs: [
      { internalType: "address", name: "implementation", type: "address" }
    ],
    name: "ERC1967InvalidImplementation",
    type: "error"
  },
  { inputs: [], name: "ERC1967NonPayable", type: "error" },
  {
    inputs: [
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "uint256", name: "allowance", type: "uint256" },
      { internalType: "uint256", name: "needed", type: "uint256" }
    ],
    name: "ERC20InsufficientAllowance",
    type: "error"
  },
  {
    inputs: [
      { internalType: "address", name: "sender", type: "address" },
      { internalType: "uint256", name: "balance", type: "uint256" },
      { internalType: "uint256", name: "needed", type: "uint256" }
    ],
    name: "ERC20InsufficientBalance",
    type: "error"
  },
  {
    inputs: [{ internalType: "address", name: "approver", type: "address" }],
    name: "ERC20InvalidApprover",
    type: "error"
  },
  {
    inputs: [{ internalType: "address", name: "receiver", type: "address" }],
    name: "ERC20InvalidReceiver",
    type: "error"
  },
  {
    inputs: [{ internalType: "address", name: "sender", type: "address" }],
    name: "ERC20InvalidSender",
    type: "error"
  },
  {
    inputs: [{ internalType: "address", name: "spender", type: "address" }],
    name: "ERC20InvalidSpender",
    type: "error"
  },
  { inputs: [], name: "EnforcedPause", type: "error" },
  { inputs: [], name: "ExpectedPause", type: "error" },
  { inputs: [], name: "FailedInnerCall", type: "error" },
  { inputs: [], name: "InvalidInitialization", type: "error" },
  { inputs: [], name: "NotInitializing", type: "error" },
  {
    inputs: [{ internalType: "address", name: "owner", type: "address" }],
    name: "OwnableInvalidOwner",
    type: "error"
  },
  {
    inputs: [{ internalType: "address", name: "account", type: "address" }],
    name: "OwnableUnauthorizedAccount",
    type: "error"
  },
  {
    inputs: [{ internalType: "address", name: "token", type: "address" }],
    name: "SafeERC20FailedOperation",
    type: "error"
  },
  { inputs: [], name: "UUPSUnauthorizedCallContext", type: "error" },
  {
    inputs: [{ internalType: "bytes32", name: "slot", type: "bytes32" }],
    name: "UUPSUnsupportedProxiableUUID",
    type: "error"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "newBridge",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "oldBridge",
        type: "address"
      }
    ],
    name: "BridgeUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint64",
        name: "version",
        type: "uint64"
      }
    ],
    name: "Initialized",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferStarted",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "Paused",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "from", type: "address" },
      { indexed: true, internalType: "address", name: "to", type: "address" },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "Unpaused",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "implementation",
        type: "address"
      }
    ],
    name: "Upgraded",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "user", type: "address" }
    ],
    name: "UserLocked",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "user", type: "address" }
    ],
    name: "UserUnlocked",
    type: "event"
  },
  {
    inputs: [],
    name: "UPGRADE_INTERFACE_VERSION",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "acceptOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "owner", type: "address" },
      { internalType: "address", name: "spender", type: "address" }
    ],
    name: "allowance",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "uint256", name: "value", type: "uint256" }
    ],
    name: "approve",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "account", type: "address" }],
    name: "balanceOf",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "bridge",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "from", type: "address" },
      { internalType: "uint256", name: "amount", type: "uint256" }
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "_owner", type: "address" },
      { internalType: "address", name: "_bridge", type: "address" }
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "_user", type: "address" }],
    name: "lockUser",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "amount", type: "uint256" }
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "name",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "paused",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "payer", type: "address" },
      { internalType: "address", name: "feeRecipient", type: "address" },
      { internalType: "uint256", name: "amount", type: "uint256" }
    ],
    name: "payFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "pendingOwner",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "proxiableUUID",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "token", type: "address" },
      { internalType: "address", name: "to", type: "address" }
    ],
    name: "rescue",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "_bridge", type: "address" }],
    name: "setBridge",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "value", type: "uint256" }
    ],
    name: "transfer",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "from", type: "address" },
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "value", type: "uint256" }
    ],
    name: "transferFrom",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "newOwner", type: "address" }],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "_user", type: "address" }],
    name: "unlockUser",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "newImplementation", type: "address" },
      { internalType: "bytes", name: "data", type: "bytes" }
    ],
    name: "upgradeToAndCall",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "user", type: "address" }],
    name: "userBlocked",
    outputs: [{ internalType: "bool", name: "blocked", type: "bool" }],
    stateMutability: "view",
    type: "function"
  }
];
const tbtcAbi = [
  {
    inputs: [
      { internalType: "address", name: "_VendingMachine", type: "address" }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "from", type: "address" },
      { indexed: true, internalType: "address", name: "to", type: "address" },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    constant: true,
    inputs: [
      { internalType: "address", name: "owner", type: "address" },
      { internalType: "address", name: "spender", type: "address" }
    ],
    name: "allowance",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "uint256", name: "value", type: "uint256" }
    ],
    name: "approve",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "contract ITokenRecipient",
        name: "_spender",
        type: "address"
      },
      { internalType: "uint256", name: "_value", type: "uint256" },
      { internalType: "bytes", name: "_extraData", type: "bytes" }
    ],
    name: "approveAndCall",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [{ internalType: "address", name: "account", type: "address" }],
    name: "balanceOf",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [{ internalType: "uint256", name: "_amount", type: "uint256" }],
    name: "burn",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      { internalType: "address", name: "_account", type: "address" },
      { internalType: "uint256", name: "_amount", type: "uint256" }
    ],
    name: "burnFrom",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "decimals",
    outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "uint256", name: "subtractedValue", type: "uint256" }
    ],
    name: "decreaseAllowance",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "uint256", name: "addedValue", type: "uint256" }
    ],
    name: "increaseAllowance",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      { internalType: "address", name: "_account", type: "address" },
      { internalType: "uint256", name: "_amount", type: "uint256" }
    ],
    name: "mint",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "name",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "symbol",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "totalSupply",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      { internalType: "address", name: "recipient", type: "address" },
      { internalType: "uint256", name: "amount", type: "uint256" }
    ],
    name: "transfer",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      { internalType: "address", name: "sender", type: "address" },
      { internalType: "address", name: "recipient", type: "address" },
      { internalType: "uint256", name: "amount", type: "uint256" }
    ],
    name: "transferFrom",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  }
];
const thusdAbi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_troveManagerAddress1",
        type: "address"
      },
      {
        internalType: "address",
        name: "_stabilityPoolAddress1",
        type: "address"
      },
      {
        internalType: "address",
        name: "_borrowerOperationsAddress1",
        type: "address"
      },
      {
        internalType: "address",
        name: "_troveManagerAddress2",
        type: "address"
      },
      {
        internalType: "address",
        name: "_stabilityPoolAddress2",
        type: "address"
      },
      {
        internalType: "address",
        name: "_borrowerOperationsAddress2",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_governanceTimeDelay",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_newBorrowerOperationsAddress",
        type: "address"
      }
    ],
    name: "BorrowerOperationsAddressAdded",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_newStabilityPoolAddress",
        type: "address"
      }
    ],
    name: "StabilityPoolAddressAdded",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_user",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      }
    ],
    name: "THUSDTokenBalanceUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "from", type: "address" },
      { indexed: true, internalType: "address", name: "to", type: "address" },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_troveManagerAddress",
        type: "address"
      }
    ],
    name: "TroveManagerAddressAdded",
    type: "event"
  },
  {
    inputs: [],
    name: "addContractsInitiated",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "addMintListInitiated",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "owner", type: "address" },
      { internalType: "address", name: "spender", type: "address" }
    ],
    name: "allowance",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "uint256", name: "amount", type: "uint256" }
    ],
    name: "approve",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "account", type: "address" }],
    name: "balanceOf",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "_account", type: "address" },
      { internalType: "uint256", name: "_amount", type: "uint256" }
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "", type: "address" }],
    name: "burnList",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "cancelAddContracts",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "cancelAddMintList",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "cancelRevokeBurnList",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "cancelRevokeMintList",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "uint256", name: "subtractedValue", type: "uint256" }
    ],
    name: "decreaseAllowance",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "domainSeparator",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "finalizeAddContracts",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "finalizeAddMintList",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "finalizeRevokeBurnList",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "finalizeRevokeMintList",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "governanceTimeDelay",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "uint256", name: "addedValue", type: "uint256" }
    ],
    name: "increaseAllowance",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "isOwner",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "_account", type: "address" },
      { internalType: "uint256", name: "_amount", type: "uint256" }
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "", type: "address" }],
    name: "mintList",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "name",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "owner", type: "address" }],
    name: "nonces",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pendingAddedMintAddress",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pendingBorrowerOperations",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pendingRevokedBurnAddress",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pendingRevokedMintAddress",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pendingStabilityPool",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pendingTroveManager",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "owner", type: "address" },
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "uint256", name: "amount", type: "uint256" },
      { internalType: "uint256", name: "deadline", type: "uint256" },
      { internalType: "uint8", name: "v", type: "uint8" },
      { internalType: "bytes32", name: "r", type: "bytes32" },
      { internalType: "bytes32", name: "s", type: "bytes32" }
    ],
    name: "permit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "permitTypeHash",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [],
    name: "revokeBurnListInitiated",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "revokeMintListInitiated",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_troveManagerAddress",
        type: "address"
      },
      {
        internalType: "address",
        name: "_stabilityPoolAddress",
        type: "address"
      },
      {
        internalType: "address",
        name: "_borrowerOperationsAddress",
        type: "address"
      }
    ],
    name: "startAddContracts",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "_account", type: "address" }],
    name: "startAddMintList",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "_account", type: "address" }],
    name: "startRevokeBurnList",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "_account", type: "address" }],
    name: "startRevokeMintList",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "recipient", type: "address" },
      { internalType: "uint256", name: "amount", type: "uint256" }
    ],
    name: "transfer",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "sender", type: "address" },
      { internalType: "address", name: "recipient", type: "address" },
      { internalType: "uint256", name: "amount", type: "uint256" }
    ],
    name: "transferFrom",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "newOwner", type: "address" }],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "version",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "pure",
    type: "function"
  }
];
const usdeAbi = [
  {
    inputs: [{ internalType: "address", name: "admin", type: "address" }],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  { inputs: [], name: "CantRenounceOwnership", type: "error" },
  { inputs: [], name: "InvalidShortString", type: "error" },
  { inputs: [], name: "OnlyMinter", type: "error" },
  {
    inputs: [{ internalType: "string", name: "str", type: "string" }],
    name: "StringTooLong",
    type: "error"
  },
  { inputs: [], name: "ZeroAddressException", type: "error" },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Approval",
    type: "event"
  },
  { anonymous: false, inputs: [], name: "EIP712DomainChanged", type: "event" },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "newMinter",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "oldMinter",
        type: "address"
      }
    ],
    name: "MinterUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferStarted",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "from", type: "address" },
      { indexed: true, internalType: "address", name: "to", type: "address" },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    inputs: [],
    name: "DOMAIN_SEPARATOR",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "acceptOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "owner", type: "address" },
      { internalType: "address", name: "spender", type: "address" }
    ],
    name: "allowance",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "uint256", name: "amount", type: "uint256" }
    ],
    name: "approve",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "account", type: "address" }],
    name: "balanceOf",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint256", name: "amount", type: "uint256" }],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "account", type: "address" },
      { internalType: "uint256", name: "amount", type: "uint256" }
    ],
    name: "burnFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "uint256", name: "subtractedValue", type: "uint256" }
    ],
    name: "decreaseAllowance",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "eip712Domain",
    outputs: [
      { internalType: "bytes1", name: "fields", type: "bytes1" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "string", name: "version", type: "string" },
      { internalType: "uint256", name: "chainId", type: "uint256" },
      { internalType: "address", name: "verifyingContract", type: "address" },
      { internalType: "bytes32", name: "salt", type: "bytes32" },
      { internalType: "uint256[]", name: "extensions", type: "uint256[]" }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "uint256", name: "addedValue", type: "uint256" }
    ],
    name: "increaseAllowance",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "amount", type: "uint256" }
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "minter",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "name",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "owner", type: "address" }],
    name: "nonces",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pendingOwner",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "owner", type: "address" },
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "uint256", name: "value", type: "uint256" },
      { internalType: "uint256", name: "deadline", type: "uint256" },
      { internalType: "uint8", name: "v", type: "uint8" },
      { internalType: "bytes32", name: "r", type: "bytes32" },
      { internalType: "bytes32", name: "s", type: "bytes32" }
    ],
    name: "permit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "newMinter", type: "address" }],
    name: "setMinter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "amount", type: "uint256" }
    ],
    name: "transfer",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "from", type: "address" },
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "amount", type: "uint256" }
    ],
    name: "transferFrom",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "newOwner", type: "address" }],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];
const usdcAbi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "authorizer",
        type: "address"
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "nonce",
        type: "bytes32"
      }
    ],
    name: "AuthorizationCanceled",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "authorizer",
        type: "address"
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "nonce",
        type: "bytes32"
      }
    ],
    name: "AuthorizationUsed",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_account",
        type: "address"
      }
    ],
    name: "Blacklisted",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "newBlacklister",
        type: "address"
      }
    ],
    name: "BlacklisterChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "burner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "Burn",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "newMasterMinter",
        type: "address"
      }
    ],
    name: "MasterMinterChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "minter",
        type: "address"
      },
      { indexed: true, internalType: "address", name: "to", type: "address" },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "Mint",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "minter",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "minterAllowedAmount",
        type: "uint256"
      }
    ],
    name: "MinterConfigured",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "oldMinter",
        type: "address"
      }
    ],
    name: "MinterRemoved",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  { anonymous: false, inputs: [], name: "Pause", type: "event" },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "newAddress",
        type: "address"
      }
    ],
    name: "PauserChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "newRescuer",
        type: "address"
      }
    ],
    name: "RescuerChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "from", type: "address" },
      { indexed: true, internalType: "address", name: "to", type: "address" },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_account",
        type: "address"
      }
    ],
    name: "UnBlacklisted",
    type: "event"
  },
  { anonymous: false, inputs: [], name: "Unpause", type: "event" },
  {
    inputs: [],
    name: "CANCEL_AUTHORIZATION_TYPEHASH",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "DOMAIN_SEPARATOR",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "PERMIT_TYPEHASH",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "RECEIVE_WITH_AUTHORIZATION_TYPEHASH",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "TRANSFER_WITH_AUTHORIZATION_TYPEHASH",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "owner", type: "address" },
      { internalType: "address", name: "spender", type: "address" }
    ],
    name: "allowance",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "uint256", name: "value", type: "uint256" }
    ],
    name: "approve",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "authorizer", type: "address" },
      { internalType: "bytes32", name: "nonce", type: "bytes32" }
    ],
    name: "authorizationState",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "account", type: "address" }],
    name: "balanceOf",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "_account", type: "address" }],
    name: "blacklist",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "blacklister",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint256", name: "_amount", type: "uint256" }],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "authorizer", type: "address" },
      { internalType: "bytes32", name: "nonce", type: "bytes32" },
      { internalType: "uint8", name: "v", type: "uint8" },
      { internalType: "bytes32", name: "r", type: "bytes32" },
      { internalType: "bytes32", name: "s", type: "bytes32" }
    ],
    name: "cancelAuthorization",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "authorizer", type: "address" },
      { internalType: "bytes32", name: "nonce", type: "bytes32" },
      { internalType: "bytes", name: "signature", type: "bytes" }
    ],
    name: "cancelAuthorization",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "minter", type: "address" },
      { internalType: "uint256", name: "minterAllowedAmount", type: "uint256" }
    ],
    name: "configureMinter",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "currency",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "uint256", name: "decrement", type: "uint256" }
    ],
    name: "decreaseAllowance",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "uint256", name: "increment", type: "uint256" }
    ],
    name: "increaseAllowance",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "string", name: "tokenName", type: "string" },
      { internalType: "string", name: "tokenSymbol", type: "string" },
      { internalType: "string", name: "tokenCurrency", type: "string" },
      { internalType: "uint8", name: "tokenDecimals", type: "uint8" },
      { internalType: "address", name: "newMasterMinter", type: "address" },
      { internalType: "address", name: "newPauser", type: "address" },
      { internalType: "address", name: "newBlacklister", type: "address" },
      { internalType: "address", name: "newOwner", type: "address" }
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "string", name: "newName", type: "string" }],
    name: "initializeV2",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "lostAndFound", type: "address" }
    ],
    name: "initializeV2_1",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "accountsToBlacklist",
        type: "address[]"
      },
      { internalType: "string", name: "newSymbol", type: "string" }
    ],
    name: "initializeV2_2",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "_account", type: "address" }],
    name: "isBlacklisted",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "account", type: "address" }],
    name: "isMinter",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "masterMinter",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "_to", type: "address" },
      { internalType: "uint256", name: "_amount", type: "uint256" }
    ],
    name: "mint",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "minter", type: "address" }],
    name: "minterAllowance",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "name",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "owner", type: "address" }],
    name: "nonces",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "paused",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pauser",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "owner", type: "address" },
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "uint256", name: "value", type: "uint256" },
      { internalType: "uint256", name: "deadline", type: "uint256" },
      { internalType: "bytes", name: "signature", type: "bytes" }
    ],
    name: "permit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "owner", type: "address" },
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "uint256", name: "value", type: "uint256" },
      { internalType: "uint256", name: "deadline", type: "uint256" },
      { internalType: "uint8", name: "v", type: "uint8" },
      { internalType: "bytes32", name: "r", type: "bytes32" },
      { internalType: "bytes32", name: "s", type: "bytes32" }
    ],
    name: "permit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "from", type: "address" },
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "value", type: "uint256" },
      { internalType: "uint256", name: "validAfter", type: "uint256" },
      { internalType: "uint256", name: "validBefore", type: "uint256" },
      { internalType: "bytes32", name: "nonce", type: "bytes32" },
      { internalType: "bytes", name: "signature", type: "bytes" }
    ],
    name: "receiveWithAuthorization",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "from", type: "address" },
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "value", type: "uint256" },
      { internalType: "uint256", name: "validAfter", type: "uint256" },
      { internalType: "uint256", name: "validBefore", type: "uint256" },
      { internalType: "bytes32", name: "nonce", type: "bytes32" },
      { internalType: "uint8", name: "v", type: "uint8" },
      { internalType: "bytes32", name: "r", type: "bytes32" },
      { internalType: "bytes32", name: "s", type: "bytes32" }
    ],
    name: "receiveWithAuthorization",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "minter", type: "address" }],
    name: "removeMinter",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "tokenContract",
        type: "address"
      },
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "amount", type: "uint256" }
    ],
    name: "rescueERC20",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "rescuer",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "value", type: "uint256" }
    ],
    name: "transfer",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "from", type: "address" },
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "value", type: "uint256" }
    ],
    name: "transferFrom",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "newOwner", type: "address" }],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "from", type: "address" },
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "value", type: "uint256" },
      { internalType: "uint256", name: "validAfter", type: "uint256" },
      { internalType: "uint256", name: "validBefore", type: "uint256" },
      { internalType: "bytes32", name: "nonce", type: "bytes32" },
      { internalType: "bytes", name: "signature", type: "bytes" }
    ],
    name: "transferWithAuthorization",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "from", type: "address" },
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "value", type: "uint256" },
      { internalType: "uint256", name: "validAfter", type: "uint256" },
      { internalType: "uint256", name: "validBefore", type: "uint256" },
      { internalType: "bytes32", name: "nonce", type: "bytes32" },
      { internalType: "uint8", name: "v", type: "uint8" },
      { internalType: "bytes32", name: "r", type: "bytes32" },
      { internalType: "bytes32", name: "s", type: "bytes32" }
    ],
    name: "transferWithAuthorization",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "_account", type: "address" }],
    name: "unBlacklist",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "_newBlacklister", type: "address" }
    ],
    name: "updateBlacklister",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "_newMasterMinter", type: "address" }
    ],
    name: "updateMasterMinter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "_newPauser", type: "address" }],
    name: "updatePauser",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "newRescuer", type: "address" }],
    name: "updateRescuer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "version",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "pure",
    type: "function"
  }
];
const usdtAbi = [
  {
    constant: true,
    inputs: [],
    name: "name",
    outputs: [{ name: "", type: "string" }],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [{ name: "_upgradedAddress", type: "address" }],
    name: "deprecate",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      { name: "_spender", type: "address" },
      { name: "_value", type: "uint256" }
    ],
    name: "approve",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "deprecated",
    outputs: [{ name: "", type: "bool" }],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [{ name: "_evilUser", type: "address" }],
    name: "addBlackList",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "totalSupply",
    outputs: [{ name: "", type: "uint256" }],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      { name: "_from", type: "address" },
      { name: "_to", type: "address" },
      { name: "_value", type: "uint256" }
    ],
    name: "transferFrom",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "upgradedAddress",
    outputs: [{ name: "", type: "address" }],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [{ name: "", type: "address" }],
    name: "balances",
    outputs: [{ name: "", type: "uint256" }],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "decimals",
    outputs: [{ name: "", type: "uint256" }],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "maximumFee",
    outputs: [{ name: "", type: "uint256" }],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "_totalSupply",
    outputs: [{ name: "", type: "uint256" }],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [],
    name: "unpause",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [{ name: "_maker", type: "address" }],
    name: "getBlackListStatus",
    outputs: [{ name: "", type: "bool" }],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      { name: "", type: "address" },
      { name: "", type: "address" }
    ],
    name: "allowed",
    outputs: [{ name: "", type: "uint256" }],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "paused",
    outputs: [{ name: "", type: "bool" }],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [{ name: "who", type: "address" }],
    name: "balanceOf",
    outputs: [{ name: "", type: "uint256" }],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [],
    name: "pause",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "getOwner",
    outputs: [{ name: "", type: "address" }],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "owner",
    outputs: [{ name: "", type: "address" }],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "symbol",
    outputs: [{ name: "", type: "string" }],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      { name: "_to", type: "address" },
      { name: "_value", type: "uint256" }
    ],
    name: "transfer",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      { name: "newBasisPoints", type: "uint256" },
      { name: "newMaxFee", type: "uint256" }
    ],
    name: "setParams",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [{ name: "amount", type: "uint256" }],
    name: "issue",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [{ name: "amount", type: "uint256" }],
    name: "redeem",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      { name: "_owner", type: "address" },
      { name: "_spender", type: "address" }
    ],
    name: "allowance",
    outputs: [{ name: "remaining", type: "uint256" }],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "basisPointsRate",
    outputs: [{ name: "", type: "uint256" }],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [{ name: "", type: "address" }],
    name: "isBlackListed",
    outputs: [{ name: "", type: "bool" }],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [{ name: "_clearedUser", type: "address" }],
    name: "removeBlackList",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "MAX_UINT",
    outputs: [{ name: "", type: "uint256" }],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [{ name: "newOwner", type: "address" }],
    name: "transferOwnership",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [{ name: "_blackListedUser", type: "address" }],
    name: "destroyBlackFunds",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "_initialSupply", type: "uint256" },
      { name: "_name", type: "string" },
      { name: "_symbol", type: "string" },
      { name: "_decimals", type: "uint256" }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [{ indexed: false, name: "amount", type: "uint256" }],
    name: "Issue",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [{ indexed: false, name: "amount", type: "uint256" }],
    name: "Redeem",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [{ indexed: false, name: "newAddress", type: "address" }],
    name: "Deprecate",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, name: "feeBasisPoints", type: "uint256" },
      { indexed: false, name: "maxFee", type: "uint256" }
    ],
    name: "Params",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, name: "_blackListedUser", type: "address" },
      { indexed: false, name: "_balance", type: "uint256" }
    ],
    name: "DestroyedBlackFunds",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [{ indexed: false, name: "_user", type: "address" }],
    name: "AddedBlackList",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [{ indexed: false, name: "_user", type: "address" }],
    name: "RemovedBlackList",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, name: "owner", type: "address" },
      { indexed: true, name: "spender", type: "address" },
      { indexed: false, name: "value", type: "uint256" }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, name: "from", type: "address" },
      { indexed: true, name: "to", type: "address" },
      { indexed: false, name: "value", type: "uint256" }
    ],
    name: "Transfer",
    type: "event"
  },
  { anonymous: false, inputs: [], name: "Pause", type: "event" },
  { anonymous: false, inputs: [], name: "Unpause", type: "event" }
];
const wbtcAbi = [
  {
    constant: true,
    inputs: [],
    name: "mintingFinished",
    outputs: [{ name: "", type: "bool" }],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "name",
    outputs: [{ name: "", type: "string" }],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      { name: "_spender", type: "address" },
      { name: "_value", type: "uint256" }
    ],
    name: "approve",
    outputs: [{ name: "", type: "bool" }],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [{ name: "_token", type: "address" }],
    name: "reclaimToken",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "totalSupply",
    outputs: [{ name: "", type: "uint256" }],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      { name: "_from", type: "address" },
      { name: "_to", type: "address" },
      { name: "_value", type: "uint256" }
    ],
    name: "transferFrom",
    outputs: [{ name: "", type: "bool" }],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "decimals",
    outputs: [{ name: "", type: "uint8" }],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [],
    name: "unpause",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      { name: "_to", type: "address" },
      { name: "_amount", type: "uint256" }
    ],
    name: "mint",
    outputs: [{ name: "", type: "bool" }],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [{ name: "value", type: "uint256" }],
    name: "burn",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [],
    name: "claimOwnership",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "paused",
    outputs: [{ name: "", type: "bool" }],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      { name: "_spender", type: "address" },
      { name: "_subtractedValue", type: "uint256" }
    ],
    name: "decreaseApproval",
    outputs: [{ name: "success", type: "bool" }],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [{ name: "_owner", type: "address" }],
    name: "balanceOf",
    outputs: [{ name: "", type: "uint256" }],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [],
    name: "finishMinting",
    outputs: [{ name: "", type: "bool" }],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [],
    name: "pause",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "owner",
    outputs: [{ name: "", type: "address" }],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "symbol",
    outputs: [{ name: "", type: "string" }],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      { name: "_to", type: "address" },
      { name: "_value", type: "uint256" }
    ],
    name: "transfer",
    outputs: [{ name: "", type: "bool" }],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      { name: "_spender", type: "address" },
      { name: "_addedValue", type: "uint256" }
    ],
    name: "increaseApproval",
    outputs: [{ name: "success", type: "bool" }],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      { name: "_owner", type: "address" },
      { name: "_spender", type: "address" }
    ],
    name: "allowance",
    outputs: [{ name: "", type: "uint256" }],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "pendingOwner",
    outputs: [{ name: "", type: "address" }],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [{ name: "newOwner", type: "address" }],
    name: "transferOwnership",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  { anonymous: false, inputs: [], name: "Pause", type: "event" },
  { anonymous: false, inputs: [], name: "Unpause", type: "event" },
  {
    anonymous: false,
    inputs: [
      { indexed: true, name: "burner", type: "address" },
      { indexed: false, name: "value", type: "uint256" }
    ],
    name: "Burn",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, name: "to", type: "address" },
      { indexed: false, name: "amount", type: "uint256" }
    ],
    name: "Mint",
    type: "event"
  },
  { anonymous: false, inputs: [], name: "MintFinished", type: "event" },
  {
    anonymous: false,
    inputs: [{ indexed: true, name: "previousOwner", type: "address" }],
    name: "OwnershipRenounced",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, name: "previousOwner", type: "address" },
      { indexed: true, name: "newOwner", type: "address" }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, name: "owner", type: "address" },
      { indexed: true, name: "spender", type: "address" },
      { indexed: false, name: "value", type: "uint256" }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, name: "from", type: "address" },
      { indexed: true, name: "to", type: "address" },
      { indexed: false, name: "value", type: "uint256" }
    ],
    name: "Transfer",
    type: "event"
  }
];
const solvbtcAbi = [
  { inputs: [], stateMutability: "nonpayable", type: "constructor" },
  {
    inputs: [
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "uint256", name: "allowance", type: "uint256" },
      { internalType: "uint256", name: "needed", type: "uint256" }
    ],
    name: "ERC20InsufficientAllowance",
    type: "error"
  },
  {
    inputs: [
      { internalType: "address", name: "sender", type: "address" },
      { internalType: "uint256", name: "balance", type: "uint256" },
      { internalType: "uint256", name: "needed", type: "uint256" }
    ],
    name: "ERC20InsufficientBalance",
    type: "error"
  },
  {
    inputs: [{ internalType: "address", name: "approver", type: "address" }],
    name: "ERC20InvalidApprover",
    type: "error"
  },
  {
    inputs: [{ internalType: "address", name: "receiver", type: "address" }],
    name: "ERC20InvalidReceiver",
    type: "error"
  },
  {
    inputs: [{ internalType: "address", name: "sender", type: "address" }],
    name: "ERC20InvalidSender",
    type: "error"
  },
  {
    inputs: [{ internalType: "address", name: "spender", type: "address" }],
    name: "ERC20InvalidSpender",
    type: "error"
  },
  { inputs: [], name: "InvalidInitialization", type: "error" },
  { inputs: [], name: "NotInitializing", type: "error" },
  { inputs: [], name: "ReentrancyGuardReentrantCall", type: "error" },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint64",
        name: "version",
        type: "uint64"
      }
    ],
    name: "Initialized",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "from", type: "address" },
      { indexed: true, internalType: "address", name: "to", type: "address" },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    inputs: [
      { internalType: "address", name: "owner", type: "address" },
      { internalType: "address", name: "spender", type: "address" }
    ],
    name: "allowance",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "uint256", name: "value", type: "uint256" }
    ],
    name: "approve",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "account", type: "address" }],
    name: "balanceOf",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint256", name: "amount_", type: "uint256" },
      { internalType: "uint256", name: "sftId_", type: "uint256" }
    ],
    name: "burn",
    outputs: [{ internalType: "uint256", name: "toSftId_", type: "uint256" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint256", name: "value", type: "uint256" }],
    name: "getSharesByValue",
    outputs: [{ internalType: "uint256", name: "shares", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint256", name: "shares", type: "uint256" }],
    name: "getValueByShares",
    outputs: [{ internalType: "uint256", name: "value", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "holdingValueSftId",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "string", name: "name_", type: "string" },
      { internalType: "string", name: "symbol_", type: "string" },
      { internalType: "address", name: "wrappedSftAddress_", type: "address" },
      { internalType: "uint256", name: "wrappedSftSlot_", type: "uint256" },
      { internalType: "address", name: "navOracle_", type: "address" }
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint256", name: "amount_", type: "uint256" }],
    name: "layer1Burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint256", name: "amount_", type: "uint256" }],
    name: "layer1Mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "layer1MintTarget",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [],
    name: "layer1Minter",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint256", name: "sftId_", type: "uint256" },
      { internalType: "uint256", name: "amount_", type: "uint256" }
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "name",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "navOracle",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "", type: "address" },
      { internalType: "uint256", name: "fromSftId_", type: "uint256" },
      { internalType: "uint256", name: "sftId_", type: "uint256" },
      { internalType: "uint256", name: "value_", type: "uint256" },
      { internalType: "bytes", name: "", type: "bytes" }
    ],
    name: "onERC3525Received",
    outputs: [{ internalType: "bytes4", name: "", type: "bytes4" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "", type: "address" },
      { internalType: "address", name: "from_", type: "address" },
      { internalType: "uint256", name: "sftId_", type: "uint256" },
      { internalType: "bytes", name: "", type: "bytes" }
    ],
    name: "onERC721Received",
    outputs: [{ internalType: "bytes4", name: "", type: "bytes4" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "bytes4", name: "interfaceId", type: "bytes4" }],
    name: "supportsInterface",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "value", type: "uint256" }
    ],
    name: "transfer",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "from", type: "address" },
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "value", type: "uint256" }
    ],
    name: "transferFrom",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "underlyingAsset",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "wrappedSftAddress",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "wrappedSftSlot",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  }
];
const xsolvbtcAbi = [
  { inputs: [], stateMutability: "nonpayable", type: "constructor" },
  {
    inputs: [
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "uint256", name: "allowance", type: "uint256" },
      { internalType: "uint256", name: "needed", type: "uint256" }
    ],
    name: "ERC20InsufficientAllowance",
    type: "error"
  },
  {
    inputs: [
      { internalType: "address", name: "sender", type: "address" },
      { internalType: "uint256", name: "balance", type: "uint256" },
      { internalType: "uint256", name: "needed", type: "uint256" }
    ],
    name: "ERC20InsufficientBalance",
    type: "error"
  },
  {
    inputs: [{ internalType: "address", name: "approver", type: "address" }],
    name: "ERC20InvalidApprover",
    type: "error"
  },
  {
    inputs: [{ internalType: "address", name: "receiver", type: "address" }],
    name: "ERC20InvalidReceiver",
    type: "error"
  },
  {
    inputs: [{ internalType: "address", name: "sender", type: "address" }],
    name: "ERC20InvalidSender",
    type: "error"
  },
  {
    inputs: [{ internalType: "address", name: "spender", type: "address" }],
    name: "ERC20InvalidSpender",
    type: "error"
  },
  { inputs: [], name: "InvalidInitialization", type: "error" },
  { inputs: [], name: "NotInitializing", type: "error" },
  { inputs: [], name: "ReentrancyGuardReentrantCall", type: "error" },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint64",
        name: "version",
        type: "uint64"
      }
    ],
    name: "Initialized",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "from", type: "address" },
      { indexed: true, internalType: "address", name: "to", type: "address" },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    inputs: [
      { internalType: "address", name: "owner", type: "address" },
      { internalType: "address", name: "spender", type: "address" }
    ],
    name: "allowance",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "uint256", name: "value", type: "uint256" }
    ],
    name: "approve",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "account", type: "address" }],
    name: "balanceOf",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint256", name: "amount_", type: "uint256" },
      { internalType: "uint256", name: "sftId_", type: "uint256" }
    ],
    name: "burn",
    outputs: [{ internalType: "uint256", name: "toSftId_", type: "uint256" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint256", name: "value", type: "uint256" }],
    name: "getSharesByValue",
    outputs: [{ internalType: "uint256", name: "shares", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint256", name: "shares", type: "uint256" }],
    name: "getValueByShares",
    outputs: [{ internalType: "uint256", name: "value", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "holdingValueSftId",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "string", name: "name_", type: "string" },
      { internalType: "string", name: "symbol_", type: "string" },
      { internalType: "address", name: "wrappedSftAddress_", type: "address" },
      { internalType: "uint256", name: "wrappedSftSlot_", type: "uint256" },
      { internalType: "address", name: "navOracle_", type: "address" }
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint256", name: "amount_", type: "uint256" }],
    name: "layer1Burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint256", name: "amount_", type: "uint256" }],
    name: "layer1Mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "layer1MintTarget",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [],
    name: "layer1Minter",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint256", name: "sftId_", type: "uint256" },
      { internalType: "uint256", name: "amount_", type: "uint256" }
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "name",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "navOracle",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "", type: "address" },
      { internalType: "uint256", name: "fromSftId_", type: "uint256" },
      { internalType: "uint256", name: "sftId_", type: "uint256" },
      { internalType: "uint256", name: "value_", type: "uint256" },
      { internalType: "bytes", name: "", type: "bytes" }
    ],
    name: "onERC3525Received",
    outputs: [{ internalType: "bytes4", name: "", type: "bytes4" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "", type: "address" },
      { internalType: "address", name: "from_", type: "address" },
      { internalType: "uint256", name: "sftId_", type: "uint256" },
      { internalType: "bytes", name: "", type: "bytes" }
    ],
    name: "onERC721Received",
    outputs: [{ internalType: "bytes4", name: "", type: "bytes4" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "bytes4", name: "interfaceId", type: "bytes4" }],
    name: "supportsInterface",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "value", type: "uint256" }
    ],
    name: "transfer",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "from", type: "address" },
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "value", type: "uint256" }
    ],
    name: "transferFrom",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "underlyingAsset",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "wrappedSftAddress",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "wrappedSftSlot",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  }
];
const crvStbtcAbi = [
  {
    name: "Transfer",
    inputs: [
      { name: "sender", type: "address", indexed: true },
      { name: "receiver", type: "address", indexed: true },
      { name: "value", type: "uint256", indexed: false }
    ],
    anonymous: false,
    type: "event"
  },
  {
    name: "Approval",
    inputs: [
      { name: "owner", type: "address", indexed: true },
      { name: "spender", type: "address", indexed: true },
      { name: "value", type: "uint256", indexed: false }
    ],
    anonymous: false,
    type: "event"
  },
  {
    name: "TokenExchange",
    inputs: [
      { name: "buyer", type: "address", indexed: true },
      { name: "sold_id", type: "int128", indexed: false },
      { name: "tokens_sold", type: "uint256", indexed: false },
      { name: "bought_id", type: "int128", indexed: false },
      { name: "tokens_bought", type: "uint256", indexed: false }
    ],
    anonymous: false,
    type: "event"
  },
  {
    name: "TokenExchangeUnderlying",
    inputs: [
      { name: "buyer", type: "address", indexed: true },
      { name: "sold_id", type: "int128", indexed: false },
      { name: "tokens_sold", type: "uint256", indexed: false },
      { name: "bought_id", type: "int128", indexed: false },
      { name: "tokens_bought", type: "uint256", indexed: false }
    ],
    anonymous: false,
    type: "event"
  },
  {
    name: "AddLiquidity",
    inputs: [
      { name: "provider", type: "address", indexed: true },
      { name: "token_amounts", type: "uint256[]", indexed: false },
      { name: "fees", type: "uint256[]", indexed: false },
      { name: "invariant", type: "uint256", indexed: false },
      { name: "token_supply", type: "uint256", indexed: false }
    ],
    anonymous: false,
    type: "event"
  },
  {
    name: "RemoveLiquidity",
    inputs: [
      { name: "provider", type: "address", indexed: true },
      { name: "token_amounts", type: "uint256[]", indexed: false },
      { name: "fees", type: "uint256[]", indexed: false },
      { name: "token_supply", type: "uint256", indexed: false }
    ],
    anonymous: false,
    type: "event"
  },
  {
    name: "RemoveLiquidityOne",
    inputs: [
      { name: "provider", type: "address", indexed: true },
      { name: "token_id", type: "int128", indexed: false },
      { name: "token_amount", type: "uint256", indexed: false },
      { name: "coin_amount", type: "uint256", indexed: false },
      { name: "token_supply", type: "uint256", indexed: false }
    ],
    anonymous: false,
    type: "event"
  },
  {
    name: "RemoveLiquidityImbalance",
    inputs: [
      { name: "provider", type: "address", indexed: true },
      { name: "token_amounts", type: "uint256[]", indexed: false },
      { name: "fees", type: "uint256[]", indexed: false },
      { name: "invariant", type: "uint256", indexed: false },
      { name: "token_supply", type: "uint256", indexed: false }
    ],
    anonymous: false,
    type: "event"
  },
  {
    name: "RampA",
    inputs: [
      { name: "old_A", type: "uint256", indexed: false },
      { name: "new_A", type: "uint256", indexed: false },
      { name: "initial_time", type: "uint256", indexed: false },
      { name: "future_time", type: "uint256", indexed: false }
    ],
    anonymous: false,
    type: "event"
  },
  {
    name: "StopRampA",
    inputs: [
      { name: "A", type: "uint256", indexed: false },
      { name: "t", type: "uint256", indexed: false }
    ],
    anonymous: false,
    type: "event"
  },
  {
    name: "ApplyNewFee",
    inputs: [
      { name: "fee", type: "uint256", indexed: false },
      { name: "offpeg_fee_multiplier", type: "uint256", indexed: false }
    ],
    anonymous: false,
    type: "event"
  },
  {
    name: "SetNewMATime",
    inputs: [
      { name: "ma_exp_time", type: "uint256", indexed: false },
      { name: "D_ma_time", type: "uint256", indexed: false }
    ],
    anonymous: false,
    type: "event"
  },
  {
    stateMutability: "nonpayable",
    type: "constructor",
    inputs: [
      { name: "_name", type: "string" },
      { name: "_symbol", type: "string" },
      { name: "_A", type: "uint256" },
      { name: "_fee", type: "uint256" },
      { name: "_offpeg_fee_multiplier", type: "uint256" },
      { name: "_ma_exp_time", type: "uint256" },
      { name: "_coins", type: "address[]" },
      { name: "_rate_multipliers", type: "uint256[]" },
      { name: "_asset_types", type: "uint8[]" },
      { name: "_method_ids", type: "bytes4[]" },
      { name: "_oracles", type: "address[]" }
    ],
    outputs: []
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "exchange",
    inputs: [
      { name: "i", type: "int128" },
      { name: "j", type: "int128" },
      { name: "_dx", type: "uint256" },
      { name: "_min_dy", type: "uint256" }
    ],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "exchange",
    inputs: [
      { name: "i", type: "int128" },
      { name: "j", type: "int128" },
      { name: "_dx", type: "uint256" },
      { name: "_min_dy", type: "uint256" },
      { name: "_receiver", type: "address" }
    ],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "exchange_received",
    inputs: [
      { name: "i", type: "int128" },
      { name: "j", type: "int128" },
      { name: "_dx", type: "uint256" },
      { name: "_min_dy", type: "uint256" }
    ],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "exchange_received",
    inputs: [
      { name: "i", type: "int128" },
      { name: "j", type: "int128" },
      { name: "_dx", type: "uint256" },
      { name: "_min_dy", type: "uint256" },
      { name: "_receiver", type: "address" }
    ],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "add_liquidity",
    inputs: [
      { name: "_amounts", type: "uint256[]" },
      { name: "_min_mint_amount", type: "uint256" }
    ],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "add_liquidity",
    inputs: [
      { name: "_amounts", type: "uint256[]" },
      { name: "_min_mint_amount", type: "uint256" },
      { name: "_receiver", type: "address" }
    ],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "remove_liquidity_one_coin",
    inputs: [
      { name: "_burn_amount", type: "uint256" },
      { name: "i", type: "int128" },
      { name: "_min_received", type: "uint256" }
    ],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "remove_liquidity_one_coin",
    inputs: [
      { name: "_burn_amount", type: "uint256" },
      { name: "i", type: "int128" },
      { name: "_min_received", type: "uint256" },
      { name: "_receiver", type: "address" }
    ],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "remove_liquidity_imbalance",
    inputs: [
      { name: "_amounts", type: "uint256[]" },
      { name: "_max_burn_amount", type: "uint256" }
    ],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "remove_liquidity_imbalance",
    inputs: [
      { name: "_amounts", type: "uint256[]" },
      { name: "_max_burn_amount", type: "uint256" },
      { name: "_receiver", type: "address" }
    ],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "remove_liquidity",
    inputs: [
      { name: "_burn_amount", type: "uint256" },
      { name: "_min_amounts", type: "uint256[]" }
    ],
    outputs: [{ name: "", type: "uint256[]" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "remove_liquidity",
    inputs: [
      { name: "_burn_amount", type: "uint256" },
      { name: "_min_amounts", type: "uint256[]" },
      { name: "_receiver", type: "address" }
    ],
    outputs: [{ name: "", type: "uint256[]" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "remove_liquidity",
    inputs: [
      { name: "_burn_amount", type: "uint256" },
      { name: "_min_amounts", type: "uint256[]" },
      { name: "_receiver", type: "address" },
      { name: "_claim_admin_fees", type: "bool" }
    ],
    outputs: [{ name: "", type: "uint256[]" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "withdraw_admin_fees",
    inputs: [],
    outputs: []
  },
  {
    stateMutability: "view",
    type: "function",
    name: "last_price",
    inputs: [{ name: "i", type: "uint256" }],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "ema_price",
    inputs: [{ name: "i", type: "uint256" }],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "get_p",
    inputs: [{ name: "i", type: "uint256" }],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "price_oracle",
    inputs: [{ name: "i", type: "uint256" }],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "D_oracle",
    inputs: [],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "transfer",
    inputs: [
      { name: "_to", type: "address" },
      { name: "_value", type: "uint256" }
    ],
    outputs: [{ name: "", type: "bool" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "transferFrom",
    inputs: [
      { name: "_from", type: "address" },
      { name: "_to", type: "address" },
      { name: "_value", type: "uint256" }
    ],
    outputs: [{ name: "", type: "bool" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "approve",
    inputs: [
      { name: "_spender", type: "address" },
      { name: "_value", type: "uint256" }
    ],
    outputs: [{ name: "", type: "bool" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "permit",
    inputs: [
      { name: "_owner", type: "address" },
      { name: "_spender", type: "address" },
      { name: "_value", type: "uint256" },
      { name: "_deadline", type: "uint256" },
      { name: "_v", type: "uint8" },
      { name: "_r", type: "bytes32" },
      { name: "_s", type: "bytes32" }
    ],
    outputs: [{ name: "", type: "bool" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "DOMAIN_SEPARATOR",
    inputs: [],
    outputs: [{ name: "", type: "bytes32" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "get_dx",
    inputs: [
      { name: "i", type: "int128" },
      { name: "j", type: "int128" },
      { name: "dy", type: "uint256" }
    ],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "get_dy",
    inputs: [
      { name: "i", type: "int128" },
      { name: "j", type: "int128" },
      { name: "dx", type: "uint256" }
    ],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "calc_withdraw_one_coin",
    inputs: [
      { name: "_burn_amount", type: "uint256" },
      { name: "i", type: "int128" }
    ],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "totalSupply",
    inputs: [],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "get_virtual_price",
    inputs: [],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "calc_token_amount",
    inputs: [
      { name: "_amounts", type: "uint256[]" },
      { name: "_is_deposit", type: "bool" }
    ],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "A",
    inputs: [],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "A_precise",
    inputs: [],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "balances",
    inputs: [{ name: "i", type: "uint256" }],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "get_balances",
    inputs: [],
    outputs: [{ name: "", type: "uint256[]" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "stored_rates",
    inputs: [],
    outputs: [{ name: "", type: "uint256[]" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "dynamic_fee",
    inputs: [
      { name: "i", type: "int128" },
      { name: "j", type: "int128" }
    ],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "ramp_A",
    inputs: [
      { name: "_future_A", type: "uint256" },
      { name: "_future_time", type: "uint256" }
    ],
    outputs: []
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "stop_ramp_A",
    inputs: [],
    outputs: []
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "set_new_fee",
    inputs: [
      { name: "_new_fee", type: "uint256" },
      { name: "_new_offpeg_fee_multiplier", type: "uint256" }
    ],
    outputs: []
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "set_ma_exp_time",
    inputs: [
      { name: "_ma_exp_time", type: "uint256" },
      { name: "_D_ma_time", type: "uint256" }
    ],
    outputs: []
  },
  {
    stateMutability: "view",
    type: "function",
    name: "N_COINS",
    inputs: [],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "coins",
    inputs: [{ name: "arg0", type: "uint256" }],
    outputs: [{ name: "", type: "address" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "fee",
    inputs: [],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "offpeg_fee_multiplier",
    inputs: [],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "admin_fee",
    inputs: [],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "initial_A",
    inputs: [],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "future_A",
    inputs: [],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "initial_A_time",
    inputs: [],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "future_A_time",
    inputs: [],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "admin_balances",
    inputs: [{ name: "arg0", type: "uint256" }],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "ma_exp_time",
    inputs: [],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "D_ma_time",
    inputs: [],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "ma_last_time",
    inputs: [],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "name",
    inputs: [],
    outputs: [{ name: "", type: "string" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "symbol",
    inputs: [],
    outputs: [{ name: "", type: "string" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "decimals",
    inputs: [],
    outputs: [{ name: "", type: "uint8" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "version",
    inputs: [],
    outputs: [{ name: "", type: "string" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "balanceOf",
    inputs: [{ name: "arg0", type: "address" }],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "allowance",
    inputs: [
      { name: "arg0", type: "address" },
      { name: "arg1", type: "address" }
    ],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "nonces",
    inputs: [{ name: "arg0", type: "address" }],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "salt",
    inputs: [],
    outputs: [{ name: "", type: "bytes32" }]
  }
];
const swBtcAbi = [
  {
    name: "Deposit",
    inputs: [
      { name: "sender", type: "address", indexed: true },
      { name: "owner", type: "address", indexed: true },
      { name: "assets", type: "uint256", indexed: false },
      { name: "shares", type: "uint256", indexed: false }
    ],
    anonymous: false,
    type: "event"
  },
  {
    name: "Withdraw",
    inputs: [
      { name: "sender", type: "address", indexed: true },
      { name: "receiver", type: "address", indexed: true },
      { name: "owner", type: "address", indexed: true },
      { name: "assets", type: "uint256", indexed: false },
      { name: "shares", type: "uint256", indexed: false }
    ],
    anonymous: false,
    type: "event"
  },
  {
    name: "Transfer",
    inputs: [
      { name: "sender", type: "address", indexed: true },
      { name: "receiver", type: "address", indexed: true },
      { name: "value", type: "uint256", indexed: false }
    ],
    anonymous: false,
    type: "event"
  },
  {
    name: "Approval",
    inputs: [
      { name: "owner", type: "address", indexed: true },
      { name: "spender", type: "address", indexed: true },
      { name: "value", type: "uint256", indexed: false }
    ],
    anonymous: false,
    type: "event"
  },
  {
    name: "StrategyChanged",
    inputs: [
      { name: "strategy", type: "address", indexed: true },
      { name: "change_type", type: "uint256", indexed: true }
    ],
    anonymous: false,
    type: "event"
  },
  {
    name: "StrategyReported",
    inputs: [
      { name: "strategy", type: "address", indexed: true },
      { name: "gain", type: "uint256", indexed: false },
      { name: "loss", type: "uint256", indexed: false },
      { name: "current_debt", type: "uint256", indexed: false },
      { name: "protocol_fees", type: "uint256", indexed: false },
      { name: "total_fees", type: "uint256", indexed: false },
      { name: "total_refunds", type: "uint256", indexed: false }
    ],
    anonymous: false,
    type: "event"
  },
  {
    name: "DebtUpdated",
    inputs: [
      { name: "strategy", type: "address", indexed: true },
      { name: "current_debt", type: "uint256", indexed: false },
      { name: "new_debt", type: "uint256", indexed: false }
    ],
    anonymous: false,
    type: "event"
  },
  {
    name: "RoleSet",
    inputs: [
      { name: "account", type: "address", indexed: true },
      { name: "role", type: "uint256", indexed: true }
    ],
    anonymous: false,
    type: "event"
  },
  {
    name: "UpdateRoleManager",
    inputs: [{ name: "role_manager", type: "address", indexed: true }],
    anonymous: false,
    type: "event"
  },
  {
    name: "UpdateAccountant",
    inputs: [{ name: "accountant", type: "address", indexed: true }],
    anonymous: false,
    type: "event"
  },
  {
    name: "UpdateDepositLimitModule",
    inputs: [{ name: "deposit_limit_module", type: "address", indexed: true }],
    anonymous: false,
    type: "event"
  },
  {
    name: "UpdateWithdrawLimitModule",
    inputs: [{ name: "withdraw_limit_module", type: "address", indexed: true }],
    anonymous: false,
    type: "event"
  },
  {
    name: "UpdateDefaultQueue",
    inputs: [{ name: "new_default_queue", type: "address[]", indexed: false }],
    anonymous: false,
    type: "event"
  },
  {
    name: "UpdateUseDefaultQueue",
    inputs: [{ name: "use_default_queue", type: "bool", indexed: false }],
    anonymous: false,
    type: "event"
  },
  {
    name: "UpdatedMaxDebtForStrategy",
    inputs: [
      { name: "sender", type: "address", indexed: true },
      { name: "strategy", type: "address", indexed: true },
      { name: "new_debt", type: "uint256", indexed: false }
    ],
    anonymous: false,
    type: "event"
  },
  {
    name: "UpdateDepositLimit",
    inputs: [{ name: "deposit_limit", type: "uint256", indexed: false }],
    anonymous: false,
    type: "event"
  },
  {
    name: "UpdateMinimumTotalIdle",
    inputs: [{ name: "minimum_total_idle", type: "uint256", indexed: false }],
    anonymous: false,
    type: "event"
  },
  {
    name: "UpdateProfitMaxUnlockTime",
    inputs: [
      { name: "profit_max_unlock_time", type: "uint256", indexed: false }
    ],
    anonymous: false,
    type: "event"
  },
  {
    name: "DebtPurchased",
    inputs: [
      { name: "strategy", type: "address", indexed: true },
      { name: "amount", type: "uint256", indexed: false }
    ],
    anonymous: false,
    type: "event"
  },
  { name: "Shutdown", inputs: [], anonymous: false, type: "event" },
  {
    stateMutability: "nonpayable",
    type: "constructor",
    inputs: [],
    outputs: []
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "initialize",
    inputs: [
      { name: "asset", type: "address" },
      { name: "name", type: "string" },
      { name: "symbol", type: "string" },
      { name: "role_manager", type: "address" },
      { name: "profit_max_unlock_time", type: "uint256" }
    ],
    outputs: []
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "set_accountant",
    inputs: [{ name: "new_accountant", type: "address" }],
    outputs: []
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "set_default_queue",
    inputs: [{ name: "new_default_queue", type: "address[]" }],
    outputs: []
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "set_use_default_queue",
    inputs: [{ name: "use_default_queue", type: "bool" }],
    outputs: []
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "set_deposit_limit",
    inputs: [{ name: "deposit_limit", type: "uint256" }],
    outputs: []
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "set_deposit_limit",
    inputs: [
      { name: "deposit_limit", type: "uint256" },
      { name: "override", type: "bool" }
    ],
    outputs: []
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "set_deposit_limit_module",
    inputs: [{ name: "deposit_limit_module", type: "address" }],
    outputs: []
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "set_deposit_limit_module",
    inputs: [
      { name: "deposit_limit_module", type: "address" },
      { name: "override", type: "bool" }
    ],
    outputs: []
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "set_withdraw_limit_module",
    inputs: [{ name: "withdraw_limit_module", type: "address" }],
    outputs: []
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "set_minimum_total_idle",
    inputs: [{ name: "minimum_total_idle", type: "uint256" }],
    outputs: []
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "setProfitMaxUnlockTime",
    inputs: [{ name: "new_profit_max_unlock_time", type: "uint256" }],
    outputs: []
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "set_role",
    inputs: [
      { name: "account", type: "address" },
      { name: "role", type: "uint256" }
    ],
    outputs: []
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "add_role",
    inputs: [
      { name: "account", type: "address" },
      { name: "role", type: "uint256" }
    ],
    outputs: []
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "remove_role",
    inputs: [
      { name: "account", type: "address" },
      { name: "role", type: "uint256" }
    ],
    outputs: []
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "transfer_role_manager",
    inputs: [{ name: "role_manager", type: "address" }],
    outputs: []
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "accept_role_manager",
    inputs: [],
    outputs: []
  },
  {
    stateMutability: "view",
    type: "function",
    name: "isShutdown",
    inputs: [],
    outputs: [{ name: "", type: "bool" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "unlockedShares",
    inputs: [],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "pricePerShare",
    inputs: [],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "get_default_queue",
    inputs: [],
    outputs: [{ name: "", type: "address[]" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "process_report",
    inputs: [{ name: "strategy", type: "address" }],
    outputs: [
      { name: "", type: "uint256" },
      { name: "", type: "uint256" }
    ]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "buy_debt",
    inputs: [
      { name: "strategy", type: "address" },
      { name: "amount", type: "uint256" }
    ],
    outputs: []
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "add_strategy",
    inputs: [{ name: "new_strategy", type: "address" }],
    outputs: []
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "add_strategy",
    inputs: [
      { name: "new_strategy", type: "address" },
      { name: "add_to_queue", type: "bool" }
    ],
    outputs: []
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "revoke_strategy",
    inputs: [{ name: "strategy", type: "address" }],
    outputs: []
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "force_revoke_strategy",
    inputs: [{ name: "strategy", type: "address" }],
    outputs: []
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "update_max_debt_for_strategy",
    inputs: [
      { name: "strategy", type: "address" },
      { name: "new_max_debt", type: "uint256" }
    ],
    outputs: []
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "update_debt",
    inputs: [
      { name: "strategy", type: "address" },
      { name: "target_debt", type: "uint256" }
    ],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "update_debt",
    inputs: [
      { name: "strategy", type: "address" },
      { name: "target_debt", type: "uint256" },
      { name: "max_loss", type: "uint256" }
    ],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "shutdown_vault",
    inputs: [],
    outputs: []
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "deposit",
    inputs: [
      { name: "assets", type: "uint256" },
      { name: "receiver", type: "address" }
    ],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "mint",
    inputs: [
      { name: "shares", type: "uint256" },
      { name: "receiver", type: "address" }
    ],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "withdraw",
    inputs: [
      { name: "assets", type: "uint256" },
      { name: "receiver", type: "address" },
      { name: "owner", type: "address" }
    ],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "withdraw",
    inputs: [
      { name: "assets", type: "uint256" },
      { name: "receiver", type: "address" },
      { name: "owner", type: "address" },
      { name: "max_loss", type: "uint256" }
    ],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "withdraw",
    inputs: [
      { name: "assets", type: "uint256" },
      { name: "receiver", type: "address" },
      { name: "owner", type: "address" },
      { name: "max_loss", type: "uint256" },
      { name: "strategies", type: "address[]" }
    ],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "redeem",
    inputs: [
      { name: "shares", type: "uint256" },
      { name: "receiver", type: "address" },
      { name: "owner", type: "address" }
    ],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "redeem",
    inputs: [
      { name: "shares", type: "uint256" },
      { name: "receiver", type: "address" },
      { name: "owner", type: "address" },
      { name: "max_loss", type: "uint256" }
    ],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "redeem",
    inputs: [
      { name: "shares", type: "uint256" },
      { name: "receiver", type: "address" },
      { name: "owner", type: "address" },
      { name: "max_loss", type: "uint256" },
      { name: "strategies", type: "address[]" }
    ],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "approve",
    inputs: [
      { name: "spender", type: "address" },
      { name: "amount", type: "uint256" }
    ],
    outputs: [{ name: "", type: "bool" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "transfer",
    inputs: [
      { name: "receiver", type: "address" },
      { name: "amount", type: "uint256" }
    ],
    outputs: [{ name: "", type: "bool" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "transferFrom",
    inputs: [
      { name: "sender", type: "address" },
      { name: "receiver", type: "address" },
      { name: "amount", type: "uint256" }
    ],
    outputs: [{ name: "", type: "bool" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    name: "permit",
    inputs: [
      { name: "owner", type: "address" },
      { name: "spender", type: "address" },
      { name: "amount", type: "uint256" },
      { name: "deadline", type: "uint256" },
      { name: "v", type: "uint8" },
      { name: "r", type: "bytes32" },
      { name: "s", type: "bytes32" }
    ],
    outputs: [{ name: "", type: "bool" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "balanceOf",
    inputs: [{ name: "addr", type: "address" }],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "totalSupply",
    inputs: [],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "totalAssets",
    inputs: [],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "totalIdle",
    inputs: [],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "totalDebt",
    inputs: [],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "convertToShares",
    inputs: [{ name: "assets", type: "uint256" }],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "previewDeposit",
    inputs: [{ name: "assets", type: "uint256" }],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "previewMint",
    inputs: [{ name: "shares", type: "uint256" }],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "convertToAssets",
    inputs: [{ name: "shares", type: "uint256" }],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "maxDeposit",
    inputs: [{ name: "receiver", type: "address" }],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "maxMint",
    inputs: [{ name: "receiver", type: "address" }],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "maxWithdraw",
    inputs: [{ name: "owner", type: "address" }],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "maxWithdraw",
    inputs: [
      { name: "owner", type: "address" },
      { name: "max_loss", type: "uint256" }
    ],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "maxWithdraw",
    inputs: [
      { name: "owner", type: "address" },
      { name: "max_loss", type: "uint256" },
      { name: "strategies", type: "address[]" }
    ],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "maxRedeem",
    inputs: [{ name: "owner", type: "address" }],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "maxRedeem",
    inputs: [
      { name: "owner", type: "address" },
      { name: "max_loss", type: "uint256" }
    ],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "maxRedeem",
    inputs: [
      { name: "owner", type: "address" },
      { name: "max_loss", type: "uint256" },
      { name: "strategies", type: "address[]" }
    ],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "previewWithdraw",
    inputs: [{ name: "assets", type: "uint256" }],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "previewRedeem",
    inputs: [{ name: "shares", type: "uint256" }],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "FACTORY",
    inputs: [],
    outputs: [{ name: "", type: "address" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "apiVersion",
    inputs: [],
    outputs: [{ name: "", type: "string" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "assess_share_of_unrealised_losses",
    inputs: [
      { name: "strategy", type: "address" },
      { name: "assets_needed", type: "uint256" }
    ],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "profitMaxUnlockTime",
    inputs: [],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "fullProfitUnlockDate",
    inputs: [],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "profitUnlockingRate",
    inputs: [],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "lastProfitUpdate",
    inputs: [],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "DOMAIN_SEPARATOR",
    inputs: [],
    outputs: [{ name: "", type: "bytes32" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "asset",
    inputs: [],
    outputs: [{ name: "", type: "address" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "decimals",
    inputs: [],
    outputs: [{ name: "", type: "uint8" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "strategies",
    inputs: [{ name: "arg0", type: "address" }],
    outputs: [
      {
        name: "",
        type: "tuple",
        components: [
          { name: "activation", type: "uint256" },
          { name: "last_report", type: "uint256" },
          { name: "current_debt", type: "uint256" },
          { name: "max_debt", type: "uint256" }
        ]
      }
    ]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "default_queue",
    inputs: [{ name: "arg0", type: "uint256" }],
    outputs: [{ name: "", type: "address" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "use_default_queue",
    inputs: [],
    outputs: [{ name: "", type: "bool" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "allowance",
    inputs: [
      { name: "arg0", type: "address" },
      { name: "arg1", type: "address" }
    ],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "minimum_total_idle",
    inputs: [],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "deposit_limit",
    inputs: [],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "accountant",
    inputs: [],
    outputs: [{ name: "", type: "address" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "deposit_limit_module",
    inputs: [],
    outputs: [{ name: "", type: "address" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "withdraw_limit_module",
    inputs: [],
    outputs: [{ name: "", type: "address" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "roles",
    inputs: [{ name: "arg0", type: "address" }],
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "role_manager",
    inputs: [],
    outputs: [{ name: "", type: "address" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "future_role_manager",
    inputs: [],
    outputs: [{ name: "", type: "address" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "name",
    inputs: [],
    outputs: [{ name: "", type: "string" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "symbol",
    inputs: [],
    outputs: [{ name: "", type: "string" }]
  },
  {
    stateMutability: "view",
    type: "function",
    name: "nonces",
    inputs: [{ name: "arg0", type: "address" }],
    outputs: [{ name: "", type: "uint256" }]
  }
];
const cbBtcAbi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "authorizer",
        type: "address"
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "nonce",
        type: "bytes32"
      }
    ],
    name: "AuthorizationCanceled",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "authorizer",
        type: "address"
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "nonce",
        type: "bytes32"
      }
    ],
    name: "AuthorizationUsed",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_account",
        type: "address"
      }
    ],
    name: "Blacklisted",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "newBlacklister",
        type: "address"
      }
    ],
    name: "BlacklisterChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "burner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "Burn",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "newMasterMinter",
        type: "address"
      }
    ],
    name: "MasterMinterChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "minter",
        type: "address"
      },
      { indexed: true, internalType: "address", name: "to", type: "address" },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "Mint",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "minter",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "minterAllowedAmount",
        type: "uint256"
      }
    ],
    name: "MinterConfigured",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "oldMinter",
        type: "address"
      }
    ],
    name: "MinterRemoved",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  { anonymous: false, inputs: [], name: "Pause", type: "event" },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "newAddress",
        type: "address"
      }
    ],
    name: "PauserChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "newRescuer",
        type: "address"
      }
    ],
    name: "RescuerChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "from", type: "address" },
      { indexed: true, internalType: "address", name: "to", type: "address" },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_account",
        type: "address"
      }
    ],
    name: "UnBlacklisted",
    type: "event"
  },
  { anonymous: false, inputs: [], name: "Unpause", type: "event" },
  {
    inputs: [],
    name: "CANCEL_AUTHORIZATION_TYPEHASH",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "DOMAIN_SEPARATOR",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "PERMIT_TYPEHASH",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "RECEIVE_WITH_AUTHORIZATION_TYPEHASH",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "TRANSFER_WITH_AUTHORIZATION_TYPEHASH",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "owner", type: "address" },
      { internalType: "address", name: "spender", type: "address" }
    ],
    name: "allowance",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "uint256", name: "value", type: "uint256" }
    ],
    name: "approve",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "authorizer", type: "address" },
      { internalType: "bytes32", name: "nonce", type: "bytes32" }
    ],
    name: "authorizationState",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "account", type: "address" }],
    name: "balanceOf",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "_account", type: "address" }],
    name: "blacklist",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "blacklister",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint256", name: "_amount", type: "uint256" }],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "authorizer", type: "address" },
      { internalType: "bytes32", name: "nonce", type: "bytes32" },
      { internalType: "uint8", name: "v", type: "uint8" },
      { internalType: "bytes32", name: "r", type: "bytes32" },
      { internalType: "bytes32", name: "s", type: "bytes32" }
    ],
    name: "cancelAuthorization",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "minter", type: "address" },
      { internalType: "uint256", name: "minterAllowedAmount", type: "uint256" }
    ],
    name: "configureMinter",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "currency",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "uint256", name: "decrement", type: "uint256" }
    ],
    name: "decreaseAllowance",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "uint256", name: "increment", type: "uint256" }
    ],
    name: "increaseAllowance",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "string", name: "tokenName", type: "string" },
      { internalType: "string", name: "tokenSymbol", type: "string" },
      { internalType: "string", name: "tokenCurrency", type: "string" },
      { internalType: "uint8", name: "tokenDecimals", type: "uint8" },
      { internalType: "address", name: "newMasterMinter", type: "address" },
      { internalType: "address", name: "newPauser", type: "address" },
      { internalType: "address", name: "newBlacklister", type: "address" },
      { internalType: "address", name: "newOwner", type: "address" }
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "string", name: "newName", type: "string" }],
    name: "initializeV2",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "lostAndFound", type: "address" }
    ],
    name: "initializeV2_1",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "_account", type: "address" }],
    name: "isBlacklisted",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "account", type: "address" }],
    name: "isMinter",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "masterMinter",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "_to", type: "address" },
      { internalType: "uint256", name: "_amount", type: "uint256" }
    ],
    name: "mint",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "minter", type: "address" }],
    name: "minterAllowance",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "name",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "owner", type: "address" }],
    name: "nonces",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "paused",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pauser",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "owner", type: "address" },
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "uint256", name: "value", type: "uint256" },
      { internalType: "uint256", name: "deadline", type: "uint256" },
      { internalType: "uint8", name: "v", type: "uint8" },
      { internalType: "bytes32", name: "r", type: "bytes32" },
      { internalType: "bytes32", name: "s", type: "bytes32" }
    ],
    name: "permit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "from", type: "address" },
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "value", type: "uint256" },
      { internalType: "uint256", name: "validAfter", type: "uint256" },
      { internalType: "uint256", name: "validBefore", type: "uint256" },
      { internalType: "bytes32", name: "nonce", type: "bytes32" },
      { internalType: "uint8", name: "v", type: "uint8" },
      { internalType: "bytes32", name: "r", type: "bytes32" },
      { internalType: "bytes32", name: "s", type: "bytes32" }
    ],
    name: "receiveWithAuthorization",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "minter", type: "address" }],
    name: "removeMinter",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "tokenContract",
        type: "address"
      },
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "amount", type: "uint256" }
    ],
    name: "rescueERC20",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "rescuer",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "value", type: "uint256" }
    ],
    name: "transfer",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "from", type: "address" },
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "value", type: "uint256" }
    ],
    name: "transferFrom",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "newOwner", type: "address" }],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "from", type: "address" },
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "value", type: "uint256" },
      { internalType: "uint256", name: "validAfter", type: "uint256" },
      { internalType: "uint256", name: "validBefore", type: "uint256" },
      { internalType: "bytes32", name: "nonce", type: "bytes32" },
      { internalType: "uint8", name: "v", type: "uint8" },
      { internalType: "bytes32", name: "r", type: "bytes32" },
      { internalType: "bytes32", name: "s", type: "bytes32" }
    ],
    name: "transferWithAuthorization",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "_account", type: "address" }],
    name: "unBlacklist",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "_newBlacklister", type: "address" }
    ],
    name: "updateBlacklister",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "_newMasterMinter", type: "address" }
    ],
    name: "updateMasterMinter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "_newPauser", type: "address" }],
    name: "updatePauser",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "newRescuer", type: "address" }],
    name: "updateRescuer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "version",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  }
];
const lBtcAbi = [
  { inputs: [], stateMutability: "nonpayable", type: "constructor" },
  {
    inputs: [{ internalType: "uint256", name: "dustLimit", type: "uint256" }],
    name: "AmountBelowDustLimit",
    type: "error"
  },
  {
    inputs: [{ internalType: "uint256", name: "fee", type: "uint256" }],
    name: "AmountLessThanCommission",
    type: "error"
  },
  { inputs: [], name: "AmountTooSmallToPayRelativeFee", type: "error" },
  {
    inputs: [
      { internalType: "uint256", name: "expected", type: "uint256" },
      { internalType: "uint256", name: "received", type: "uint256" }
    ],
    name: "BadChainId",
    type: "error"
  },
  { inputs: [], name: "BadCommission", type: "error" },
  { inputs: [], name: "BadDestination", type: "error" },
  {
    inputs: [
      { internalType: "address", name: "expected", type: "address" },
      { internalType: "address", name: "received", type: "address" }
    ],
    name: "BadToContractAddress",
    type: "error"
  },
  { inputs: [], name: "ECDSAInvalidSignature", type: "error" },
  {
    inputs: [{ internalType: "uint256", name: "length", type: "uint256" }],
    name: "ECDSAInvalidSignatureLength",
    type: "error"
  },
  {
    inputs: [{ internalType: "bytes32", name: "s", type: "bytes32" }],
    name: "ECDSAInvalidSignatureS",
    type: "error"
  },
  {
    inputs: [
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "uint256", name: "allowance", type: "uint256" },
      { internalType: "uint256", name: "needed", type: "uint256" }
    ],
    name: "ERC20InsufficientAllowance",
    type: "error"
  },
  {
    inputs: [
      { internalType: "address", name: "sender", type: "address" },
      { internalType: "uint256", name: "balance", type: "uint256" },
      { internalType: "uint256", name: "needed", type: "uint256" }
    ],
    name: "ERC20InsufficientBalance",
    type: "error"
  },
  {
    inputs: [{ internalType: "address", name: "approver", type: "address" }],
    name: "ERC20InvalidApprover",
    type: "error"
  },
  {
    inputs: [{ internalType: "address", name: "receiver", type: "address" }],
    name: "ERC20InvalidReceiver",
    type: "error"
  },
  {
    inputs: [{ internalType: "address", name: "sender", type: "address" }],
    name: "ERC20InvalidSender",
    type: "error"
  },
  {
    inputs: [{ internalType: "address", name: "spender", type: "address" }],
    name: "ERC20InvalidSpender",
    type: "error"
  },
  { inputs: [], name: "EnforcedPause", type: "error" },
  { inputs: [], name: "ExpectedPause", type: "error" },
  { inputs: [], name: "InvalidDustFeeRate", type: "error" },
  { inputs: [], name: "InvalidInitialization", type: "error" },
  { inputs: [], name: "KnownDestination", type: "error" },
  { inputs: [], name: "MathOverflowedMulDiv", type: "error" },
  { inputs: [], name: "NotInitializing", type: "error" },
  {
    inputs: [{ internalType: "address", name: "owner", type: "address" }],
    name: "OwnableInvalidOwner",
    type: "error"
  },
  {
    inputs: [{ internalType: "address", name: "account", type: "address" }],
    name: "OwnableUnauthorizedAccount",
    type: "error"
  },
  { inputs: [], name: "ProofAlreadyUsed", type: "error" },
  { inputs: [], name: "ReentrancyGuardReentrantCall", type: "error" },
  { inputs: [], name: "ScriptPubkeyUnsupported", type: "error" },
  { inputs: [], name: "SignatureVerificationFailed", type: "error" },
  {
    inputs: [{ internalType: "address", name: "account", type: "address" }],
    name: "UnauthorizedAccount",
    type: "error"
  },
  { inputs: [], name: "UnknownDestination", type: "error" },
  { inputs: [], name: "WithdrawalsDisabled", type: "error" },
  { inputs: [], name: "WrongAddressEncoding", type: "error" },
  { inputs: [], name: "WrongChainIdEncoding", type: "error" },
  { inputs: [], name: "WrongDataLength", type: "error" },
  { inputs: [], name: "WrongDataLength", type: "error" },
  { inputs: [], name: "WrongTxIdEncoding", type: "error" },
  { inputs: [], name: "ZeroAddress", type: "error" },
  { inputs: [], name: "ZeroAddress", type: "error" },
  { inputs: [], name: "ZeroAmount", type: "error" },
  { inputs: [], name: "ZeroAmount", type: "error" },
  { inputs: [], name: "ZeroChainId", type: "error" },
  { inputs: [], name: "ZeroChainId", type: "error" },
  { inputs: [], name: "ZeroContractHash", type: "error" },
  { inputs: [], name: "ZeroTxHash", type: "error" },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "prevVal",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newVal",
        type: "address"
      }
    ],
    name: "BasculeChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "toChain",
        type: "bytes32"
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "toContract",
        type: "bytes32"
      }
    ],
    name: "BridgeDestinationAdded",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "toChain",
        type: "bytes32"
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "toContract",
        type: "bytes32"
      }
    ],
    name: "BridgeDestinationRemoved",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint64",
        name: "prevValue",
        type: "uint64"
      },
      {
        indexed: true,
        internalType: "uint64",
        name: "newValue",
        type: "uint64"
      }
    ],
    name: "BurnCommissionChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "prevVal",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newVal",
        type: "address"
      }
    ],
    name: "ConsortiumChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint64",
        name: "newValue",
        type: "uint64"
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "toChain",
        type: "bytes32"
      }
    ],
    name: "DepositAbsoluteCommissionChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint16",
        name: "newValue",
        type: "uint16"
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "toChain",
        type: "bytes32"
      }
    ],
    name: "DepositRelativeCommissionChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "fromAddress",
        type: "address"
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "toAddress",
        type: "bytes32"
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "toContract",
        type: "bytes32"
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "chainId",
        type: "bytes32"
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "amount",
        type: "uint64"
      }
    ],
    name: "DepositToBridge",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "oldRate",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "newRate",
        type: "uint256"
      }
    ],
    name: "DustFeeRateChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint64",
        name: "version",
        type: "uint64"
      }
    ],
    name: "Initialized",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: "string", name: "name", type: "string" },
      {
        indexed: false,
        internalType: "string",
        name: "symbol",
        type: "string"
      }
    ],
    name: "NameAndSymbolChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "transactionId",
        type: "bytes32"
      },
      { indexed: true, internalType: "uint32", name: "index", type: "uint32" },
      {
        indexed: false,
        internalType: "bytes32",
        name: "proofHash",
        type: "bytes32"
      }
    ],
    name: "OutputProcessed",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferStarted",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "Paused",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousPauser",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newPauser",
        type: "address"
      }
    ],
    name: "PauserRoleTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "from", type: "address" },
      { indexed: true, internalType: "address", name: "to", type: "address" },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "prevValue",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newValue",
        type: "address"
      }
    ],
    name: "TreasuryAddressChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "Unpaused",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "fromAddress",
        type: "address"
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "scriptPubKey",
        type: "bytes"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "UnstakeRequest",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "toAddress",
        type: "address"
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "txHash",
        type: "bytes32"
      },
      {
        indexed: true,
        internalType: "uint32",
        name: "eventIndex",
        type: "uint32"
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "proofHash",
        type: "bytes32"
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "fromContract",
        type: "bytes32"
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "fromChainId",
        type: "bytes32"
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "amount",
        type: "uint64"
      }
    ],
    name: "WithdrawFromBridge",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [{ indexed: false, internalType: "bool", name: "", type: "bool" }],
    name: "WithdrawalsEnabled",
    type: "event"
  },
  {
    inputs: [],
    name: "Bascule",
    outputs: [{ internalType: "contract IBascule", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "MAX_COMMISSION",
    outputs: [{ internalType: "uint16", name: "", type: "uint16" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "acceptOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "bytes32", name: "toChain", type: "bytes32" },
      { internalType: "bytes32", name: "toContract", type: "bytes32" },
      { internalType: "uint16", name: "relCommission", type: "uint16" },
      { internalType: "uint64", name: "absCommission", type: "uint64" }
    ],
    name: "addDestination",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "owner", type: "address" },
      { internalType: "address", name: "spender", type: "address" }
    ],
    name: "allowance",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "uint256", name: "value", type: "uint256" }
    ],
    name: "approve",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "account", type: "address" }],
    name: "balanceOf",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint256", name: "amount", type: "uint256" }],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "bytes", name: "scriptPubkey", type: "bytes" },
      { internalType: "uint256", name: "amount", type: "uint256" }
    ],
    name: "calcUnstakeRequestAmount",
    outputs: [
      { internalType: "uint256", name: "amountAfterFee", type: "uint256" },
      { internalType: "bool", name: "isAboveDust", type: "bool" }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "newVal", type: "address" }],
    name: "changeBascule",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint64", name: "newValue", type: "uint64" }],
    name: "changeBurnCommission",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "newVal", type: "address" }],
    name: "changeConsortium",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint64", name: "newValue", type: "uint64" },
      { internalType: "bytes32", name: "chain", type: "bytes32" }
    ],
    name: "changeDepositAbsoluteCommission",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint16", name: "newValue", type: "uint16" },
      { internalType: "bytes32", name: "chain", type: "bytes32" }
    ],
    name: "changeDepositRelativeCommission",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint256", name: "newRate", type: "uint256" }],
    name: "changeDustFeeRate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "string", name: "name_", type: "string" },
      { internalType: "string", name: "symbol_", type: "string" }
    ],
    name: "changeNameAndSymbol",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "newValue", type: "address" }],
    name: "changeTreasuryAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "consortium",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "bytes32", name: "toChain", type: "bytes32" },
      { internalType: "bytes32", name: "toAddress", type: "bytes32" },
      { internalType: "uint64", name: "amount", type: "uint64" }
    ],
    name: "depositToBridge",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "getBurnCommission",
    outputs: [{ internalType: "uint64", name: "", type: "uint64" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "bytes32", name: "toChain", type: "bytes32" }],
    name: "getDepositAbsoluteCommission",
    outputs: [{ internalType: "uint64", name: "", type: "uint64" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "bytes32", name: "toChain", type: "bytes32" }],
    name: "getDepositRelativeCommission",
    outputs: [{ internalType: "uint16", name: "", type: "uint16" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "bytes32", name: "chainId", type: "bytes32" }],
    name: "getDestination",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getDustFeeRate",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getTreasury",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "consortium_", type: "address" },
      { internalType: "uint64", name: "burnCommission_", type: "uint64" }
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "bytes32", name: "proof", type: "bytes32" }],
    name: "isUsed",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "bytes", name: "data", type: "bytes" },
      { internalType: "bytes", name: "proofSignature", type: "bytes" }
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "name",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "paused",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pauser",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pendingOwner",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "bytes", name: "scriptPubkey", type: "bytes" },
      { internalType: "uint256", name: "amount", type: "uint256" }
    ],
    name: "redeem",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "bytes32", name: "toChain", type: "bytes32" }],
    name: "removeDestination",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "toggleWithdrawals",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "value", type: "uint256" }
    ],
    name: "transfer",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "from", type: "address" },
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "value", type: "uint256" }
    ],
    name: "transferFrom",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "newOwner", type: "address" }],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "newPauser", type: "address" }],
    name: "transferPauserRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "bytes", name: "data", type: "bytes" },
      { internalType: "bytes", name: "proofSignature", type: "bytes" }
    ],
    name: "withdrawFromBridge",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];
const aBtcAbi = [
  {
    inputs: [
      { internalType: "address", name: "_initialOwner", type: "address" },
      { internalType: "uint256", name: "_initialCap", type: "uint256" },
      { internalType: "address[]", name: "_signers", type: "address[]" },
      { internalType: "address", name: "_endpoint", type: "address" },
      { internalType: "uint256", name: "_startChainID", type: "uint256" }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    inputs: [{ internalType: "address", name: "target", type: "address" }],
    name: "AddressEmptyCode",
    type: "error"
  },
  {
    inputs: [{ internalType: "address", name: "account", type: "address" }],
    name: "AddressInsufficientBalance",
    type: "error"
  },
  { inputs: [], name: "ECDSAInvalidSignature", type: "error" },
  {
    inputs: [{ internalType: "uint256", name: "length", type: "uint256" }],
    name: "ECDSAInvalidSignatureLength",
    type: "error"
  },
  {
    inputs: [{ internalType: "bytes32", name: "s", type: "bytes32" }],
    name: "ECDSAInvalidSignatureS",
    type: "error"
  },
  {
    inputs: [
      { internalType: "uint256", name: "increasedSupply", type: "uint256" },
      { internalType: "uint256", name: "cap", type: "uint256" }
    ],
    name: "ERC20ExceededCap",
    type: "error"
  },
  {
    inputs: [
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "uint256", name: "allowance", type: "uint256" },
      { internalType: "uint256", name: "needed", type: "uint256" }
    ],
    name: "ERC20InsufficientAllowance",
    type: "error"
  },
  {
    inputs: [
      { internalType: "address", name: "sender", type: "address" },
      { internalType: "uint256", name: "balance", type: "uint256" },
      { internalType: "uint256", name: "needed", type: "uint256" }
    ],
    name: "ERC20InsufficientBalance",
    type: "error"
  },
  {
    inputs: [{ internalType: "address", name: "approver", type: "address" }],
    name: "ERC20InvalidApprover",
    type: "error"
  },
  {
    inputs: [{ internalType: "uint256", name: "cap", type: "uint256" }],
    name: "ERC20InvalidCap",
    type: "error"
  },
  {
    inputs: [{ internalType: "address", name: "receiver", type: "address" }],
    name: "ERC20InvalidReceiver",
    type: "error"
  },
  {
    inputs: [{ internalType: "address", name: "sender", type: "address" }],
    name: "ERC20InvalidSender",
    type: "error"
  },
  {
    inputs: [{ internalType: "address", name: "spender", type: "address" }],
    name: "ERC20InvalidSpender",
    type: "error"
  },
  {
    inputs: [{ internalType: "uint256", name: "deadline", type: "uint256" }],
    name: "ERC2612ExpiredSignature",
    type: "error"
  },
  {
    inputs: [
      { internalType: "address", name: "signer", type: "address" },
      { internalType: "address", name: "owner", type: "address" }
    ],
    name: "ERC2612InvalidSigner",
    type: "error"
  },
  { inputs: [], name: "EnforcedPause", type: "error" },
  { inputs: [], name: "ExpectedPause", type: "error" },
  { inputs: [], name: "FailedInnerCall", type: "error" },
  {
    inputs: [
      { internalType: "address", name: "account", type: "address" },
      { internalType: "uint256", name: "currentNonce", type: "uint256" }
    ],
    name: "InvalidAccountNonce",
    type: "error"
  },
  { inputs: [], name: "InvalidDelegate", type: "error" },
  { inputs: [], name: "InvalidEndpointCall", type: "error" },
  { inputs: [], name: "InvalidLocalDecimals", type: "error" },
  {
    inputs: [{ internalType: "bytes", name: "options", type: "bytes" }],
    name: "InvalidOptions",
    type: "error"
  },
  { inputs: [], name: "InvalidShortString", type: "error" },
  {
    inputs: [
      { internalType: "uint256", name: "index", type: "uint256" },
      { internalType: "address", name: "signer", type: "address" }
    ],
    name: "InvalidSigner",
    type: "error"
  },
  { inputs: [], name: "IsBlackListed", type: "error" },
  { inputs: [], name: "LzTokenUnavailable", type: "error" },
  {
    inputs: [{ internalType: "uint32", name: "eid", type: "uint32" }],
    name: "NoPeer",
    type: "error"
  },
  {
    inputs: [{ internalType: "uint256", name: "msgValue", type: "uint256" }],
    name: "NotEnoughNative",
    type: "error"
  },
  {
    inputs: [{ internalType: "address", name: "addr", type: "address" }],
    name: "OnlyEndpoint",
    type: "error"
  },
  {
    inputs: [
      { internalType: "uint32", name: "eid", type: "uint32" },
      { internalType: "bytes32", name: "sender", type: "bytes32" }
    ],
    name: "OnlyPeer",
    type: "error"
  },
  { inputs: [], name: "OnlySelf", type: "error" },
  {
    inputs: [{ internalType: "address", name: "owner", type: "address" }],
    name: "OwnableInvalidOwner",
    type: "error"
  },
  {
    inputs: [{ internalType: "address", name: "account", type: "address" }],
    name: "OwnableUnauthorizedAccount",
    type: "error"
  },
  {
    inputs: [{ internalType: "address", name: "token", type: "address" }],
    name: "SafeERC20FailedOperation",
    type: "error"
  },
  {
    inputs: [{ internalType: "bytes", name: "result", type: "bytes" }],
    name: "SimulationResult",
    type: "error"
  },
  {
    inputs: [
      { internalType: "uint256", name: "amountLD", type: "uint256" },
      { internalType: "uint256", name: "minAmountLD", type: "uint256" }
    ],
    name: "SlippageExceeded",
    type: "error"
  },
  {
    inputs: [{ internalType: "string", name: "str", type: "string" }],
    name: "StringTooLong",
    type: "error"
  },
  {
    inputs: [
      { internalType: "uint256", name: "hope", type: "uint256" },
      { internalType: "uint256", name: "have", type: "uint256" }
    ],
    name: "ThresholdError",
    type: "error"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "user",
        type: "address"
      }
    ],
    name: "AddedBlackList",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "user", type: "address" },
      {
        indexed: false,
        internalType: "uint256",
        name: "burnId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "netAmount",
        type: "uint256"
      },
      { indexed: false, internalType: "uint256", name: "fee", type: "uint256" },
      {
        indexed: false,
        internalType: "string",
        name: "btcAddress",
        type: "string"
      }
    ],
    name: "Burn",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "burnId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "string",
        name: "btcAddress",
        type: "string"
      }
    ],
    name: "Declare",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "blackListedUser",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "balance",
        type: "uint256"
      }
    ],
    name: "DestroyedBlackFunds",
    type: "event"
  },
  { anonymous: false, inputs: [], name: "EIP712DomainChanged", type: "event" },
  {
    anonymous: false,
    inputs: [
      {
        components: [
          { internalType: "uint32", name: "eid", type: "uint32" },
          { internalType: "uint16", name: "msgType", type: "uint16" },
          { internalType: "bytes", name: "options", type: "bytes" }
        ],
        indexed: false,
        internalType: "struct EnforcedOptionParam[]",
        name: "_enforcedOptions",
        type: "tuple[]"
      }
    ],
    name: "EnforcedOptionSet",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "oldRecipient",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "newRecipient",
        type: "address"
      }
    ],
    name: "FeeRecipientUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "oldFee",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newFee",
        type: "uint256"
      }
    ],
    name: "FeeUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "user", type: "address" },
      {
        indexed: false,
        internalType: "bytes32",
        name: "txid",
        type: "bytes32"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "index",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Mint",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "inspector",
        type: "address"
      }
    ],
    name: "MsgInspectorSet",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "bytes32", name: "guid", type: "bytes32" },
      {
        indexed: false,
        internalType: "uint32",
        name: "srcEid",
        type: "uint32"
      },
      {
        indexed: true,
        internalType: "address",
        name: "toAddress",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amountReceivedLD",
        type: "uint256"
      }
    ],
    name: "OFTReceived",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "bytes32", name: "guid", type: "bytes32" },
      {
        indexed: false,
        internalType: "uint32",
        name: "dstEid",
        type: "uint32"
      },
      {
        indexed: true,
        internalType: "address",
        name: "fromAddress",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amountSentLD",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amountReceivedLD",
        type: "uint256"
      }
    ],
    name: "OFTSent",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "Paused",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: "uint32", name: "eid", type: "uint32" },
      {
        indexed: false,
        internalType: "bytes32",
        name: "peer",
        type: "bytes32"
      }
    ],
    name: "PeerSet",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "preCrimeAddress",
        type: "address"
      }
    ],
    name: "PreCrimeSet",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "user",
        type: "address"
      }
    ],
    name: "RemovedBlackList",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "signer",
        type: "address"
      },
      { indexed: false, internalType: "bool", name: "enable", type: "bool" }
    ],
    name: "SetSigner",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "oldThreshold",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newThreshold",
        type: "uint256"
      }
    ],
    name: "SetThreshold",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "from", type: "address" },
      { indexed: true, internalType: "address", name: "to", type: "address" },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "Unpaused",
    type: "event"
  },
  {
    inputs: [],
    name: "DOMAIN_SEPARATOR",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "MINT_TYPEHASH",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "MIN_THRESHOLD",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "SEND",
    outputs: [{ internalType: "uint16", name: "", type: "uint16" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "SEND_AND_CALL",
    outputs: [{ internalType: "uint16", name: "", type: "uint16" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "_evilUser", type: "address" }],
    name: "addBlackList",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { internalType: "uint32", name: "srcEid", type: "uint32" },
          { internalType: "bytes32", name: "sender", type: "bytes32" },
          { internalType: "uint64", name: "nonce", type: "uint64" }
        ],
        internalType: "struct Origin",
        name: "origin",
        type: "tuple"
      }
    ],
    name: "allowInitializePath",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "owner", type: "address" },
      { internalType: "address", name: "spender", type: "address" }
    ],
    name: "allowance",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "approvalRequired",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "uint256", name: "value", type: "uint256" }
    ],
    name: "approve",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "account", type: "address" }],
    name: "balanceOf",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint256", name: "amount", type: "uint256" },
      { internalType: "string", name: "btcAddress", type: "string" }
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    name: "burnOwner",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "cap",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint32", name: "_eid", type: "uint32" },
      { internalType: "uint16", name: "_msgType", type: "uint16" },
      { internalType: "bytes", name: "_extraOptions", type: "bytes" }
    ],
    name: "combineOptions",
    outputs: [{ internalType: "bytes", name: "", type: "bytes" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "currentBurnId",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "decimalConversionRate",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint256", name: "burnId", type: "uint256" },
      { internalType: "string", name: "btcAddress", type: "string" }
    ],
    name: "declare",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "_blackListedUser", type: "address" }
    ],
    name: "destroyBlackFunds",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "eip712Domain",
    outputs: [
      { internalType: "bytes1", name: "fields", type: "bytes1" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "string", name: "version", type: "string" },
      { internalType: "uint256", name: "chainId", type: "uint256" },
      { internalType: "address", name: "verifyingContract", type: "address" },
      { internalType: "bytes32", name: "salt", type: "bytes32" },
      { internalType: "uint256[]", name: "extensions", type: "uint256[]" }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "endpoint",
    outputs: [
      {
        internalType: "contract ILayerZeroEndpointV2",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint32", name: "eid", type: "uint32" },
      { internalType: "uint16", name: "msgType", type: "uint16" }
    ],
    name: "enforcedOptions",
    outputs: [{ internalType: "bytes", name: "enforcedOption", type: "bytes" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "fee",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "feeRecipient",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getSigners",
    outputs: [{ internalType: "address[]", name: "", type: "address[]" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "", type: "address" }],
    name: "isBlackListed",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { internalType: "uint32", name: "srcEid", type: "uint32" },
          { internalType: "bytes32", name: "sender", type: "bytes32" },
          { internalType: "uint64", name: "nonce", type: "uint64" }
        ],
        internalType: "struct Origin",
        name: "",
        type: "tuple"
      },
      { internalType: "bytes", name: "", type: "bytes" },
      { internalType: "address", name: "_sender", type: "address" }
    ],
    name: "isComposeMsgSender",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint32", name: "_eid", type: "uint32" },
      { internalType: "bytes32", name: "_peer", type: "bytes32" }
    ],
    name: "isPeer",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { internalType: "uint32", name: "srcEid", type: "uint32" },
          { internalType: "bytes32", name: "sender", type: "bytes32" },
          { internalType: "uint64", name: "nonce", type: "uint64" }
        ],
        internalType: "struct Origin",
        name: "_origin",
        type: "tuple"
      },
      { internalType: "bytes32", name: "_guid", type: "bytes32" },
      { internalType: "bytes", name: "_message", type: "bytes" },
      { internalType: "address", name: "_executor", type: "address" },
      { internalType: "bytes", name: "_extraData", type: "bytes" }
    ],
    name: "lzReceive",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            components: [
              { internalType: "uint32", name: "srcEid", type: "uint32" },
              { internalType: "bytes32", name: "sender", type: "bytes32" },
              { internalType: "uint64", name: "nonce", type: "uint64" }
            ],
            internalType: "struct Origin",
            name: "origin",
            type: "tuple"
          },
          { internalType: "uint32", name: "dstEid", type: "uint32" },
          { internalType: "address", name: "receiver", type: "address" },
          { internalType: "bytes32", name: "guid", type: "bytes32" },
          { internalType: "uint256", name: "value", type: "uint256" },
          { internalType: "address", name: "executor", type: "address" },
          { internalType: "bytes", name: "message", type: "bytes" },
          { internalType: "bytes", name: "extraData", type: "bytes" }
        ],
        internalType: "struct InboundPacket[]",
        name: "_packets",
        type: "tuple[]"
      }
    ],
    name: "lzReceiveAndRevert",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { internalType: "uint32", name: "srcEid", type: "uint32" },
          { internalType: "bytes32", name: "sender", type: "bytes32" },
          { internalType: "uint64", name: "nonce", type: "uint64" }
        ],
        internalType: "struct Origin",
        name: "_origin",
        type: "tuple"
      },
      { internalType: "bytes32", name: "_guid", type: "bytes32" },
      { internalType: "bytes", name: "_message", type: "bytes" },
      { internalType: "address", name: "_executor", type: "address" },
      { internalType: "bytes", name: "_extraData", type: "bytes" }
    ],
    name: "lzReceiveSimulate",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "amount", type: "uint256" },
      { internalType: "bytes32", name: "txid", type: "bytes32" },
      { internalType: "uint256", name: "index", type: "uint256" },
      { internalType: "bytes[]", name: "signatures", type: "bytes[]" }
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "msgInspector",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "name",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint32", name: "", type: "uint32" },
      { internalType: "bytes32", name: "", type: "bytes32" }
    ],
    name: "nextNonce",
    outputs: [{ internalType: "uint64", name: "nonce", type: "uint64" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "owner", type: "address" }],
    name: "nonces",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "oApp",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "oAppVersion",
    outputs: [
      { internalType: "uint64", name: "senderVersion", type: "uint64" },
      { internalType: "uint64", name: "receiverVersion", type: "uint64" }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [],
    name: "oftVersion",
    outputs: [
      { internalType: "bytes4", name: "interfaceId", type: "bytes4" },
      { internalType: "uint64", name: "version", type: "uint64" }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "paused",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint32", name: "eid", type: "uint32" }],
    name: "peers",
    outputs: [{ internalType: "bytes32", name: "peer", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "owner", type: "address" },
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "uint256", name: "value", type: "uint256" },
      { internalType: "uint256", name: "deadline", type: "uint256" },
      { internalType: "uint8", name: "v", type: "uint8" },
      { internalType: "bytes32", name: "r", type: "bytes32" },
      { internalType: "bytes32", name: "s", type: "bytes32" }
    ],
    name: "permit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "preCrime",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { internalType: "uint32", name: "dstEid", type: "uint32" },
          { internalType: "bytes32", name: "to", type: "bytes32" },
          { internalType: "uint256", name: "amountLD", type: "uint256" },
          { internalType: "uint256", name: "minAmountLD", type: "uint256" },
          { internalType: "bytes", name: "extraOptions", type: "bytes" },
          { internalType: "bytes", name: "composeMsg", type: "bytes" },
          { internalType: "bytes", name: "oftCmd", type: "bytes" }
        ],
        internalType: "struct SendParam",
        name: "_sendParam",
        type: "tuple"
      }
    ],
    name: "quoteOFT",
    outputs: [
      {
        components: [
          { internalType: "uint256", name: "minAmountLD", type: "uint256" },
          { internalType: "uint256", name: "maxAmountLD", type: "uint256" }
        ],
        internalType: "struct OFTLimit",
        name: "oftLimit",
        type: "tuple"
      },
      {
        components: [
          { internalType: "int256", name: "feeAmountLD", type: "int256" },
          { internalType: "string", name: "description", type: "string" }
        ],
        internalType: "struct OFTFeeDetail[]",
        name: "oftFeeDetails",
        type: "tuple[]"
      },
      {
        components: [
          { internalType: "uint256", name: "amountSentLD", type: "uint256" },
          {
            internalType: "uint256",
            name: "amountReceivedLD",
            type: "uint256"
          }
        ],
        internalType: "struct OFTReceipt",
        name: "oftReceipt",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { internalType: "uint32", name: "dstEid", type: "uint32" },
          { internalType: "bytes32", name: "to", type: "bytes32" },
          { internalType: "uint256", name: "amountLD", type: "uint256" },
          { internalType: "uint256", name: "minAmountLD", type: "uint256" },
          { internalType: "bytes", name: "extraOptions", type: "bytes" },
          { internalType: "bytes", name: "composeMsg", type: "bytes" },
          { internalType: "bytes", name: "oftCmd", type: "bytes" }
        ],
        internalType: "struct SendParam",
        name: "_sendParam",
        type: "tuple"
      },
      { internalType: "bool", name: "_payInLzToken", type: "bool" }
    ],
    name: "quoteSend",
    outputs: [
      {
        components: [
          { internalType: "uint256", name: "nativeFee", type: "uint256" },
          { internalType: "uint256", name: "lzTokenFee", type: "uint256" }
        ],
        internalType: "struct MessagingFee",
        name: "msgFee",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "_clearedUser", type: "address" }
    ],
    name: "removeBlackList",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { internalType: "uint32", name: "dstEid", type: "uint32" },
          { internalType: "bytes32", name: "to", type: "bytes32" },
          { internalType: "uint256", name: "amountLD", type: "uint256" },
          { internalType: "uint256", name: "minAmountLD", type: "uint256" },
          { internalType: "bytes", name: "extraOptions", type: "bytes" },
          { internalType: "bytes", name: "composeMsg", type: "bytes" },
          { internalType: "bytes", name: "oftCmd", type: "bytes" }
        ],
        internalType: "struct SendParam",
        name: "_sendParam",
        type: "tuple"
      },
      {
        components: [
          { internalType: "uint256", name: "nativeFee", type: "uint256" },
          { internalType: "uint256", name: "lzTokenFee", type: "uint256" }
        ],
        internalType: "struct MessagingFee",
        name: "_fee",
        type: "tuple"
      },
      { internalType: "address", name: "_refundAddress", type: "address" }
    ],
    name: "send",
    outputs: [
      {
        components: [
          { internalType: "bytes32", name: "guid", type: "bytes32" },
          { internalType: "uint64", name: "nonce", type: "uint64" },
          {
            components: [
              { internalType: "uint256", name: "nativeFee", type: "uint256" },
              { internalType: "uint256", name: "lzTokenFee", type: "uint256" }
            ],
            internalType: "struct MessagingFee",
            name: "fee",
            type: "tuple"
          }
        ],
        internalType: "struct MessagingReceipt",
        name: "msgReceipt",
        type: "tuple"
      },
      {
        components: [
          { internalType: "uint256", name: "amountSentLD", type: "uint256" },
          {
            internalType: "uint256",
            name: "amountReceivedLD",
            type: "uint256"
          }
        ],
        internalType: "struct OFTReceipt",
        name: "oftReceipt",
        type: "tuple"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "_delegate", type: "address" }],
    name: "setDelegate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { internalType: "uint32", name: "eid", type: "uint32" },
          { internalType: "uint16", name: "msgType", type: "uint16" },
          { internalType: "bytes", name: "options", type: "bytes" }
        ],
        internalType: "struct EnforcedOptionParam[]",
        name: "_enforcedOptions",
        type: "tuple[]"
      }
    ],
    name: "setEnforcedOptions",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "_msgInspector", type: "address" }
    ],
    name: "setMsgInspector",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "bool", name: "pause_", type: "bool" }],
    name: "setPause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint32", name: "_eid", type: "uint32" },
      { internalType: "bytes32", name: "_peer", type: "bytes32" }
    ],
    name: "setPeer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "_preCrime", type: "address" }],
    name: "setPreCrime",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "signer", type: "address" },
      { internalType: "bool", name: "enable", type: "bool" }
    ],
    name: "setSigner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint256", name: "newThreshold", type: "uint256" }
    ],
    name: "setThreshold",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "sharedDecimals",
    outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [],
    name: "startChain",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "threshold",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "token",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "value", type: "uint256" }
    ],
    name: "transfer",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "from", type: "address" },
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "value", type: "uint256" }
    ],
    name: "transferFrom",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "newOwner", type: "address" }],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "bytes32", name: "", type: "bytes32" },
      { internalType: "uint256", name: "", type: "uint256" }
    ],
    name: "txNullifier",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint256", name: "newFee", type: "uint256" }],
    name: "updateFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "newRecipient", type: "address" }
    ],
    name: "updateFeeRecipient",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "useNonce",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];
const intBtcAbi = [
  { inputs: [], stateMutability: "nonpayable", type: "constructor" },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: "uint8", name: "version", type: "uint8" }
    ],
    name: "Initialized",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "Paused",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "from", type: "address" },
      { indexed: true, internalType: "address", name: "to", type: "address" },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "Unpaused",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "prevValue",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "newValue",
        type: "address"
      }
    ],
    name: "VaultChanged",
    type: "event"
  },
  {
    inputs: [
      { internalType: "address", name: "owner", type: "address" },
      { internalType: "address", name: "spender", type: "address" }
    ],
    name: "allowance",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "uint256", name: "amount", type: "uint256" }
    ],
    name: "approve",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "account", type: "address" }],
    name: "balanceOf",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "account", type: "address" },
      { internalType: "uint256", name: "amount", type: "uint256" }
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "uint256", name: "subtractedValue", type: "uint256" }
    ],
    name: "decreaseAllowance",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "uint256", name: "addedValue", type: "uint256" }
    ],
    name: "increaseAllowance",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "string", name: "name", type: "string" },
      { internalType: "string", name: "symbol", type: "string" }
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "account", type: "address" },
      { internalType: "uint256", name: "amount", type: "uint256" }
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "name",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "paused",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "contract IInceptionVault",
        name: "newValue",
        type: "address"
      }
    ],
    name: "setVault",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "amount", type: "uint256" }
    ],
    name: "transfer",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "from", type: "address" },
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "amount", type: "uint256" }
    ],
    name: "transferFrom",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "newOwner", type: "address" }],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "vault",
    outputs: [
      { internalType: "contract IInceptionVault", name: "", type: "address" }
    ],
    stateMutability: "view",
    type: "function"
  }
];
const wMAbi = [
  {
    inputs: [
      { internalType: "address", name: "mToken_", type: "address" },
      { internalType: "address", name: "migrationAdmin_", type: "address" }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    inputs: [
      { internalType: "address", name: "authorizer", type: "address" },
      { internalType: "bytes32", name: "nonce", type: "bytes32" }
    ],
    name: "AuthorizationAlreadyUsed",
    type: "error"
  },
  {
    inputs: [
      { internalType: "uint256", name: "timestamp", type: "uint256" },
      { internalType: "uint256", name: "validBefore", type: "uint256" }
    ],
    name: "AuthorizationExpired",
    type: "error"
  },
  {
    inputs: [
      { internalType: "uint256", name: "timestamp", type: "uint256" },
      { internalType: "uint256", name: "validAfter", type: "uint256" }
    ],
    name: "AuthorizationNotYetValid",
    type: "error"
  },
  {
    inputs: [
      { internalType: "address", name: "caller", type: "address" },
      { internalType: "address", name: "payee", type: "address" }
    ],
    name: "CallerMustBePayee",
    type: "error"
  },
  { inputs: [], name: "DivisionByZero", type: "error" },
  { inputs: [], name: "EarningCannotBeReenabled", type: "error" },
  { inputs: [], name: "EarningIsDisabled", type: "error" },
  { inputs: [], name: "EarningIsEnabled", type: "error" },
  {
    inputs: [
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "uint256", name: "allowance", type: "uint256" },
      { internalType: "uint256", name: "needed", type: "uint256" }
    ],
    name: "InsufficientAllowance",
    type: "error"
  },
  {
    inputs: [{ internalType: "uint256", name: "amount", type: "uint256" }],
    name: "InsufficientAmount",
    type: "error"
  },
  {
    inputs: [
      { internalType: "address", name: "account", type: "address" },
      { internalType: "uint240", name: "balance", type: "uint240" },
      { internalType: "uint240", name: "amount", type: "uint240" }
    ],
    name: "InsufficientBalance",
    type: "error"
  },
  {
    inputs: [
      { internalType: "uint256", name: "nonce", type: "uint256" },
      { internalType: "uint256", name: "expectedNonce", type: "uint256" }
    ],
    name: "InvalidAccountNonce",
    type: "error"
  },
  { inputs: [], name: "InvalidMigrator", type: "error" },
  {
    inputs: [{ internalType: "address", name: "recipient", type: "address" }],
    name: "InvalidRecipient",
    type: "error"
  },
  { inputs: [], name: "InvalidSignature", type: "error" },
  { inputs: [], name: "InvalidSignatureLength", type: "error" },
  { inputs: [], name: "InvalidSignatureS", type: "error" },
  { inputs: [], name: "InvalidSignatureV", type: "error" },
  { inputs: [], name: "InvalidUInt112", type: "error" },
  { inputs: [], name: "InvalidUInt240", type: "error" },
  { inputs: [], name: "IsApprovedEarner", type: "error" },
  { inputs: [], name: "MigrationFailed", type: "error" },
  { inputs: [], name: "NotApprovedEarner", type: "error" },
  {
    inputs: [
      { internalType: "uint256", name: "deadline", type: "uint256" },
      { internalType: "uint256", name: "timestamp", type: "uint256" }
    ],
    name: "SignatureExpired",
    type: "error"
  },
  { inputs: [], name: "SignerMismatch", type: "error" },
  { inputs: [], name: "UnauthorizedMigration", type: "error" },
  { inputs: [], name: "ZeroMToken", type: "error" },
  { inputs: [], name: "ZeroMigrationAdmin", type: "error" },
  { inputs: [], name: "ZeroMigrator", type: "error" },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "authorizer",
        type: "address"
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "nonce",
        type: "bytes32"
      }
    ],
    name: "AuthorizationCanceled",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "authorizer",
        type: "address"
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "nonce",
        type: "bytes32"
      }
    ],
    name: "AuthorizationUsed",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint240",
        name: "yield",
        type: "uint240"
      }
    ],
    name: "Claimed",
    type: "event"
  },
  { anonymous: false, inputs: [], name: "EIP712DomainChanged", type: "event" },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint128",
        name: "index",
        type: "uint128"
      }
    ],
    name: "EarningDisabled",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint128",
        name: "index",
        type: "uint128"
      }
    ],
    name: "EarningEnabled",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint240",
        name: "excess",
        type: "uint240"
      }
    ],
    name: "ExcessClaimed",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "migrator",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "oldImplementation",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newImplementation",
        type: "address"
      }
    ],
    name: "Migrated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "StartedEarning",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "StoppedEarning",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "implementation",
        type: "address"
      }
    ],
    name: "Upgraded",
    type: "event"
  },
  {
    inputs: [],
    name: "CANCEL_AUTHORIZATION_TYPEHASH",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "DOMAIN_SEPARATOR",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "PERMIT_TYPEHASH",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "RECEIVE_WITH_AUTHORIZATION_TYPEHASH",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "TRANSFER_WITH_AUTHORIZATION_TYPEHASH",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "account_", type: "address" }],
    name: "accruedYieldOf",
    outputs: [{ internalType: "uint240", name: "yield_", type: "uint240" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "account", type: "address" },
      { internalType: "address", name: "spender", type: "address" }
    ],
    name: "allowance",
    outputs: [{ internalType: "uint256", name: "allowance", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "spender_", type: "address" },
      { internalType: "uint256", name: "amount_", type: "uint256" }
    ],
    name: "approve",
    outputs: [{ internalType: "bool", name: "success_", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "authorizer", type: "address" },
      { internalType: "bytes32", name: "nonce", type: "bytes32" }
    ],
    name: "authorizationState",
    outputs: [{ internalType: "bool", name: "isNonceUsed", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "account_", type: "address" }],
    name: "balanceOf",
    outputs: [{ internalType: "uint256", name: "balance_", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "account_", type: "address" }],
    name: "balanceWithYieldOf",
    outputs: [{ internalType: "uint256", name: "balance_", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "authorizer_", type: "address" },
      { internalType: "bytes32", name: "nonce_", type: "bytes32" },
      { internalType: "bytes32", name: "r_", type: "bytes32" },
      { internalType: "bytes32", name: "vs_", type: "bytes32" }
    ],
    name: "cancelAuthorization",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "authorizer_", type: "address" },
      { internalType: "bytes32", name: "nonce_", type: "bytes32" },
      { internalType: "uint8", name: "v_", type: "uint8" },
      { internalType: "bytes32", name: "r_", type: "bytes32" },
      { internalType: "bytes32", name: "s_", type: "bytes32" }
    ],
    name: "cancelAuthorization",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "authorizer_", type: "address" },
      { internalType: "bytes32", name: "nonce_", type: "bytes32" },
      { internalType: "bytes", name: "signature_", type: "bytes" }
    ],
    name: "cancelAuthorization",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "claimExcess",
    outputs: [{ internalType: "uint240", name: "excess_", type: "uint240" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "account_", type: "address" }],
    name: "claimFor",
    outputs: [{ internalType: "uint240", name: "yield_", type: "uint240" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "account_", type: "address" }],
    name: "claimOverrideRecipientFor",
    outputs: [{ internalType: "address", name: "recipient_", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "currentIndex",
    outputs: [{ internalType: "uint128", name: "index_", type: "uint128" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "disableEarning",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "eip712Domain",
    outputs: [
      { internalType: "bytes1", name: "fields_", type: "bytes1" },
      { internalType: "string", name: "name_", type: "string" },
      { internalType: "string", name: "version_", type: "string" },
      { internalType: "uint256", name: "chainId_", type: "uint256" },
      { internalType: "address", name: "verifyingContract_", type: "address" },
      { internalType: "bytes32", name: "salt_", type: "bytes32" },
      { internalType: "uint256[]", name: "extensions_", type: "uint256[]" }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "enableEarning",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "excess",
    outputs: [{ internalType: "uint240", name: "excess_", type: "uint240" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "implementation",
    outputs: [
      { internalType: "address", name: "implementation_", type: "address" }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "account_", type: "address" }],
    name: "isEarning",
    outputs: [{ internalType: "bool", name: "isEarning_", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "isEarningEnabled",
    outputs: [{ internalType: "bool", name: "isEnabled_", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "account_", type: "address" }],
    name: "lastIndexOf",
    outputs: [{ internalType: "uint128", name: "lastIndex_", type: "uint128" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "mToken",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "migrate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "migrator_", type: "address" }],
    name: "migrate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "migrationAdmin",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "name",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "account", type: "address" }],
    name: "nonces",
    outputs: [{ internalType: "uint256", name: "nonce", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "owner_", type: "address" },
      { internalType: "address", name: "spender_", type: "address" },
      { internalType: "uint256", name: "value_", type: "uint256" },
      { internalType: "uint256", name: "deadline_", type: "uint256" },
      { internalType: "bytes", name: "signature_", type: "bytes" }
    ],
    name: "permit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "owner_", type: "address" },
      { internalType: "address", name: "spender_", type: "address" },
      { internalType: "uint256", name: "value_", type: "uint256" },
      { internalType: "uint256", name: "deadline_", type: "uint256" },
      { internalType: "uint8", name: "v_", type: "uint8" },
      { internalType: "bytes32", name: "r_", type: "bytes32" },
      { internalType: "bytes32", name: "s_", type: "bytes32" }
    ],
    name: "permit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "principalOfTotalEarningSupply",
    outputs: [{ internalType: "uint112", name: "", type: "uint112" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "from_", type: "address" },
      { internalType: "address", name: "to_", type: "address" },
      { internalType: "uint256", name: "value_", type: "uint256" },
      { internalType: "uint256", name: "validAfter_", type: "uint256" },
      { internalType: "uint256", name: "validBefore_", type: "uint256" },
      { internalType: "bytes32", name: "nonce_", type: "bytes32" },
      { internalType: "bytes", name: "signature_", type: "bytes" }
    ],
    name: "receiveWithAuthorization",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "from_", type: "address" },
      { internalType: "address", name: "to_", type: "address" },
      { internalType: "uint256", name: "value_", type: "uint256" },
      { internalType: "uint256", name: "validAfter_", type: "uint256" },
      { internalType: "uint256", name: "validBefore_", type: "uint256" },
      { internalType: "bytes32", name: "nonce_", type: "bytes32" },
      { internalType: "bytes32", name: "r_", type: "bytes32" },
      { internalType: "bytes32", name: "vs_", type: "bytes32" }
    ],
    name: "receiveWithAuthorization",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "from_", type: "address" },
      { internalType: "address", name: "to_", type: "address" },
      { internalType: "uint256", name: "value_", type: "uint256" },
      { internalType: "uint256", name: "validAfter_", type: "uint256" },
      { internalType: "uint256", name: "validBefore_", type: "uint256" },
      { internalType: "bytes32", name: "nonce_", type: "bytes32" },
      { internalType: "uint8", name: "v_", type: "uint8" },
      { internalType: "bytes32", name: "r_", type: "bytes32" },
      { internalType: "bytes32", name: "s_", type: "bytes32" }
    ],
    name: "receiveWithAuthorization",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "registrar",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "account_", type: "address" }],
    name: "startEarningFor",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "account_", type: "address" }],
    name: "stopEarningFor",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "totalAccruedYield",
    outputs: [{ internalType: "uint240", name: "yield_", type: "uint240" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "totalEarningSupply",
    outputs: [{ internalType: "uint240", name: "", type: "uint240" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "totalNonEarningSupply",
    outputs: [{ internalType: "uint240", name: "", type: "uint240" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      { internalType: "uint256", name: "totalSupply_", type: "uint256" }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "recipient_", type: "address" },
      { internalType: "uint256", name: "amount_", type: "uint256" }
    ],
    name: "transfer",
    outputs: [{ internalType: "bool", name: "success_", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "sender_", type: "address" },
      { internalType: "address", name: "recipient_", type: "address" },
      { internalType: "uint256", name: "amount_", type: "uint256" }
    ],
    name: "transferFrom",
    outputs: [{ internalType: "bool", name: "success_", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "from_", type: "address" },
      { internalType: "address", name: "to_", type: "address" },
      { internalType: "uint256", name: "value_", type: "uint256" },
      { internalType: "uint256", name: "validAfter_", type: "uint256" },
      { internalType: "uint256", name: "validBefore_", type: "uint256" },
      { internalType: "bytes32", name: "nonce_", type: "bytes32" },
      { internalType: "bytes32", name: "r_", type: "bytes32" },
      { internalType: "bytes32", name: "vs_", type: "bytes32" }
    ],
    name: "transferWithAuthorization",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "from_", type: "address" },
      { internalType: "address", name: "to_", type: "address" },
      { internalType: "uint256", name: "value_", type: "uint256" },
      { internalType: "uint256", name: "validAfter_", type: "uint256" },
      { internalType: "uint256", name: "validBefore_", type: "uint256" },
      { internalType: "bytes32", name: "nonce_", type: "bytes32" },
      { internalType: "bytes", name: "signature_", type: "bytes" }
    ],
    name: "transferWithAuthorization",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "from_", type: "address" },
      { internalType: "address", name: "to_", type: "address" },
      { internalType: "uint256", name: "value_", type: "uint256" },
      { internalType: "uint256", name: "validAfter_", type: "uint256" },
      { internalType: "uint256", name: "validBefore_", type: "uint256" },
      { internalType: "bytes32", name: "nonce_", type: "bytes32" },
      { internalType: "uint8", name: "v_", type: "uint8" },
      { internalType: "bytes32", name: "r_", type: "bytes32" },
      { internalType: "bytes32", name: "s_", type: "bytes32" }
    ],
    name: "transferWithAuthorization",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "recipient_", type: "address" },
      { internalType: "uint256", name: "amount_", type: "uint256" }
    ],
    name: "unwrap",
    outputs: [{ internalType: "uint240", name: "unwrapped_", type: "uint240" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "recipient_", type: "address" }],
    name: "unwrap",
    outputs: [{ internalType: "uint240", name: "unwrapped_", type: "uint240" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "vault",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "wasEarningEnabled",
    outputs: [{ internalType: "bool", name: "wasEarning_", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "recipient_", type: "address" }],
    name: "wrap",
    outputs: [{ internalType: "uint240", name: "wrapped_", type: "uint240" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "recipient_", type: "address" },
      { internalType: "uint256", name: "amount_", type: "uint256" }
    ],
    name: "wrap",
    outputs: [{ internalType: "uint240", name: "wrapped_", type: "uint240" }],
    stateMutability: "nonpayable",
    type: "function"
  }
];
const tAbi = [
  { inputs: [], stateMutability: "nonpayable", type: "constructor" },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "delegator",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "fromDelegate",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "toDelegate",
        type: "address"
      }
    ],
    name: "DelegateChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "delegate",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "previousBalance",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newBalance",
        type: "uint256"
      }
    ],
    name: "DelegateVotesChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "from", type: "address" },
      { indexed: true, internalType: "address", name: "to", type: "address" },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    inputs: [],
    name: "DELEGATION_TYPEHASH",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "DOMAIN_SEPARATOR",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "PERMIT_TYPEHASH",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "", type: "address" },
      { internalType: "address", name: "", type: "address" }
    ],
    name: "allowance",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "uint256", name: "amount", type: "uint256" }
    ],
    name: "approve",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "uint256", name: "amount", type: "uint256" },
      { internalType: "bytes", name: "extraData", type: "bytes" }
    ],
    name: "approveAndCall",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "", type: "address" }],
    name: "balanceOf",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint256", name: "amount", type: "uint256" }],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "account", type: "address" },
      { internalType: "uint256", name: "amount", type: "uint256" }
    ],
    name: "burnFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "cachedChainId",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "cachedDomainSeparator",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "account", type: "address" },
      { internalType: "uint32", name: "pos", type: "uint32" }
    ],
    name: "checkpoints",
    outputs: [
      {
        components: [
          { internalType: "uint32", name: "fromBlock", type: "uint32" },
          { internalType: "uint96", name: "votes", type: "uint96" }
        ],
        internalType: "struct Checkpoints.Checkpoint",
        name: "checkpoint",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "delegatee", type: "address" }],
    name: "delegate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "signatory", type: "address" },
      { internalType: "address", name: "delegatee", type: "address" },
      { internalType: "uint256", name: "deadline", type: "uint256" },
      { internalType: "uint8", name: "v", type: "uint8" },
      { internalType: "bytes32", name: "r", type: "bytes32" },
      { internalType: "bytes32", name: "s", type: "bytes32" }
    ],
    name: "delegateBySig",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "account", type: "address" }],
    name: "delegates",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint256", name: "blockNumber", type: "uint256" }],
    name: "getPastTotalSupply",
    outputs: [{ internalType: "uint96", name: "", type: "uint96" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "account", type: "address" },
      { internalType: "uint256", name: "blockNumber", type: "uint256" }
    ],
    name: "getPastVotes",
    outputs: [{ internalType: "uint96", name: "", type: "uint96" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "account", type: "address" }],
    name: "getVotes",
    outputs: [{ internalType: "uint96", name: "", type: "uint96" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "recipient", type: "address" },
      { internalType: "uint256", name: "amount", type: "uint256" }
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "name",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "", type: "address" }],
    name: "nonce",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "account", type: "address" }],
    name: "numCheckpoints",
    outputs: [{ internalType: "uint32", name: "", type: "uint32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "owner", type: "address" },
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "uint256", name: "amount", type: "uint256" },
      { internalType: "uint256", name: "deadline", type: "uint256" },
      { internalType: "uint8", name: "v", type: "uint8" },
      { internalType: "bytes32", name: "r", type: "bytes32" },
      { internalType: "bytes32", name: "s", type: "bytes32" }
    ],
    name: "permit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "contract IERC20", name: "token", type: "address" },
      { internalType: "address", name: "recipient", type: "address" },
      { internalType: "uint256", name: "amount", type: "uint256" }
    ],
    name: "recoverERC20",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "contract IERC721", name: "token", type: "address" },
      { internalType: "address", name: "recipient", type: "address" },
      { internalType: "uint256", name: "tokenId", type: "uint256" },
      { internalType: "bytes", name: "data", type: "bytes" }
    ],
    name: "recoverERC721",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "recipient", type: "address" },
      { internalType: "uint256", name: "amount", type: "uint256" }
    ],
    name: "transfer",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "address", name: "recipient", type: "address" },
      { internalType: "uint256", name: "amount", type: "uint256" }
    ],
    name: "transferFrom",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "newOwner", type: "address" }],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];
const portalAbiReceiptsUpgrade = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "target",
        type: "address"
      }
    ],
    name: "AddressEmptyCode",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "AddressInsufficientBalance",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "asset",
        type: "address"
      }
    ],
    name: "AssetNotManagedByLiquidityTreasury",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "unlockAt",
        type: "uint32"
      }
    ],
    name: "DepositLocked",
    type: "error"
  },
  {
    inputs: [],
    name: "DepositNotFound",
    type: "error"
  },
  {
    inputs: [],
    name: "FailedInnerCall",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "IncorrectAmount",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "depositor",
        type: "address"
      }
    ],
    name: "IncorrectDepositor",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "lockPeriod",
        type: "uint256"
      }
    ],
    name: "IncorrectLockPeriod",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "receiptToken",
        type: "address"
      }
    ],
    name: "IncorrectReceiptTokenDecimals",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "enum Portal.TokenAbility",
        name: "ability",
        type: "uint8"
      }
    ],
    name: "IncorrectTokenAbility",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "IncorrectTokenAddress",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "enum Portal.TokenAbility",
        name: "tokenAbility",
        type: "uint8"
      }
    ],
    name: "InsufficientTokenAbility",
    type: "error"
  },
  {
    inputs: [],
    name: "InvalidInitialization",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "lockPeriod",
        type: "uint32"
      }
    ],
    name: "LockPeriodOutOfRange",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "lockPeriod",
        type: "uint32"
      },
      {
        internalType: "uint32",
        name: "newUnlockAt",
        type: "uint32"
      },
      {
        internalType: "uint32",
        name: "existingUnlockAt",
        type: "uint32"
      }
    ],
    name: "LockPeriodTooShort",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "annualFee",
        type: "uint8"
      }
    ],
    name: "MaxAnnualFeeExceeded",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "mintCap",
        type: "uint8"
      }
    ],
    name: "MaxReceiptMintCapExceeded",
    type: "error"
  },
  {
    inputs: [],
    name: "NotInitializing",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "OwnableInvalidOwner",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "OwnableUnauthorizedAccount",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "depositAmount",
        type: "uint256"
      }
    ],
    name: "PartialWithdrawalAmountTooHigh",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "feeOwed",
        type: "uint256"
      }
    ],
    name: "ReceiptFeeOwed",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "mintLimit",
        type: "uint256"
      },
      {
        internalType: "uint96",
        name: "currentlyMinted",
        type: "uint96"
      },
      {
        internalType: "uint256",
        name: "feeOwed",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "ReceiptMintLimitExceeded",
    type: "error"
  },
  {
    inputs: [],
    name: "ReceiptMintingDisabled",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "receiptMinted",
        type: "uint256"
      }
    ],
    name: "ReceiptNotRepaid",
    type: "error"
  },
  {
    inputs: [],
    name: "ReceiptTokenAlreadyInitialized",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint96",
        name: "mintedDebt",
        type: "uint96"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "RepayAmountExceededDebt",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "SafeERC20FailedOperation",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address"
      }
    ],
    name: "SenderNotLiquidityTreasury",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "enum Portal.TokenAbility",
        name: "tokenAbility",
        type: "uint8"
      }
    ],
    name: "TokenAlreadySupported",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "TokenNotSupported",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "UnknownTokenDecimals",
    type: "error"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "depositor",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "depositId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "Deposited",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "depositor",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "depositId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "fee",
        type: "uint256"
      }
    ],
    name: "FeeCollected",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint64",
        name: "version",
        type: "uint64"
      }
    ],
    name: "Initialized",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "isManaged",
        type: "bool"
      }
    ],
    name: "LiquidityTreasuryManagedAssetUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousLiquidityTreasury",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newLiquidityTreasury",
        type: "address"
      }
    ],
    name: "LiquidityTreasuryUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "depositor",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "depositId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint32",
        name: "unlockAt",
        type: "uint32"
      },
      {
        indexed: false,
        internalType: "uint32",
        name: "lockPeriod",
        type: "uint32"
      }
    ],
    name: "Locked",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint32",
        name: "maxLockPeriod",
        type: "uint32"
      }
    ],
    name: "MaxLockPeriodUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint32",
        name: "minLockPeriod",
        type: "uint32"
      }
    ],
    name: "MinLockPeriodUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferStarted",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "depositor",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "depositId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "ReceiptMinted",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "annualFee",
        type: "uint8"
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "mintCap",
        type: "uint8"
      },
      {
        indexed: false,
        internalType: "address",
        name: "receiptToken",
        type: "address"
      }
    ],
    name: "ReceiptParamsUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "depositor",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "depositId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "ReceiptRepaid",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: false,
        internalType: "enum Portal.TokenAbility",
        name: "tokenAbility",
        type: "uint8"
      }
    ],
    name: "SupportedTokenAdded",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "depositor",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "depositId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "Withdrawn",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "WithdrawnByLiquidityTreasury",
    type: "event"
  },
  {
    inputs: [],
    name: "acceptOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "token",
            type: "address"
          },
          {
            internalType: "enum Portal.TokenAbility",
            name: "tokenAbility",
            type: "uint8"
          }
        ],
        internalType: "struct Portal.SupportedToken",
        name: "supportedToken",
        type: "tuple"
      }
    ],
    name: "addSupportedToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint96",
        name: "amount",
        type: "uint96"
      },
      {
        internalType: "uint32",
        name: "lockPeriod",
        type: "uint32"
      }
    ],
    name: "deposit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "depositCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "depositOwner",
        type: "address"
      },
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint96",
        name: "amount",
        type: "uint96"
      },
      {
        internalType: "uint32",
        name: "lockPeriod",
        type: "uint32"
      }
    ],
    name: "depositFor",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "deposits",
    outputs: [
      {
        internalType: "uint96",
        name: "balance",
        type: "uint96"
      },
      {
        internalType: "uint32",
        name: "unlockAt",
        type: "uint32"
      },
      {
        internalType: "uint96",
        name: "receiptMinted",
        type: "uint96"
      },
      {
        internalType: "uint96",
        name: "feeOwed",
        type: "uint96"
      },
      {
        internalType: "uint88",
        name: "lastFeeIntegral",
        type: "uint88"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "feeInfo",
    outputs: [
      {
        internalType: "uint96",
        name: "totalMinted",
        type: "uint96"
      },
      {
        internalType: "uint32",
        name: "lastFeeUpdateAt",
        type: "uint32"
      },
      {
        internalType: "uint88",
        name: "feeIntegral",
        type: "uint88"
      },
      {
        internalType: "uint8",
        name: "annualFee",
        type: "uint8"
      },
      {
        internalType: "uint8",
        name: "mintCap",
        type: "uint8"
      },
      {
        internalType: "address",
        name: "receiptToken",
        type: "address"
      },
      {
        internalType: "uint96",
        name: "feeCollected",
        type: "uint96"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "depositor",
        type: "address"
      },
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "depositId",
        type: "uint256"
      }
    ],
    name: "getDeposit",
    outputs: [
      {
        components: [
          {
            internalType: "uint96",
            name: "balance",
            type: "uint96"
          },
          {
            internalType: "uint32",
            name: "unlockAt",
            type: "uint32"
          },
          {
            internalType: "uint96",
            name: "receiptMinted",
            type: "uint96"
          },
          {
            internalType: "uint96",
            name: "feeOwed",
            type: "uint96"
          },
          {
            internalType: "uint88",
            name: "lastFeeIntegral",
            type: "uint88"
          }
        ],
        internalType: "struct Portal.DepositInfo",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "token",
            type: "address"
          },
          {
            internalType: "enum Portal.TokenAbility",
            name: "tokenAbility",
            type: "uint8"
          }
        ],
        internalType: "struct Portal.SupportedToken[]",
        name: "supportedTokens",
        type: "tuple[]"
      }
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "liquidityTreasury",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "liquidityTreasuryManaged",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "depositId",
        type: "uint256"
      },
      {
        internalType: "uint32",
        name: "lockPeriod",
        type: "uint32"
      }
    ],
    name: "lock",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "maxLockPeriod",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "minLockPeriod",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "depositId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "mintReceipt",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pendingOwner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "receiveApproval",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "depositId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "repayReceipt",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "asset",
        type: "address"
      },
      {
        internalType: "bool",
        name: "isManaged",
        type: "bool"
      }
    ],
    name: "setAssetAsLiquidityTreasuryManaged",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_liquidityTreasury",
        type: "address"
      }
    ],
    name: "setLiquidityTreasury",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "_maxLockPeriod",
        type: "uint32"
      }
    ],
    name: "setMaxLockPeriod",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "_minLockPeriod",
        type: "uint32"
      }
    ],
    name: "setMinLockPeriod",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint8",
        name: "annualFee",
        type: "uint8"
      },
      {
        internalType: "uint8",
        name: "mintCap",
        type: "uint8"
      },
      {
        internalType: "address",
        name: "receiptToken",
        type: "address"
      }
    ],
    name: "setReceiptParams",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "tokenAbility",
    outputs: [
      {
        internalType: "enum Portal.TokenAbility",
        name: "",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "depositId",
        type: "uint256"
      }
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "withdrawAsLiquidityTreasury",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "depositId",
        type: "uint256"
      },
      {
        internalType: "uint96",
        name: "amount",
        type: "uint96"
      }
    ],
    name: "withdrawPartially",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];
const portalAbiMigrationsUpgrade = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "target",
        type: "address"
      }
    ],
    name: "AddressEmptyCode",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "AddressInsufficientBalance",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "asset",
        type: "address"
      }
    ],
    name: "AssetNotManagedByLiquidityTreasury",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "unlockAt",
        type: "uint32"
      }
    ],
    name: "DepositLocked",
    type: "error"
  },
  {
    inputs: [],
    name: "DepositNotFound",
    type: "error"
  },
  {
    inputs: [],
    name: "FailedInnerCall",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "IncorrectAmount",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "depositor",
        type: "address"
      }
    ],
    name: "IncorrectDepositor",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "lockPeriod",
        type: "uint256"
      }
    ],
    name: "IncorrectLockPeriod",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "receiptToken",
        type: "address"
      }
    ],
    name: "IncorrectReceiptTokenDecimals",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "enum Portal.TokenAbility",
        name: "ability",
        type: "uint8"
      }
    ],
    name: "IncorrectTokenAbility",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "IncorrectTokenAddress",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "enum Portal.TokenAbility",
        name: "tokenAbility",
        type: "uint8"
      }
    ],
    name: "InsufficientTokenAbility",
    type: "error"
  },
  {
    inputs: [],
    name: "InvalidInitialization",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "lockPeriod",
        type: "uint32"
      }
    ],
    name: "LockPeriodOutOfRange",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "lockPeriod",
        type: "uint32"
      },
      {
        internalType: "uint32",
        name: "newUnlockAt",
        type: "uint32"
      },
      {
        internalType: "uint32",
        name: "existingUnlockAt",
        type: "uint32"
      }
    ],
    name: "LockPeriodTooShort",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "annualFee",
        type: "uint8"
      }
    ],
    name: "MaxAnnualFeeExceeded",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "mintCap",
        type: "uint8"
      }
    ],
    name: "MaxReceiptMintCapExceeded",
    type: "error"
  },
  {
    inputs: [],
    name: "NotInitializing",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "OwnableInvalidOwner",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "OwnableUnauthorizedAccount",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "depositAmount",
        type: "uint256"
      }
    ],
    name: "PartialWithdrawalAmountTooHigh",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "feeOwed",
        type: "uint256"
      }
    ],
    name: "ReceiptFeeOwed",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "mintLimit",
        type: "uint256"
      },
      {
        internalType: "uint96",
        name: "currentlyMinted",
        type: "uint96"
      },
      {
        internalType: "uint256",
        name: "feeOwed",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "ReceiptMintLimitExceeded",
    type: "error"
  },
  {
    inputs: [],
    name: "ReceiptMintingDisabled",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "receiptMinted",
        type: "uint256"
      }
    ],
    name: "ReceiptNotRepaid",
    type: "error"
  },
  {
    inputs: [],
    name: "ReceiptTokenAlreadyInitialized",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint96",
        name: "mintedDebt",
        type: "uint96"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "RepayAmountExceededDebt",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "SafeERC20FailedOperation",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address"
      }
    ],
    name: "SenderNotLiquidityTreasury",
    type: "error"
  },
  {
    inputs: [],
    name: "SenderNotTbtcMigrationTreasury",
    type: "error"
  },
  {
    inputs: [],
    name: "TbtcMigrationAndLiquidityManagementConflict",
    type: "error"
  },
  {
    inputs: [],
    name: "TbtcMigrationNotAllowed",
    type: "error"
  },
  {
    inputs: [],
    name: "TbtcMigrationNotCompleted",
    type: "error"
  },
  {
    inputs: [],
    name: "TbtcMigrationRequestedErr",
    type: "error"
  },
  {
    inputs: [],
    name: "TbtcTokenAddressAlreadySet",
    type: "error"
  },
  {
    inputs: [],
    name: "TbtcTokenAddressNotSet",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "enum Portal.TokenAbility",
        name: "tokenAbility",
        type: "uint8"
      }
    ],
    name: "TokenAlreadySupported",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "TokenNotSupported",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "depositId",
        type: "uint256"
      },
      {
        internalType: "enum Portal.TbtcMigrationState",
        name: "currentState",
        type: "uint8"
      },
      {
        internalType: "enum Portal.TbtcMigrationState",
        name: "expectedState",
        type: "uint8"
      }
    ],
    name: "UnexpectedTbtcMigrationState",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "UnknownTokenDecimals",
    type: "error"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "depositor",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "depositId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "Deposited",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "depositor",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "depositId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "fee",
        type: "uint256"
      }
    ],
    name: "FeeCollected",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "depositor",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "tbtcToken",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "depositId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "feeInTbtc",
        type: "uint256"
      }
    ],
    name: "FeeCollectedTbtcMigrated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "FundedFromTbtcMigration",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint64",
        name: "version",
        type: "uint64"
      }
    ],
    name: "Initialized",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "isManaged",
        type: "bool"
      }
    ],
    name: "LiquidityTreasuryManagedAssetUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousLiquidityTreasury",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newLiquidityTreasury",
        type: "address"
      }
    ],
    name: "LiquidityTreasuryUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "depositor",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "depositId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint32",
        name: "unlockAt",
        type: "uint32"
      },
      {
        indexed: false,
        internalType: "uint32",
        name: "lockPeriod",
        type: "uint32"
      }
    ],
    name: "Locked",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint32",
        name: "maxLockPeriod",
        type: "uint32"
      }
    ],
    name: "MaxLockPeriodUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint32",
        name: "minLockPeriod",
        type: "uint32"
      }
    ],
    name: "MinLockPeriodUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferStarted",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "depositor",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "depositId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "ReceiptMinted",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "annualFee",
        type: "uint8"
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "mintCap",
        type: "uint8"
      },
      {
        indexed: false,
        internalType: "address",
        name: "receiptToken",
        type: "address"
      }
    ],
    name: "ReceiptParamsUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "depositor",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "depositId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "ReceiptRepaid",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: false,
        internalType: "enum Portal.TokenAbility",
        name: "tokenAbility",
        type: "uint8"
      }
    ],
    name: "SupportedTokenAdded",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "isAllowed",
        type: "bool"
      }
    ],
    name: "TbtcMigrationAllowedUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "depositor",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "depositId",
        type: "uint256"
      }
    ],
    name: "TbtcMigrationCompleted",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "depositor",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "depositId",
        type: "uint256"
      }
    ],
    name: "TbtcMigrationRequested",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "depositor",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "depositId",
        type: "uint256"
      }
    ],
    name: "TbtcMigrationStarted",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousMigrationTreasury",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newMigrationTreasury",
        type: "address"
      }
    ],
    name: "TbtcMigrationTreasuryUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "tbtc",
        type: "address"
      }
    ],
    name: "TbtcTokenAddressSet",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "depositor",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "depositId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "Withdrawn",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "WithdrawnByLiquidityTreasury",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "WithdrawnForTbtcMigration",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "depositor",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "tbtcToken",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "depositId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amountInTbtc",
        type: "uint256"
      }
    ],
    name: "WithdrawnTbtcMigrated",
    type: "event"
  },
  {
    inputs: [],
    name: "acceptOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "token",
            type: "address"
          },
          {
            internalType: "enum Portal.TokenAbility",
            name: "tokenAbility",
            type: "uint8"
          }
        ],
        internalType: "struct Portal.SupportedToken",
        name: "supportedToken",
        type: "tuple"
      }
    ],
    name: "addSupportedToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        components: [
          {
            internalType: "address",
            name: "depositor",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "depositId",
            type: "uint256"
          }
        ],
        internalType: "struct Portal.DepositToMigrate[]",
        name: "migratedDeposits",
        type: "tuple[]"
      }
    ],
    name: "completeTbtcMigration",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint96",
        name: "amount",
        type: "uint96"
      },
      {
        internalType: "uint32",
        name: "lockPeriod",
        type: "uint32"
      }
    ],
    name: "deposit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "depositCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "depositOwner",
        type: "address"
      },
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint96",
        name: "amount",
        type: "uint96"
      },
      {
        internalType: "uint32",
        name: "lockPeriod",
        type: "uint32"
      }
    ],
    name: "depositFor",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "deposits",
    outputs: [
      {
        internalType: "uint96",
        name: "balance",
        type: "uint96"
      },
      {
        internalType: "uint32",
        name: "unlockAt",
        type: "uint32"
      },
      {
        internalType: "uint96",
        name: "receiptMinted",
        type: "uint96"
      },
      {
        internalType: "uint96",
        name: "feeOwed",
        type: "uint96"
      },
      {
        internalType: "uint88",
        name: "lastFeeIntegral",
        type: "uint88"
      },
      {
        internalType: "enum Portal.TbtcMigrationState",
        name: "tbtcMigrationState",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "feeInfo",
    outputs: [
      {
        internalType: "uint96",
        name: "totalMinted",
        type: "uint96"
      },
      {
        internalType: "uint32",
        name: "lastFeeUpdateAt",
        type: "uint32"
      },
      {
        internalType: "uint88",
        name: "feeIntegral",
        type: "uint88"
      },
      {
        internalType: "uint8",
        name: "annualFee",
        type: "uint8"
      },
      {
        internalType: "uint8",
        name: "mintCap",
        type: "uint8"
      },
      {
        internalType: "address",
        name: "receiptToken",
        type: "address"
      },
      {
        internalType: "uint96",
        name: "feeCollected",
        type: "uint96"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "depositor",
        type: "address"
      },
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "depositId",
        type: "uint256"
      }
    ],
    name: "getDeposit",
    outputs: [
      {
        components: [
          {
            internalType: "uint96",
            name: "balance",
            type: "uint96"
          },
          {
            internalType: "uint32",
            name: "unlockAt",
            type: "uint32"
          },
          {
            internalType: "uint96",
            name: "receiptMinted",
            type: "uint96"
          },
          {
            internalType: "uint96",
            name: "feeOwed",
            type: "uint96"
          },
          {
            internalType: "uint88",
            name: "lastFeeIntegral",
            type: "uint88"
          },
          {
            internalType: "enum Portal.TbtcMigrationState",
            name: "tbtcMigrationState",
            type: "uint8"
          }
        ],
        internalType: "struct Portal.DepositInfo",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "token",
            type: "address"
          },
          {
            internalType: "enum Portal.TokenAbility",
            name: "tokenAbility",
            type: "uint8"
          }
        ],
        internalType: "struct Portal.SupportedToken[]",
        name: "supportedTokens",
        type: "tuple[]"
      }
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "liquidityTreasury",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "liquidityTreasuryManaged",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "depositId",
        type: "uint256"
      },
      {
        internalType: "uint32",
        name: "lockPeriod",
        type: "uint32"
      }
    ],
    name: "lock",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "maxLockPeriod",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "minLockPeriod",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "depositId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "mintReceipt",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pendingOwner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "receiveApproval",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "depositId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "repayReceipt",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "depositId",
        type: "uint256"
      }
    ],
    name: "requestTbtcMigration",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "asset",
        type: "address"
      },
      {
        internalType: "bool",
        name: "isManaged",
        type: "bool"
      }
    ],
    name: "setAssetAsLiquidityTreasuryManaged",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "asset",
        type: "address"
      },
      {
        internalType: "bool",
        name: "isAllowed",
        type: "bool"
      }
    ],
    name: "setAssetTbtcMigrationAllowed",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_liquidityTreasury",
        type: "address"
      }
    ],
    name: "setLiquidityTreasury",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "_maxLockPeriod",
        type: "uint32"
      }
    ],
    name: "setMaxLockPeriod",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "_minLockPeriod",
        type: "uint32"
      }
    ],
    name: "setMinLockPeriod",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint8",
        name: "annualFee",
        type: "uint8"
      },
      {
        internalType: "uint8",
        name: "mintCap",
        type: "uint8"
      },
      {
        internalType: "address",
        name: "receiptToken",
        type: "address"
      }
    ],
    name: "setReceiptParams",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_tbtcMigrationTreasury",
        type: "address"
      }
    ],
    name: "setTbtcMigrationTreasury",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_tbtcToken",
        type: "address"
      }
    ],
    name: "setTbtcTokenAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "tbtcMigrationTreasury",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "tbtcMigrations",
    outputs: [
      {
        internalType: "bool",
        name: "isAllowed",
        type: "bool"
      },
      {
        internalType: "uint96",
        name: "totalMigrating",
        type: "uint96"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "tbtcToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "tokenAbility",
    outputs: [
      {
        internalType: "enum Portal.TokenAbility",
        name: "",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "depositId",
        type: "uint256"
      }
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "withdrawAsLiquidityTreasury",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        components: [
          {
            internalType: "address",
            name: "depositor",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "depositId",
            type: "uint256"
          }
        ],
        internalType: "struct Portal.DepositToMigrate[]",
        name: "depositsToMigrate",
        type: "tuple[]"
      }
    ],
    name: "withdrawForTbtcMigration",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "depositId",
        type: "uint256"
      },
      {
        internalType: "uint96",
        name: "amount",
        type: "uint96"
      }
    ],
    name: "withdrawPartially",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];
const borrowerOperationsAbi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "target",
        type: "address"
      }
    ],
    name: "AddressEmptyCode",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "AddressInsufficientBalance",
    type: "error"
  },
  {
    inputs: [],
    name: "FailedInnerCall",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "OwnableInvalidOwner",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "OwnableUnauthorizedAccount",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "SafeERC20FailedOperation",
    type: "error"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_activePoolAddress",
        type: "address"
      }
    ],
    name: "ActivePoolAddressChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_borrower",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_fee",
        type: "uint256"
      }
    ],
    name: "BorrowingFeePaid",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_collSurplusPoolAddress",
        type: "address"
      }
    ],
    name: "CollSurplusPoolAddressChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_newCollateralAddress",
        type: "address"
      }
    ],
    name: "CollateralAddressChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_defaultPoolAddress",
        type: "address"
      }
    ],
    name: "DefaultPoolAddressChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_gasPoolAddress",
        type: "address"
      }
    ],
    name: "GasPoolAddressChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_musdTokenAddress",
        type: "address"
      }
    ],
    name: "MUSDTokenAddressChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_pcvAddress",
        type: "address"
      }
    ],
    name: "PCVAddressChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_newPriceFeedAddress",
        type: "address"
      }
    ],
    name: "PriceFeedAddressChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_borrower",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_fee",
        type: "uint256"
      }
    ],
    name: "RefinancingFeePaid",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_sortedTrovesAddress",
        type: "address"
      }
    ],
    name: "SortedTrovesAddressChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_stabilityPoolAddress",
        type: "address"
      }
    ],
    name: "StabilityPoolAddressChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_borrower",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "arrayIndex",
        type: "uint256"
      }
    ],
    name: "TroveCreated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_newTroveManagerAddress",
        type: "address"
      }
    ],
    name: "TroveManagerAddressChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_borrower",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_principal",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_interest",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_coll",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "stake",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "operation",
        type: "uint8"
      }
    ],
    name: "TroveUpdated",
    type: "event"
  },
  {
    inputs: [],
    name: "BORROWING_FEE_FLOOR",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "CCR",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "DECIMAL_PRECISION",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "MCR",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "MIN_NET_DEBT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "MUSD_GAS_COMPENSATION",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "PERCENT_DIVISOR",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "_100pct",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "activePool",
    outputs: [
      {
        internalType: "contract IActivePool",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_assetAmount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_upperHint",
        type: "address"
      },
      {
        internalType: "address",
        name: "_lowerHint",
        type: "address"
      }
    ],
    name: "addColl",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_maxFeePercentage",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_collWithdrawal",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_debtChange",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "_isDebtIncrease",
        type: "bool"
      },
      {
        internalType: "uint256",
        name: "_assetAmount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_upperHint",
        type: "address"
      },
      {
        internalType: "address",
        name: "_lowerHint",
        type: "address"
      }
    ],
    name: "adjustTrove",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_musdToBurn",
        type: "uint256"
      }
    ],
    name: "burnDebtFromPCV",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "claimCollateral",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "closeTrove",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "collSurplusPool",
    outputs: [
      {
        internalType: "contract ICollSurplusPool",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "collateralAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "defaultPool",
    outputs: [
      {
        internalType: "contract IDefaultPool",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "gasPoolAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_debt",
        type: "uint256"
      }
    ],
    name: "getCompositeDebt",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [],
    name: "getEntireSystemColl",
    outputs: [
      {
        internalType: "uint256",
        name: "entireSystemColl",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getEntireSystemDebt",
    outputs: [
      {
        internalType: "uint256",
        name: "entireSystemDebt",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "interestRateManager",
    outputs: [
      {
        internalType: "contract IInterestRateManager",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_musdToMint",
        type: "uint256"
      }
    ],
    name: "mintBootstrapLoanFromPCV",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_borrower",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_assetAmount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_upperHint",
        type: "address"
      },
      {
        internalType: "address",
        name: "_lowerHint",
        type: "address"
      }
    ],
    name: "moveCollateralGainToTrove",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [],
    name: "musd",
    outputs: [
      {
        internalType: "contract IMUSD",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_maxFeePercentage",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_debtAmount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_assetAmount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_upperHint",
        type: "address"
      },
      {
        internalType: "address",
        name: "_lowerHint",
        type: "address"
      }
    ],
    name: "openTrove",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pcv",
    outputs: [
      {
        internalType: "contract IPCV",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pcvAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "priceFeed",
    outputs: [
      {
        internalType: "contract IPriceFeed",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_maxFeePercentage",
        type: "uint256"
      }
    ],
    name: "refinance",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "refinancingFeePercentage",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_upperHint",
        type: "address"
      },
      {
        internalType: "address",
        name: "_lowerHint",
        type: "address"
      }
    ],
    name: "repayMUSD",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_activePoolAddress",
        type: "address"
      },
      {
        internalType: "address",
        name: "_collateralAddress",
        type: "address"
      },
      {
        internalType: "address",
        name: "_collSurplusPoolAddress",
        type: "address"
      },
      {
        internalType: "address",
        name: "_defaultPoolAddress",
        type: "address"
      },
      {
        internalType: "address",
        name: "_gasPoolAddress",
        type: "address"
      },
      {
        internalType: "address",
        name: "_interestRateManagerAddress",
        type: "address"
      },
      {
        internalType: "address",
        name: "_musdTokenAddress",
        type: "address"
      },
      {
        internalType: "address",
        name: "_pcvAddress",
        type: "address"
      },
      {
        internalType: "address",
        name: "_priceFeedAddress",
        type: "address"
      },
      {
        internalType: "address",
        name: "_stabilityPoolAddress",
        type: "address"
      },
      {
        internalType: "address",
        name: "_sortedTrovesAddress",
        type: "address"
      },
      {
        internalType: "address",
        name: "_troveManagerAddress",
        type: "address"
      }
    ],
    name: "setAddresses",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "_refinanceFeePercentage",
        type: "uint8"
      }
    ],
    name: "setRefinancingFeePercentage",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "sortedTroves",
    outputs: [
      {
        internalType: "contract ISortedTroves",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "stabilityPoolAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "troveManager",
    outputs: [
      {
        internalType: "contract ITroveManager",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_upperHint",
        type: "address"
      },
      {
        internalType: "address",
        name: "_lowerHint",
        type: "address"
      }
    ],
    name: "withdrawColl",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_maxFeePercentage",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_upperHint",
        type: "address"
      },
      {
        internalType: "address",
        name: "_lowerHint",
        type: "address"
      }
    ],
    name: "withdrawMUSD",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];
const priceFeedAbi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "OwnableInvalidOwner",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "OwnableUnauthorizedAccount",
    type: "error"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "_lastGoodPrice",
        type: "uint256"
      }
    ],
    name: "LastGoodPriceUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_oracle",
        type: "address"
      }
    ],
    name: "NewOracleRegistered",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    inputs: [],
    name: "TARGET_DIGITS",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "fetchPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "oracle",
    outputs: [
      {
        internalType: "contract ChainlinkAggregatorV3Interface",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_oracle",
        type: "address"
      }
    ],
    name: "setOracle",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];
const troveManagerAbi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "OwnableInvalidOwner",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "OwnableUnauthorizedAccount",
    type: "error"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_activePoolAddress",
        type: "address"
      }
    ],
    name: "ActivePoolAddressChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "_baseRate",
        type: "uint256"
      }
    ],
    name: "BaseRateUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_newBorrowerOperationsAddress",
        type: "address"
      }
    ],
    name: "BorrowerOperationsAddressChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_collSurplusPoolAddress",
        type: "address"
      }
    ],
    name: "CollSurplusPoolAddressChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_defaultPoolAddress",
        type: "address"
      }
    ],
    name: "DefaultPoolAddressChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_gasPoolAddress",
        type: "address"
      }
    ],
    name: "GasPoolAddressChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_interestRateManagerAddress",
        type: "address"
      }
    ],
    name: "InterestRateManagerAddressChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "_L_Collateral",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_L_Principal",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_L_Interest",
        type: "uint256"
      }
    ],
    name: "LTermsUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "_lastFeeOpTime",
        type: "uint256"
      }
    ],
    name: "LastFeeOpTimeUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "_liquidatedPrincipal",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_liquidatedInterest",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_liquidatedColl",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_collGasCompensation",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_gasCompensation",
        type: "uint256"
      }
    ],
    name: "Liquidation",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_newMUSDTokenAddress",
        type: "address"
      }
    ],
    name: "MUSDTokenAddressChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_pcvAddress",
        type: "address"
      }
    ],
    name: "PCVAddressChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_newPriceFeedAddress",
        type: "address"
      }
    ],
    name: "PriceFeedAddressChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "_attemptedAmount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_actualAmount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_collateralSent",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_collateralFee",
        type: "uint256"
      }
    ],
    name: "Redemption",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_sortedTrovesAddress",
        type: "address"
      }
    ],
    name: "SortedTrovesAddressChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_stabilityPoolAddress",
        type: "address"
      }
    ],
    name: "StabilityPoolAddressChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "_totalStakesSnapshot",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_totalCollateralSnapshot",
        type: "uint256"
      }
    ],
    name: "SystemSnapshotsUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "_newTotalStakes",
        type: "uint256"
      }
    ],
    name: "TotalStakesUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_borrower",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_newIndex",
        type: "uint256"
      }
    ],
    name: "TroveIndexUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_borrower",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_debt",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_coll",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "operation",
        type: "uint8"
      }
    ],
    name: "TroveLiquidated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "_L_Collateral",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_L_Principal",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_L_Interest",
        type: "uint256"
      }
    ],
    name: "TroveSnapshotsUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_borrower",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_principal",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_interest",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_coll",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "stake",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "operation",
        type: "uint8"
      }
    ],
    name: "TroveUpdated",
    type: "event"
  },
  {
    inputs: [],
    name: "BETA",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "BORROWING_FEE_FLOOR",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "CCR",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "DECIMAL_PRECISION",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "L_Collateral",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "L_Interest",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "L_Principal",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "MAX_BORROWING_FEE",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "MCR",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "MINUTE_DECAY_FACTOR",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "MIN_NET_DEBT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "MUSD_GAS_COMPENSATION",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "PERCENT_DIVISOR",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "REDEMPTION_FEE_FLOOR",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "TroveOwners",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "Troves",
    outputs: [
      {
        internalType: "uint256",
        name: "coll",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "principal",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "interestOwed",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "stake",
        type: "uint256"
      },
      {
        internalType: "enum ITroveManager.Status",
        name: "status",
        type: "uint8"
      },
      {
        internalType: "uint16",
        name: "interestRate",
        type: "uint16"
      },
      {
        internalType: "uint256",
        name: "lastInterestUpdateTime",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "maxBorrowingCapacity",
        type: "uint256"
      },
      {
        internalType: "uint128",
        name: "arrayIndex",
        type: "uint128"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "_100pct",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "activePool",
    outputs: [
      {
        internalType: "contract IActivePool",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_borrower",
        type: "address"
      }
    ],
    name: "addTroveOwnerToArray",
    outputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_borrower",
        type: "address"
      }
    ],
    name: "applyPendingRewards",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "baseRate",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_troveArray",
        type: "address[]"
      }
    ],
    name: "batchLiquidateTroves",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "borrowerOperationsAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_price",
        type: "uint256"
      }
    ],
    name: "checkRecoveryMode",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_borrower",
        type: "address"
      }
    ],
    name: "closeTrove",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "collSurplusPool",
    outputs: [
      {
        internalType: "contract ICollSurplusPool",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "decayBaseRateFromBorrowing",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_borrower",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_collDecrease",
        type: "uint256"
      }
    ],
    name: "decreaseTroveColl",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_borrower",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_debtDecrease",
        type: "uint256"
      }
    ],
    name: "decreaseTroveDebt",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "defaultPool",
    outputs: [
      {
        internalType: "contract IDefaultPool",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "gasPoolAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_debt",
        type: "uint256"
      }
    ],
    name: "getBorrowingFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_debt",
        type: "uint256"
      }
    ],
    name: "getBorrowingFeeWithDecay",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getBorrowingRate",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getBorrowingRateWithDecay",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_borrower",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_price",
        type: "uint256"
      }
    ],
    name: "getCurrentICR",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_borrower",
        type: "address"
      }
    ],
    name: "getEntireDebtAndColl",
    outputs: [
      {
        internalType: "uint256",
        name: "coll",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "principal",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "interest",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "pendingCollateral",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "pendingPrincipal",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "pendingInterest",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getEntireSystemColl",
    outputs: [
      {
        internalType: "uint256",
        name: "entireSystemColl",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getEntireSystemDebt",
    outputs: [
      {
        internalType: "uint256",
        name: "entireSystemDebt",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_borrower",
        type: "address"
      }
    ],
    name: "getNominalICR",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_borrower",
        type: "address"
      }
    ],
    name: "getPendingCollateral",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_borrower",
        type: "address"
      }
    ],
    name: "getPendingDebt",
    outputs: [
      {
        internalType: "uint256",
        name: "pendingPrincipal",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "pendingInterest",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_collateralDrawn",
        type: "uint256"
      }
    ],
    name: "getRedemptionFeeWithDecay",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getRedemptionRate",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getRedemptionRateWithDecay",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_price",
        type: "uint256"
      }
    ],
    name: "getTCR",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_borrower",
        type: "address"
      }
    ],
    name: "getTroveColl",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_borrower",
        type: "address"
      }
    ],
    name: "getTroveDebt",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_index",
        type: "uint256"
      }
    ],
    name: "getTroveFromTroveOwnersArray",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_borrower",
        type: "address"
      }
    ],
    name: "getTroveInterestOwed",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_borrower",
        type: "address"
      }
    ],
    name: "getTroveInterestRate",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_borrower",
        type: "address"
      }
    ],
    name: "getTroveLastInterestUpdateTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_borrower",
        type: "address"
      }
    ],
    name: "getTroveMaxBorrowingCapacity",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getTroveOwnersCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_borrower",
        type: "address"
      }
    ],
    name: "getTrovePrincipal",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_borrower",
        type: "address"
      }
    ],
    name: "getTroveStake",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_borrower",
        type: "address"
      }
    ],
    name: "getTroveStatus",
    outputs: [
      {
        internalType: "enum ITroveManager.Status",
        name: "",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_borrower",
        type: "address"
      }
    ],
    name: "hasPendingRewards",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_borrower",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_collIncrease",
        type: "uint256"
      }
    ],
    name: "increaseTroveColl",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_borrower",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_debtIncrease",
        type: "uint256"
      }
    ],
    name: "increaseTroveDebt",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "interestRateManager",
    outputs: [
      {
        internalType: "contract IInterestRateManager",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "lastCollateralError_Redistribution",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "lastFeeOperationTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "lastInterestError_Redistribution",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "lastPrincipalError_Redistribution",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_borrower",
        type: "address"
      }
    ],
    name: "liquidate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "musdToken",
    outputs: [
      {
        internalType: "contract IMUSD",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pcv",
    outputs: [
      {
        internalType: "contract IPCV",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "priceFeed",
    outputs: [
      {
        internalType: "contract IPriceFeed",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_firstRedemptionHint",
        type: "address"
      },
      {
        internalType: "address",
        name: "_upperPartialRedemptionHint",
        type: "address"
      },
      {
        internalType: "address",
        name: "_lowerPartialRedemptionHint",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_partialRedemptionHintNICR",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_maxIterations",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_maxFeePercentage",
        type: "uint256"
      }
    ],
    name: "redeemCollateral",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_borrower",
        type: "address"
      }
    ],
    name: "removeStake",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "rewardSnapshots",
    outputs: [
      {
        internalType: "uint256",
        name: "collateral",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "principal",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "interest",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_activePoolAddress",
        type: "address"
      },
      {
        internalType: "address",
        name: "_borrowerOperationsAddress",
        type: "address"
      },
      {
        internalType: "address",
        name: "_collSurplusPoolAddress",
        type: "address"
      },
      {
        internalType: "address",
        name: "_defaultPoolAddress",
        type: "address"
      },
      {
        internalType: "address",
        name: "_gasPoolAddress",
        type: "address"
      },
      {
        internalType: "address",
        name: "_interestRateManagerAddress",
        type: "address"
      },
      {
        internalType: "address",
        name: "_musdTokenAddress",
        type: "address"
      },
      {
        internalType: "address",
        name: "_pcvAddress",
        type: "address"
      },
      {
        internalType: "address",
        name: "_priceFeedAddress",
        type: "address"
      },
      {
        internalType: "address",
        name: "_sortedTrovesAddress",
        type: "address"
      },
      {
        internalType: "address",
        name: "_stabilityPoolAddress",
        type: "address"
      }
    ],
    name: "setAddresses",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_borrower",
        type: "address"
      },
      {
        internalType: "uint16",
        name: "_rate",
        type: "uint16"
      }
    ],
    name: "setTroveInterestRate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_borrower",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_timestamp",
        type: "uint256"
      }
    ],
    name: "setTroveLastInterestUpdateTime",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_borrower",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_maxBorrowingCapacity",
        type: "uint256"
      }
    ],
    name: "setTroveMaxBorrowingCapacity",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_borrower",
        type: "address"
      },
      {
        internalType: "enum ITroveManager.Status",
        name: "_status",
        type: "uint8"
      }
    ],
    name: "setTroveStatus",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "sortedTroves",
    outputs: [
      {
        internalType: "contract ISortedTroves",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "stabilityPool",
    outputs: [
      {
        internalType: "contract IStabilityPool",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "totalCollateralSnapshot",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "totalStakes",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "totalStakesSnapshot",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "updateDefaultPoolInterest",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_borrower",
        type: "address"
      }
    ],
    name: "updateStakeAndTotalStakes",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_borrower",
        type: "address"
      }
    ],
    name: "updateSystemAndTroveInterest",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_borrower",
        type: "address"
      }
    ],
    name: "updateTroveRewardSnapshots",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];
const sortedTrovesAbi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "OwnableInvalidOwner",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "OwnableUnauthorizedAccount",
    type: "error"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_borrowerOperationsAddress",
        type: "address"
      }
    ],
    name: "BorrowerOperationsAddressChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_id",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_NICR",
        type: "uint256"
      }
    ],
    name: "NodeAdded",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_id",
        type: "address"
      }
    ],
    name: "NodeRemoved",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_sortedDoublyLLAddress",
        type: "address"
      }
    ],
    name: "SortedTrovesAddressChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_troveManagerAddress",
        type: "address"
      }
    ],
    name: "TroveManagerAddressChanged",
    type: "event"
  },
  {
    inputs: [],
    name: "borrowerOperationsAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_id",
        type: "address"
      }
    ],
    name: "contains",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "data",
    outputs: [
      {
        internalType: "address",
        name: "head",
        type: "address"
      },
      {
        internalType: "address",
        name: "tail",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "maxSize",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "size",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_NICR",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_prevId",
        type: "address"
      },
      {
        internalType: "address",
        name: "_nextId",
        type: "address"
      }
    ],
    name: "findInsertPosition",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getFirst",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getLast",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getMaxSize",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_id",
        type: "address"
      }
    ],
    name: "getNext",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_id",
        type: "address"
      }
    ],
    name: "getPrev",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getSize",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_id",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_NICR",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_prevId",
        type: "address"
      },
      {
        internalType: "address",
        name: "_nextId",
        type: "address"
      }
    ],
    name: "insert",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "isEmpty",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "isFull",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_id",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_newNICR",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_prevId",
        type: "address"
      },
      {
        internalType: "address",
        name: "_nextId",
        type: "address"
      }
    ],
    name: "reInsert",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_id",
        type: "address"
      }
    ],
    name: "remove",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_size",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_troveManagerAddress",
        type: "address"
      },
      {
        internalType: "address",
        name: "_borrowerOperationsAddress",
        type: "address"
      }
    ],
    name: "setParams",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "troveManager",
    outputs: [
      {
        internalType: "contract ITroveManager",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_NICR",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_prevId",
        type: "address"
      },
      {
        internalType: "address",
        name: "_nextId",
        type: "address"
      }
    ],
    name: "validInsertPosition",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  }
];
const hintHelpersAbi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "OwnableInvalidOwner",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "OwnableUnauthorizedAccount",
    type: "error"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_sortedTrovesAddress",
        type: "address"
      }
    ],
    name: "SortedTrovesAddressChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_troveManagerAddress",
        type: "address"
      }
    ],
    name: "TroveManagerAddressChanged",
    type: "event"
  },
  {
    inputs: [],
    name: "BORROWING_FEE_FLOOR",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "CCR",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "DECIMAL_PRECISION",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "MCR",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "MIN_NET_DEBT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "MUSD_GAS_COMPENSATION",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "NAME",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "PERCENT_DIVISOR",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "_100pct",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "activePool",
    outputs: [
      {
        internalType: "contract IActivePool",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_coll",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_debt",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_price",
        type: "uint256"
      }
    ],
    name: "computeCR",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_coll",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_debt",
        type: "uint256"
      }
    ],
    name: "computeNominalCR",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [],
    name: "defaultPool",
    outputs: [
      {
        internalType: "contract IDefaultPool",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_CR",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_numTrials",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_inputRandomSeed",
        type: "uint256"
      }
    ],
    name: "getApproxHint",
    outputs: [
      {
        internalType: "address",
        name: "hintAddress",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "diff",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "latestRandomSeed",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getEntireSystemColl",
    outputs: [
      {
        internalType: "uint256",
        name: "entireSystemColl",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getEntireSystemDebt",
    outputs: [
      {
        internalType: "uint256",
        name: "entireSystemDebt",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_price",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_maxIterations",
        type: "uint256"
      }
    ],
    name: "getRedemptionHints",
    outputs: [
      {
        internalType: "address",
        name: "firstRedemptionHint",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "partialRedemptionHintNICR",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "truncatedAmount",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "priceFeed",
    outputs: [
      {
        internalType: "contract IPriceFeed",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_sortedTrovesAddress",
        type: "address"
      },
      {
        internalType: "address",
        name: "_troveManagerAddress",
        type: "address"
      }
    ],
    name: "setAddresses",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "sortedTroves",
    outputs: [
      {
        internalType: "contract ISortedTroves",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "troveManager",
    outputs: [
      {
        internalType: "contract ITroveManager",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  }
];
var define_process_env_default$3 = { npm_package_scripts_build_source: "node scripts/copy-original-ts-files.mjs", npm_package_devDependencies__types_node: "^20.10.6", npm_package_devDependencies_ts_node: "^10.9.2", npm_package_dependencies__orangekit_sign_in_with_wallet: "1.0.0-beta.6", HOST_NODE_IP: "10.71.17.84", INTEGRATION_TEST: "", SITE_ID: "64ff34ae-c815-4397-9ed0-f7eabbfb7032", npm_package_scripts_lint_config: "prettier -c '**/*.@(json|yaml|toml|md)'", npm_package_dependencies__safe_global_safe_core_sdk_types: "4.0.1", LANGUAGE: "en_US:en", ENABLE_ZERO_LOCK_TIME: "false", npm_package_devDependencies_jest: "^29.7.0", npm_config_user_agent: "pnpm/8.13.1 npm/? node/v20.19.1 linux x64", ENABLE_SEPARATE_MEZO_CHAINS: "false", RVM_DIR: "/opt/buildhome/.rvm", SENTRY_AUTH_TOKEN: "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", CI: "true", NODE_VERSION: "v20.19.1", YARN_VERSION: "1.22.19", ENABLE_BORROW_PRICE_CHANGES: "false", GOLDSKY_MEZO_SUBGRAPH_URL: "https://api.goldsky.com/api/public/project_cm6ks2x8um4aj01uj8nwg1f6r/subgraphs/mezo-testnet/0.1.0-dev.3/gn", URL: "https://mezo.org", BRANCH: "matsnet", npm_package_devDependencies_tsc_alias: "^1.8.8", npm_package_devDependencies_vite: "^5.0.12", npm_node_execpath: "/opt/buildhome/.nvm/versions/node/v20.19.1/bin/node", GIMME_NO_ENV_ALIAS: "true", ENABLE_STAKE_WITHDRAWAL: "false", SHLVL: "1", NETLIFY_SUBSTAGE_TIMES: "/tmp/substage_times.txt", npm_package_devDependencies_eslint_import_resolver_typescript: "^3.6.1", HOME: "/opt/buildhome", GELATO_RELAY_API_KEY: "ITkU3BICAYLu744hA_t1rMdMcUtiGHTC2G4cODIUwuY_", OLDPWD: "/opt/build/repo/dapp", npm_package_dependencies_ethers: "^6.9.2", RPC_URL_ETHEREUM: "https://eth-mainnet.g.alchemy.com/v2/KxGOKqgpp4CeCSe0-4POLBBNVfAsACLi", ACCOUNT_ID: "60274f5a25e90375cffc9590", NVM_BIN: "/opt/buildhome/.nvm/versions/node/v22.14.0/bin", NVM_INC: "/opt/buildhome/.nvm/versions/node/v22.14.0/include/node", rvm_stored_umask: "0022", CACHED_COMMIT_REF: "56a8abcf8f205b33ed9430104ee066c1ce38beba", MEZO_MAINNET_URL: "https://mezo.org", COREPACK_ROOT: "/opt/buildhome/.nvm/versions/node/v20.19.1/lib/node_modules/corepack", npm_package_scripts_build_api: "cd ../api && pnpm build", npm_package_devDependencies_typedoc_plugin_markdown: "^3.17.1", NODE_OPTIONS: "--max-old-space-size=8192", GIMME_TYPE: "binary", GIMME_ENV_PREFIX: "/opt/buildhome/.gimme/env", API_ENDPOINT_V2: "https://api.matsnet.mezo.org/api/v2/", GATSBY_TELEMETRY_DISABLED: "1", npm_package_devDependencies__types_fs_extra: "^11.0.4", ENABLE_EXPLORE_PAGE: "false", rvm_user_install_flag: "1", TBTC_API_ENDPOINT: "https://tbtc.api.matsnet.mezo.org/tbtc-api/v1/", npm_package_devDependencies_vite_plugin_dts: "^3.7.2", npm_package_dependencies__mezo_org_orangekit: "1.0.0-beta.39", POSTHOG_KEY: "phc_VTMS7GzJYJWIIUR6ax8xtHXBxbEoNFGi3nijgVQ5bja", GOROOT: "/opt/buildhome/.gimme/versions/go1.19.13.linux.amd64", MEZO_NETWORK: "testnet", API_ENDPOINT: "https://api.matsnet.mezo.org/api/v1/", COMMIT_REF: "11b7c649fcbe302b3b82dd6e7097b316126b06b0", ENABLE_DISCORD_ONBOARDING: "false", SANITY_PROJECT: "9zunswfd", npm_package_devDependencies_typedoc: "^0.25.7", npm_package_devDependencies_typescript: "^5.2.2", NVM_DIR: "/opt/buildhome/.nvm", npm_package_types: "dist/index.d.ts", ENABLE_NEW_MARKET_PAGE: "false", GIMME_GO_VERSION: "1.19.13", CUSTOM_RUBY: "0", COREPACK_ENABLE_DOWNLOAD_PROMPT: "1", npm_package_devDependencies_prettier: "^3.1.1", npm_package_devDependencies_vite_node: "^1.3.0", NETLIFY_BUILD_BASE: "/opt/build", DEPLOY_URL: "https://6814aae11bc9800008fe2eee--mezo-dapp.netlify.app", FORCE_COLOR: "1", npm_package_type: "module", npm_package_devDependencies_eslint_plugin_import: "^2.29.1", _: "/opt/buildhome/.nvm/versions/node/v20.19.1/bin/pnpm", ENABLE_DISCORD_SIGNUP: "false", rvm_bin_path: "/opt/buildhome/.rvm/bin", ENABLE_GOVERNANCE_PAGE: "false", npm_package_devDependencies__types_jest: "^29.5.11", npm_package_devDependencies_ts_jest: "^29.1.1", RUBY_VERSION: "2.7.2", WALLET_CONNECT_PROJECT_ID: "b4cb11ecae1076f6a76cc85be61df9af", IRBRC: "/opt/buildhome/.rvm/rubies/ruby-2.7.2/.irbrc", npm_config_registry: "https://registry.npmjs.org/", POSTHOG_HOST: "https://us.i.posthog.com", ENABLE_STAKE_MANAGEMENT: "false", STORED_JS_WORKSPACE_LOCATIONS: "dapp/ sdk/ solidity/ api/ tbtc-api/", npm_package_dependencies__mezo_org_orangekit_smart_account: "1.0.0-beta.23", SDK_NETWORK: "mainnet", ENABLE_VAULT_PAGE: "false", npm_package_scripts_lint_eslint_fix: "eslint . --fix", npm_package_dependencies__sentry_browser: "^7.110.1", GO_VERSION: "1.19.x", ENABLE_OVERVIEW_PAGE: "false", npm_config_node_gyp: "/opt/buildhome/.cache/node/corepack/v1/pnpm/8.13.1/dist/node_modules/node-gyp/bin/node-gyp.js", PATH: "/opt/build/repo/sdk/node_modules/.bin:/opt/buildhome/.cache/node/corepack/v1/pnpm/8.13.1/dist/node-gyp-bin:/opt/build/repo/node_modules/.bin:/opt/build/repo/dapp/node_modules/.bin:/opt/buildhome/.cache/node/corepack/v1/pnpm/8.13.1/dist/node-gyp-bin:/opt/build/repo/node_modules/.bin:/opt/build/repo/dapp/node_modules/.bin:/opt/buildhome/.cache/node/corepack/v1/pnpm/8.13.1/dist/node-gyp-bin:/opt/build/repo/node_modules/.bin:/opt/build/repo/node_modules/.bin:/opt/build/node_modules/.bin:/opt/node_modules/.bin:/node_modules/.bin:/opt/buildhome/.nvm/versions/node/v20.19.1/bin:/opt/buildhome/.nvm/versions/node/v20.19.1/bin:/opt/buildhome/.gimme/versions/go1.19.13.linux.amd64/bin:/opt/buildhome/.rvm/gems/ruby-2.7.2/bin:/opt/buildhome/.rvm/gems/ruby-2.7.2@global/bin:/opt/buildhome/.rvm/rubies/ruby-2.7.2/bin:/opt/buildhome/.local/share/mise/installs/python/3.13.3/bin:/opt/buildhome/.local/share/mise/shims:/home/linuxbrew/.linuxbrew/bin:/opt/buildhome/.swiftenv/bin:/opt/buildhome/.swiftenv/shims:/opt/buildhome/.php:/opt/buildhome/.binrc/bin:/opt/buildhome/.local/bin:/opt/buildhome/.bun/bin:/opt/buildhome/.deno/bin:/usr/local/rvm/bin:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin:/opt/buildhome/.cask/bin:/opt/buildhome/.gimme/bin:/opt/buildhome/.dotnet/tools:/opt/buildhome/.dotnet:/opt/buildhome/.cargo/bin:/opt/buildhome/.rvm/bin:/opt/build/repo/node_modules/.bin", NEXT_TELEMETRY_DISABLED: "1", NODE: "/opt/buildhome/.nvm/versions/node/v20.19.1/bin/node", npm_package_name: "sdk", npm_config_store_dir: "/opt/buildhome/.pnpm-store", COREPACK_ENABLE_AUTO_PIN: "0", CONTEXT: "production", GIMME_CGO_ENABLED: "true", HEAD: "matsnet", PULL_REQUEST: "false", BUILD_ID: "6814aae11bc9800008fe2eec", npm_config_frozen_lockfile: "", SHOW_DEPOSIT_INFO: "false", MY_RUBY_HOME: "/opt/buildhome/.rvm/rubies/ruby-2.7.2", DEPLOY_PRIME_URL: "https://matsnet--mezo-dapp.netlify.app", npm_package_devDependencies_vite_plugin_node: "^3.1.0", LANG: "en_US.UTF-8", npm_package_scripts_docs_create: "typedoc --options ./typedoc.json && pnpm format:fix", npm_package_devDependencies_eslint: "^8.57.0", npm_package_dependencies__keep_network_tbtc_v2_ts: "2.5.0-dev.2", SEGMENT_WRITE_KEY: "cFt5yEByVw608oMUGx84jocJMEM6qTNO", CYPRESS_CACHE_FOLDER: "./node_modules/.cache/CypressBinary", npm_package_main: "dist/index.js", npm_package_scripts_format_fix: "pnpm run lint:eslint:fix && pnpm run lint:config:fix", npm_lifecycle_script: "pnpm build:api && pnpm build:typechain && vite build && pnpm build:source", npm_package_scripts_test: "jest", npm_package_scripts_lint_eslint: "eslint .", RPC_URL_MEZO: "https://rpc.test.mezo.org/", GOCACHE: "/opt/buildhome/.gimme_cache/gocache", GOPATH: "/opt/buildhome/.gimme_cache/gopath", npm_package_version: "0.1.0", npm_lifecycle_event: "build", NODE_PATH: "/opt/build/repo/node_modules/.pnpm/vite@5.0.13_@types+node@20.10.6/node_modules/vite/bin/node_modules:/opt/build/repo/node_modules/.pnpm/vite@5.0.13_@types+node@20.10.6/node_modules/vite/node_modules:/opt/build/repo/node_modules/.pnpm/vite@5.0.13_@types+node@20.10.6/node_modules:/opt/build/repo/node_modules/.pnpm/node_modules", rvm_prefix: "/opt/buildhome", rvm_loaded_flag: "1", VITE_GTM_ID: "GTM-WRZ2MKG7", npm_package_scripts_build: "pnpm build:api && pnpm build:typechain && vite build && pnpm build:source", npm_package_devDependencies__thesis_co_eslint_config: "^0.6.1", GEM_HOME: "/opt/buildhome/.rvm/gems/ruby-2.7.2", npm_package_dependencies__mezo_api: "workspace:api@*", npm_package_dependencies__mezo_contracts: "workspace:@mezo-org/contracts@*", DEPLOY_ID: "6814aae11bc9800008fe2eee", rvm_version: "1.29.12 (latest)", SENTRY_DSN: "https://cce8c24d266a6c14be70566e77b79280@o4507050091675648.ingest.us.sentry.io/4507050486267904", ENABLE_SWAPS: "false", BUGSNAG_KEY_BUILD_INFO: "8b2ab336661bf29d58011117d9c997d3", npm_package_license: "GPL-3.0", PASSPORT_API_URL: "https://api.matsnet.mezo.org", NETLIFY: "true", REPOSITORY_URL: "https://github.com/thesis/meso-portal", SITE_NAME: "mezo-dapp", ENABLE_BORROW_LIQUIDATIONS_PRICES: "false", npm_package_scripts_format: "pnpm run lint:eslint && pnpm run lint:config", PIPENV_VENV_IN_PROJECT: "1", PWD: "/opt/build/repo/sdk", SUPPORTED_PORTAL_ABI_VERSION: "migrations-upgrade", GEM_PATH: "/opt/buildhome/.rvm/gems/ruby-2.7.2:/opt/buildhome/.rvm/gems/ruby-2.7.2@global", LC_ALL: "en_US.UTF-8", npm_package_scripts_lint_config_fix: "prettier -w '**/*.@(json|yaml|toml|md)'", npm_execpath: "/opt/buildhome/.cache/node/corepack/v1/pnpm/8.13.1/bin/pnpm.cjs", DISABLED_ASSETS: '["LBTC", "aBTC", "intBTC"]', SANITY_DATASET: "production", NVM_CD_FLAGS: "", npm_package_devDependencies_fs_extra: "^11.2.0", npm_config_recursive: "true", SENTRY_ENV: "production", PNPM_SCRIPT_SRC_DIR: "/opt/build/repo/sdk", npm_package_scripts_build_typechain: "cd ../solidity && pnpm build", npm_command: "run-script", FEATURE_FLAGS: "bitballoon_site_labels_enabled,bitballoon_buildbot_cmd_as_env,bitballoon_background_envelope_request,project_razz_ui,project_snubbull_ui,cli_golang_use_al2,bitballoon_disable_domain_spam_protection,bitballoon-subscription-processing-flag,bitballoon_websocket_for_first_deploy,project_yanmega_ui,bitballoon_filter_deleted_builds,buildbot_firebase_bulk_flush,build_warn_upcoming_system_version_change,bitballoon_manifest_diff_comparison,verify_domain_using_edge_challenge,project_flamigo_ui,buildbot_gatsby_telemetry_flag,buildbot_auto_install_bun,bitballoon_increase_deploy_files_slice,project_roots_ui,proxy-remove-limit-on-streaming-response-size-for-functions,bitballoon_use_custom_domain_as_cn,project_lugia_ui,project_zubat_ui,project_rutherford_ui,project_goomy_ui,bitballoon_allow_adding_dns_zone_with_shared_ownership,bitballoon_new_default_functions_region_enabled,project_floatzel_ui,bitballoon_set_domain_capability_to_zero_hard_restriction,cli_integration_installations_meta,project_archen_ui,project_jiktomite_ui,project_dewgong_ui,zisi_fix_symlinks,bitballoon-include-new-authorized-resource-verbs,edge_functions_cache_cli,gatsby_plugin_prerelease,zisi_log_dynamic_imports,bitballoon_cert_purge_via_netlify_server,bitballoon_send_pro_trial_ended_email,bitballoon_do_not_error_ready_deploy,bitballoon-dev-server-tiers,edge_functions_bootstrap_cpu_timing_per_function,zisi_functions_api_v2,edge_functions_invalid_config_throw,bitballoon-remove-autosignup,edge_functions_bootstrap_log_passthrough_errors,project_bonsly_ui,bitballoon_save_all_members,bitballoon_account_level_custom_domain_suffix,project_shedinja_ui,project_lunatone_ui,project_toucannon_ui,bitballoon_use_analytics_for_functions_billing,bitballoon-disable-cache-network,bitballoon_in_memory_deploy_file_tracker,edge_functions_cache_deno_dir,project_wobbuffet_ui,project_electabuzz_ui,project_brambleghast_ui,bitballoon_disable_purge_related_certs,bitballoon_custom_deploy_retention_enabled,buildbot_zisi_system_log,project_marshadow_ui,bitballoon_restrict_sso_login_access,bitballoon_skip_create_proxy_routing,bitballoon_manifest_backfill,bitballoon_mime_type_use_marcel,buildbot_skip_retry,bitballoon_use_deploys_state_index,bitballoon-check-access-on-token-owner,bitballoon_silent_deploy_cancellation,bitballoon_delegate_subdomain_to_netlify,kafka_firebase_send_loglevel_to_firebase,project_therian_ui,dev_server_cache,bitballoon_sort_and_filter_sites,bitballoon_reprocess_processing_deploys,project_tinkatink_ui,edge_functions_config_export,edge_functions_correct_order,project_sunkern_ui,first-spirit-connector,project_togekiss_ui,netlify_build_updated_plugin_compatibility,bitballoon_netlify_employee_disable,zisi_golang_use_al2,project_kabutops_ui,bitballoon-feature-flag-test,bitballoon_mining_detection_enabled,bitballoon_zuora_contact_geolocation,project_samurott_ui,bitballoon_purge_via_netlify_server,project_snorlax_ui,project_deploy_configuration_api_use_per_function_configuration_files,bitballoon_apply_account_password_fix,bitballoon_soft_delete_errored_deploys,bitballoon_prevent_sites_using_envelope_from_calling_old_env,project_ceruledge_ui,bitballoon-developer-role-write-enabled,project_voltorb_ui,buildbot_js_workspace_cache,ops_sort_and_filter_sites_ui,project_shroomish_ui,project_lucario_bitballoon,bitballoon_exclude_deploy_previews_from_deploy_badge,bitballoon_delete_firebase_deploy_logs,buildbot_tracing_in_ntl_build,bitballoon_blobs_dynamodb,project_teddiursa_ui,edge_functions_npm_modules,purge_cache_on_site_transfer,bitballoon_hide_site_description,bitballoon_lambda_states_enabled,project_thwackey_ui,buildbot_fetch_integrations,netlify_build_reduced_output,bitballoon_disabled_cert_purge_via_nats,bitballoon_purge_only_branch_on_deploy,project_flabebe_ui,buildbot_stage_install_dependencies,edge_functions_bootstrap_strip_content_length,bitballoon_extended_domain_validations,project_plusle_ui,project_wishiwashi_ui,bitballoon-free-accounts-cannot-accrue-charges,build_inject_blobs_context,bitballoon_resolve_custom_domain_suffixes,project_stoutland_ui,bitballoon_use_expiry_based_cert_lookup,bitballoon_cleanup_assets_on_submission_delete,bitballoon-track-email-usage,bitballoon_force_in_memory_deploy_file_tracker,bitballoon_zuora_contact_geolocation_sandbox,project_skarmory_ui,bitballoon_auto_accept_git_committers,project_diglett_ui,project_palpitoad_ui,bitballoon-use-role-associations,remove-unused-site-capabilities,bitballoon_enforce_nf_use_mongo_secondary,bitballoon_blobs_dynamodb_for_zip_deploys,send_build_bot_token_to_jigsaw,edge_functions_bootstrap_bypass_response_headers,project_minun_ui,buildbot_tracing_in_ntl_build_via_preloading,bitballoon-unified-core-and-create-roles,bitballoon_disable_purge_via_nats,zisi_add_metadata_file,bitballoon_delete_function_schedules,bitballoon_org_owner_role_enabled,bitballoon_destroy_only_dns_records_on_cancel,bitballoon_switch_asset_blobstore_order,bitballoon_track_last_user_activity,project_yamper_ui,bitballoon_traffic_exceptions_enabled,bitballoon_use_analytics_for_build_minutes_top_queries,project_spheal_ui,bitballoon_deploy_retention_soft_delete,project_toxapex_ui,ops_advanced_deploy_filtering_ui,remove-org-owner-ids-field,zisi_use_latest_babel_version,bitballoon_site_spam_classification,set_user_registration_index,bitballoon-free-is-free,error_builds_on_extension_fetch_fail,bitballoon_autoban_pro_background_abusers,zisi_disallow_new_entry_name,bitballoon_show_deploy_expiry_enabled,bitballoon_disable_netlify_app_cert_lookup,bitballoon-noble,bitballoon_single_player_starter,project_greninja_ui,netlify_build_deploy_configuration_api,project_deoxys_ui,buildbot_node_modules_bin_no_precedence,bitballoon_get_new_zone_info_on_create,bitballoon_pass_active_feature_flags,edge_functions_system_logger,bitballoon_deploy_transition_notifications,project_alomomola_ui,buildbot_custom_build_cache,project_mewtwo_ui,bitballoon_build_settings_multiple_events,bitballoon_deploy_delete_notifications,bitballoon_kafka_firebase_kafka_delivery,configurable_sso_token_expiration,project_heliolisk_ui,bitballoon-read-site-ids-from-member,edge_functions_fail_unsupported_regex,project_sprigatito_ui,project_salamence_ui,zisi_go_drop_runtime_override,edge_functions_path_urlpattern,project_unown_ui,build_fetch_integrations,ops_scope_edge_function_logs_to_deploy_ui,zisi_add_version_file,soft_delete_dns_records,bitballoon_forced_zorb_migration,reviewer_as_a_member,netlify_build_frameworks_api,bitballoon-block-overused-email,project_audino_ui,edge_bundler_pcre_regexp,project_tadbulb_def_ui,cli_fetch_integrations,project_gardevoir_ui,cleanup_zone_when_disabling,bitballoon_branch_as_subdomain_for_buildbot_deploys,bitballoon_use_analytics_for_build_minutes_usage,project_ortegas_ui,no-prefix-cli-test-ff,functions_inherit_build_nodejs_version,project_omastar_ui,bitballoon-use-usage-exceeded-state,build_plugins_use_prerelease,bitballoon_new_accounts_use_envelope,project_fomantis_ui,project_cursola_ui,project_lucario_ui,bitballoon_enable_orb_for_new_customers,bitballoon_periodic_soft_delete_deploys,project_treecko_ui,bitballoon_custom_function_routes", ENABLE_DEFAULT_ANALYTICS_CONSENT: "false", SWIFTENV_ROOT: "/opt/buildhome/.swiftenv", rvm_path: "/opt/buildhome/.rvm", INIT_CWD: "/opt/build/repo/sdk", npm_package_dependencies_ethers_v5: "npm:ethers@^5.5.2", NODE_ENV: "production" };
const API_ENDPOINT = define_process_env_default$3.API_ENDPOINT;
const API_ENDPOINT_V2 = define_process_env_default$3.API_ENDPOINT_V2;
const TBTC_API_ENDPOINT = define_process_env_default$3.TBTC_API_ENDPOINT;
var define_process_env_default$2 = { npm_package_scripts_build_source: "node scripts/copy-original-ts-files.mjs", npm_package_devDependencies__types_node: "^20.10.6", npm_package_devDependencies_ts_node: "^10.9.2", npm_package_dependencies__orangekit_sign_in_with_wallet: "1.0.0-beta.6", HOST_NODE_IP: "10.71.17.84", INTEGRATION_TEST: "", SITE_ID: "64ff34ae-c815-4397-9ed0-f7eabbfb7032", npm_package_scripts_lint_config: "prettier -c '**/*.@(json|yaml|toml|md)'", npm_package_dependencies__safe_global_safe_core_sdk_types: "4.0.1", LANGUAGE: "en_US:en", ENABLE_ZERO_LOCK_TIME: "false", npm_package_devDependencies_jest: "^29.7.0", npm_config_user_agent: "pnpm/8.13.1 npm/? node/v20.19.1 linux x64", ENABLE_SEPARATE_MEZO_CHAINS: "false", RVM_DIR: "/opt/buildhome/.rvm", SENTRY_AUTH_TOKEN: "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", CI: "true", NODE_VERSION: "v20.19.1", YARN_VERSION: "1.22.19", ENABLE_BORROW_PRICE_CHANGES: "false", GOLDSKY_MEZO_SUBGRAPH_URL: "https://api.goldsky.com/api/public/project_cm6ks2x8um4aj01uj8nwg1f6r/subgraphs/mezo-testnet/0.1.0-dev.3/gn", URL: "https://mezo.org", BRANCH: "matsnet", npm_package_devDependencies_tsc_alias: "^1.8.8", npm_package_devDependencies_vite: "^5.0.12", npm_node_execpath: "/opt/buildhome/.nvm/versions/node/v20.19.1/bin/node", GIMME_NO_ENV_ALIAS: "true", ENABLE_STAKE_WITHDRAWAL: "false", SHLVL: "1", NETLIFY_SUBSTAGE_TIMES: "/tmp/substage_times.txt", npm_package_devDependencies_eslint_import_resolver_typescript: "^3.6.1", HOME: "/opt/buildhome", GELATO_RELAY_API_KEY: "ITkU3BICAYLu744hA_t1rMdMcUtiGHTC2G4cODIUwuY_", OLDPWD: "/opt/build/repo/dapp", npm_package_dependencies_ethers: "^6.9.2", RPC_URL_ETHEREUM: "https://eth-mainnet.g.alchemy.com/v2/KxGOKqgpp4CeCSe0-4POLBBNVfAsACLi", ACCOUNT_ID: "60274f5a25e90375cffc9590", NVM_BIN: "/opt/buildhome/.nvm/versions/node/v22.14.0/bin", NVM_INC: "/opt/buildhome/.nvm/versions/node/v22.14.0/include/node", rvm_stored_umask: "0022", CACHED_COMMIT_REF: "56a8abcf8f205b33ed9430104ee066c1ce38beba", MEZO_MAINNET_URL: "https://mezo.org", COREPACK_ROOT: "/opt/buildhome/.nvm/versions/node/v20.19.1/lib/node_modules/corepack", npm_package_scripts_build_api: "cd ../api && pnpm build", npm_package_devDependencies_typedoc_plugin_markdown: "^3.17.1", NODE_OPTIONS: "--max-old-space-size=8192", GIMME_TYPE: "binary", GIMME_ENV_PREFIX: "/opt/buildhome/.gimme/env", API_ENDPOINT_V2: "https://api.matsnet.mezo.org/api/v2/", GATSBY_TELEMETRY_DISABLED: "1", npm_package_devDependencies__types_fs_extra: "^11.0.4", ENABLE_EXPLORE_PAGE: "false", rvm_user_install_flag: "1", TBTC_API_ENDPOINT: "https://tbtc.api.matsnet.mezo.org/tbtc-api/v1/", npm_package_devDependencies_vite_plugin_dts: "^3.7.2", npm_package_dependencies__mezo_org_orangekit: "1.0.0-beta.39", POSTHOG_KEY: "phc_VTMS7GzJYJWIIUR6ax8xtHXBxbEoNFGi3nijgVQ5bja", GOROOT: "/opt/buildhome/.gimme/versions/go1.19.13.linux.amd64", MEZO_NETWORK: "testnet", API_ENDPOINT: "https://api.matsnet.mezo.org/api/v1/", COMMIT_REF: "11b7c649fcbe302b3b82dd6e7097b316126b06b0", ENABLE_DISCORD_ONBOARDING: "false", SANITY_PROJECT: "9zunswfd", npm_package_devDependencies_typedoc: "^0.25.7", npm_package_devDependencies_typescript: "^5.2.2", NVM_DIR: "/opt/buildhome/.nvm", npm_package_types: "dist/index.d.ts", ENABLE_NEW_MARKET_PAGE: "false", GIMME_GO_VERSION: "1.19.13", CUSTOM_RUBY: "0", COREPACK_ENABLE_DOWNLOAD_PROMPT: "1", npm_package_devDependencies_prettier: "^3.1.1", npm_package_devDependencies_vite_node: "^1.3.0", NETLIFY_BUILD_BASE: "/opt/build", DEPLOY_URL: "https://6814aae11bc9800008fe2eee--mezo-dapp.netlify.app", FORCE_COLOR: "1", npm_package_type: "module", npm_package_devDependencies_eslint_plugin_import: "^2.29.1", _: "/opt/buildhome/.nvm/versions/node/v20.19.1/bin/pnpm", ENABLE_DISCORD_SIGNUP: "false", rvm_bin_path: "/opt/buildhome/.rvm/bin", ENABLE_GOVERNANCE_PAGE: "false", npm_package_devDependencies__types_jest: "^29.5.11", npm_package_devDependencies_ts_jest: "^29.1.1", RUBY_VERSION: "2.7.2", WALLET_CONNECT_PROJECT_ID: "b4cb11ecae1076f6a76cc85be61df9af", IRBRC: "/opt/buildhome/.rvm/rubies/ruby-2.7.2/.irbrc", npm_config_registry: "https://registry.npmjs.org/", POSTHOG_HOST: "https://us.i.posthog.com", ENABLE_STAKE_MANAGEMENT: "false", STORED_JS_WORKSPACE_LOCATIONS: "dapp/ sdk/ solidity/ api/ tbtc-api/", npm_package_dependencies__mezo_org_orangekit_smart_account: "1.0.0-beta.23", SDK_NETWORK: "mainnet", ENABLE_VAULT_PAGE: "false", npm_package_scripts_lint_eslint_fix: "eslint . --fix", npm_package_dependencies__sentry_browser: "^7.110.1", GO_VERSION: "1.19.x", ENABLE_OVERVIEW_PAGE: "false", npm_config_node_gyp: "/opt/buildhome/.cache/node/corepack/v1/pnpm/8.13.1/dist/node_modules/node-gyp/bin/node-gyp.js", PATH: "/opt/build/repo/sdk/node_modules/.bin:/opt/buildhome/.cache/node/corepack/v1/pnpm/8.13.1/dist/node-gyp-bin:/opt/build/repo/node_modules/.bin:/opt/build/repo/dapp/node_modules/.bin:/opt/buildhome/.cache/node/corepack/v1/pnpm/8.13.1/dist/node-gyp-bin:/opt/build/repo/node_modules/.bin:/opt/build/repo/dapp/node_modules/.bin:/opt/buildhome/.cache/node/corepack/v1/pnpm/8.13.1/dist/node-gyp-bin:/opt/build/repo/node_modules/.bin:/opt/build/repo/node_modules/.bin:/opt/build/node_modules/.bin:/opt/node_modules/.bin:/node_modules/.bin:/opt/buildhome/.nvm/versions/node/v20.19.1/bin:/opt/buildhome/.nvm/versions/node/v20.19.1/bin:/opt/buildhome/.gimme/versions/go1.19.13.linux.amd64/bin:/opt/buildhome/.rvm/gems/ruby-2.7.2/bin:/opt/buildhome/.rvm/gems/ruby-2.7.2@global/bin:/opt/buildhome/.rvm/rubies/ruby-2.7.2/bin:/opt/buildhome/.local/share/mise/installs/python/3.13.3/bin:/opt/buildhome/.local/share/mise/shims:/home/linuxbrew/.linuxbrew/bin:/opt/buildhome/.swiftenv/bin:/opt/buildhome/.swiftenv/shims:/opt/buildhome/.php:/opt/buildhome/.binrc/bin:/opt/buildhome/.local/bin:/opt/buildhome/.bun/bin:/opt/buildhome/.deno/bin:/usr/local/rvm/bin:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin:/opt/buildhome/.cask/bin:/opt/buildhome/.gimme/bin:/opt/buildhome/.dotnet/tools:/opt/buildhome/.dotnet:/opt/buildhome/.cargo/bin:/opt/buildhome/.rvm/bin:/opt/build/repo/node_modules/.bin", NEXT_TELEMETRY_DISABLED: "1", NODE: "/opt/buildhome/.nvm/versions/node/v20.19.1/bin/node", npm_package_name: "sdk", npm_config_store_dir: "/opt/buildhome/.pnpm-store", COREPACK_ENABLE_AUTO_PIN: "0", CONTEXT: "production", GIMME_CGO_ENABLED: "true", HEAD: "matsnet", PULL_REQUEST: "false", BUILD_ID: "6814aae11bc9800008fe2eec", npm_config_frozen_lockfile: "", SHOW_DEPOSIT_INFO: "false", MY_RUBY_HOME: "/opt/buildhome/.rvm/rubies/ruby-2.7.2", DEPLOY_PRIME_URL: "https://matsnet--mezo-dapp.netlify.app", npm_package_devDependencies_vite_plugin_node: "^3.1.0", LANG: "en_US.UTF-8", npm_package_scripts_docs_create: "typedoc --options ./typedoc.json && pnpm format:fix", npm_package_devDependencies_eslint: "^8.57.0", npm_package_dependencies__keep_network_tbtc_v2_ts: "2.5.0-dev.2", SEGMENT_WRITE_KEY: "cFt5yEByVw608oMUGx84jocJMEM6qTNO", CYPRESS_CACHE_FOLDER: "./node_modules/.cache/CypressBinary", npm_package_main: "dist/index.js", npm_package_scripts_format_fix: "pnpm run lint:eslint:fix && pnpm run lint:config:fix", npm_lifecycle_script: "pnpm build:api && pnpm build:typechain && vite build && pnpm build:source", npm_package_scripts_test: "jest", npm_package_scripts_lint_eslint: "eslint .", RPC_URL_MEZO: "https://rpc.test.mezo.org/", GOCACHE: "/opt/buildhome/.gimme_cache/gocache", GOPATH: "/opt/buildhome/.gimme_cache/gopath", npm_package_version: "0.1.0", npm_lifecycle_event: "build", NODE_PATH: "/opt/build/repo/node_modules/.pnpm/vite@5.0.13_@types+node@20.10.6/node_modules/vite/bin/node_modules:/opt/build/repo/node_modules/.pnpm/vite@5.0.13_@types+node@20.10.6/node_modules/vite/node_modules:/opt/build/repo/node_modules/.pnpm/vite@5.0.13_@types+node@20.10.6/node_modules:/opt/build/repo/node_modules/.pnpm/node_modules", rvm_prefix: "/opt/buildhome", rvm_loaded_flag: "1", VITE_GTM_ID: "GTM-WRZ2MKG7", npm_package_scripts_build: "pnpm build:api && pnpm build:typechain && vite build && pnpm build:source", npm_package_devDependencies__thesis_co_eslint_config: "^0.6.1", GEM_HOME: "/opt/buildhome/.rvm/gems/ruby-2.7.2", npm_package_dependencies__mezo_api: "workspace:api@*", npm_package_dependencies__mezo_contracts: "workspace:@mezo-org/contracts@*", DEPLOY_ID: "6814aae11bc9800008fe2eee", rvm_version: "1.29.12 (latest)", SENTRY_DSN: "https://cce8c24d266a6c14be70566e77b79280@o4507050091675648.ingest.us.sentry.io/4507050486267904", ENABLE_SWAPS: "false", BUGSNAG_KEY_BUILD_INFO: "8b2ab336661bf29d58011117d9c997d3", npm_package_license: "GPL-3.0", PASSPORT_API_URL: "https://api.matsnet.mezo.org", NETLIFY: "true", REPOSITORY_URL: "https://github.com/thesis/meso-portal", SITE_NAME: "mezo-dapp", ENABLE_BORROW_LIQUIDATIONS_PRICES: "false", npm_package_scripts_format: "pnpm run lint:eslint && pnpm run lint:config", PIPENV_VENV_IN_PROJECT: "1", PWD: "/opt/build/repo/sdk", SUPPORTED_PORTAL_ABI_VERSION: "migrations-upgrade", GEM_PATH: "/opt/buildhome/.rvm/gems/ruby-2.7.2:/opt/buildhome/.rvm/gems/ruby-2.7.2@global", LC_ALL: "en_US.UTF-8", npm_package_scripts_lint_config_fix: "prettier -w '**/*.@(json|yaml|toml|md)'", npm_execpath: "/opt/buildhome/.cache/node/corepack/v1/pnpm/8.13.1/bin/pnpm.cjs", DISABLED_ASSETS: '["LBTC", "aBTC", "intBTC"]', SANITY_DATASET: "production", NVM_CD_FLAGS: "", npm_package_devDependencies_fs_extra: "^11.2.0", npm_config_recursive: "true", SENTRY_ENV: "production", PNPM_SCRIPT_SRC_DIR: "/opt/build/repo/sdk", npm_package_scripts_build_typechain: "cd ../solidity && pnpm build", npm_command: "run-script", FEATURE_FLAGS: "bitballoon_site_labels_enabled,bitballoon_buildbot_cmd_as_env,bitballoon_background_envelope_request,project_razz_ui,project_snubbull_ui,cli_golang_use_al2,bitballoon_disable_domain_spam_protection,bitballoon-subscription-processing-flag,bitballoon_websocket_for_first_deploy,project_yanmega_ui,bitballoon_filter_deleted_builds,buildbot_firebase_bulk_flush,build_warn_upcoming_system_version_change,bitballoon_manifest_diff_comparison,verify_domain_using_edge_challenge,project_flamigo_ui,buildbot_gatsby_telemetry_flag,buildbot_auto_install_bun,bitballoon_increase_deploy_files_slice,project_roots_ui,proxy-remove-limit-on-streaming-response-size-for-functions,bitballoon_use_custom_domain_as_cn,project_lugia_ui,project_zubat_ui,project_rutherford_ui,project_goomy_ui,bitballoon_allow_adding_dns_zone_with_shared_ownership,bitballoon_new_default_functions_region_enabled,project_floatzel_ui,bitballoon_set_domain_capability_to_zero_hard_restriction,cli_integration_installations_meta,project_archen_ui,project_jiktomite_ui,project_dewgong_ui,zisi_fix_symlinks,bitballoon-include-new-authorized-resource-verbs,edge_functions_cache_cli,gatsby_plugin_prerelease,zisi_log_dynamic_imports,bitballoon_cert_purge_via_netlify_server,bitballoon_send_pro_trial_ended_email,bitballoon_do_not_error_ready_deploy,bitballoon-dev-server-tiers,edge_functions_bootstrap_cpu_timing_per_function,zisi_functions_api_v2,edge_functions_invalid_config_throw,bitballoon-remove-autosignup,edge_functions_bootstrap_log_passthrough_errors,project_bonsly_ui,bitballoon_save_all_members,bitballoon_account_level_custom_domain_suffix,project_shedinja_ui,project_lunatone_ui,project_toucannon_ui,bitballoon_use_analytics_for_functions_billing,bitballoon-disable-cache-network,bitballoon_in_memory_deploy_file_tracker,edge_functions_cache_deno_dir,project_wobbuffet_ui,project_electabuzz_ui,project_brambleghast_ui,bitballoon_disable_purge_related_certs,bitballoon_custom_deploy_retention_enabled,buildbot_zisi_system_log,project_marshadow_ui,bitballoon_restrict_sso_login_access,bitballoon_skip_create_proxy_routing,bitballoon_manifest_backfill,bitballoon_mime_type_use_marcel,buildbot_skip_retry,bitballoon_use_deploys_state_index,bitballoon-check-access-on-token-owner,bitballoon_silent_deploy_cancellation,bitballoon_delegate_subdomain_to_netlify,kafka_firebase_send_loglevel_to_firebase,project_therian_ui,dev_server_cache,bitballoon_sort_and_filter_sites,bitballoon_reprocess_processing_deploys,project_tinkatink_ui,edge_functions_config_export,edge_functions_correct_order,project_sunkern_ui,first-spirit-connector,project_togekiss_ui,netlify_build_updated_plugin_compatibility,bitballoon_netlify_employee_disable,zisi_golang_use_al2,project_kabutops_ui,bitballoon-feature-flag-test,bitballoon_mining_detection_enabled,bitballoon_zuora_contact_geolocation,project_samurott_ui,bitballoon_purge_via_netlify_server,project_snorlax_ui,project_deploy_configuration_api_use_per_function_configuration_files,bitballoon_apply_account_password_fix,bitballoon_soft_delete_errored_deploys,bitballoon_prevent_sites_using_envelope_from_calling_old_env,project_ceruledge_ui,bitballoon-developer-role-write-enabled,project_voltorb_ui,buildbot_js_workspace_cache,ops_sort_and_filter_sites_ui,project_shroomish_ui,project_lucario_bitballoon,bitballoon_exclude_deploy_previews_from_deploy_badge,bitballoon_delete_firebase_deploy_logs,buildbot_tracing_in_ntl_build,bitballoon_blobs_dynamodb,project_teddiursa_ui,edge_functions_npm_modules,purge_cache_on_site_transfer,bitballoon_hide_site_description,bitballoon_lambda_states_enabled,project_thwackey_ui,buildbot_fetch_integrations,netlify_build_reduced_output,bitballoon_disabled_cert_purge_via_nats,bitballoon_purge_only_branch_on_deploy,project_flabebe_ui,buildbot_stage_install_dependencies,edge_functions_bootstrap_strip_content_length,bitballoon_extended_domain_validations,project_plusle_ui,project_wishiwashi_ui,bitballoon-free-accounts-cannot-accrue-charges,build_inject_blobs_context,bitballoon_resolve_custom_domain_suffixes,project_stoutland_ui,bitballoon_use_expiry_based_cert_lookup,bitballoon_cleanup_assets_on_submission_delete,bitballoon-track-email-usage,bitballoon_force_in_memory_deploy_file_tracker,bitballoon_zuora_contact_geolocation_sandbox,project_skarmory_ui,bitballoon_auto_accept_git_committers,project_diglett_ui,project_palpitoad_ui,bitballoon-use-role-associations,remove-unused-site-capabilities,bitballoon_enforce_nf_use_mongo_secondary,bitballoon_blobs_dynamodb_for_zip_deploys,send_build_bot_token_to_jigsaw,edge_functions_bootstrap_bypass_response_headers,project_minun_ui,buildbot_tracing_in_ntl_build_via_preloading,bitballoon-unified-core-and-create-roles,bitballoon_disable_purge_via_nats,zisi_add_metadata_file,bitballoon_delete_function_schedules,bitballoon_org_owner_role_enabled,bitballoon_destroy_only_dns_records_on_cancel,bitballoon_switch_asset_blobstore_order,bitballoon_track_last_user_activity,project_yamper_ui,bitballoon_traffic_exceptions_enabled,bitballoon_use_analytics_for_build_minutes_top_queries,project_spheal_ui,bitballoon_deploy_retention_soft_delete,project_toxapex_ui,ops_advanced_deploy_filtering_ui,remove-org-owner-ids-field,zisi_use_latest_babel_version,bitballoon_site_spam_classification,set_user_registration_index,bitballoon-free-is-free,error_builds_on_extension_fetch_fail,bitballoon_autoban_pro_background_abusers,zisi_disallow_new_entry_name,bitballoon_show_deploy_expiry_enabled,bitballoon_disable_netlify_app_cert_lookup,bitballoon-noble,bitballoon_single_player_starter,project_greninja_ui,netlify_build_deploy_configuration_api,project_deoxys_ui,buildbot_node_modules_bin_no_precedence,bitballoon_get_new_zone_info_on_create,bitballoon_pass_active_feature_flags,edge_functions_system_logger,bitballoon_deploy_transition_notifications,project_alomomola_ui,buildbot_custom_build_cache,project_mewtwo_ui,bitballoon_build_settings_multiple_events,bitballoon_deploy_delete_notifications,bitballoon_kafka_firebase_kafka_delivery,configurable_sso_token_expiration,project_heliolisk_ui,bitballoon-read-site-ids-from-member,edge_functions_fail_unsupported_regex,project_sprigatito_ui,project_salamence_ui,zisi_go_drop_runtime_override,edge_functions_path_urlpattern,project_unown_ui,build_fetch_integrations,ops_scope_edge_function_logs_to_deploy_ui,zisi_add_version_file,soft_delete_dns_records,bitballoon_forced_zorb_migration,reviewer_as_a_member,netlify_build_frameworks_api,bitballoon-block-overused-email,project_audino_ui,edge_bundler_pcre_regexp,project_tadbulb_def_ui,cli_fetch_integrations,project_gardevoir_ui,cleanup_zone_when_disabling,bitballoon_branch_as_subdomain_for_buildbot_deploys,bitballoon_use_analytics_for_build_minutes_usage,project_ortegas_ui,no-prefix-cli-test-ff,functions_inherit_build_nodejs_version,project_omastar_ui,bitballoon-use-usage-exceeded-state,build_plugins_use_prerelease,bitballoon_new_accounts_use_envelope,project_fomantis_ui,project_cursola_ui,project_lucario_ui,bitballoon_enable_orb_for_new_customers,bitballoon_periodic_soft_delete_deploys,project_treecko_ui,bitballoon_custom_function_routes", ENABLE_DEFAULT_ANALYTICS_CONSENT: "false", SWIFTENV_ROOT: "/opt/buildhome/.swiftenv", rvm_path: "/opt/buildhome/.rvm", INIT_CWD: "/opt/build/repo/sdk", npm_package_dependencies_ethers_v5: "npm:ethers@^5.5.2", NODE_ENV: "production" };
const CHAIN_ID = {
  local: 31337,
  sepolia: 11155111,
  mainnet: 1,
  testnet: 31611,
  mezo: 31611
  // TODO: Add correct chain ID after deployment
};
const SECOND = 1e3;
const MINUTE = 60 * SECOND;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;
const WEEK = 7 * DAY;
const YEAR = 365 * DAY;
const ZERO_ADDRESS = "0x0000000000000000000000000000000000000000";
const APPROVE_AND_CALL_TOKENS = ["tBTC"];
const MEZO_STABLECOINS = [
  "thUSD",
  "crvUSD",
  "USDe",
  "USDC",
  "USDT",
  "DAI",
  "wM",
  "T"
];
const STBTC_TOKENS = ["stBTC", "crv-stBTC"];
const SUPERSTACK_TOKENS = ["tBTC", "WBTC"];
const MIGRATABLE_TOKENS = ["WBTC"];
const SENTRY_ENVIRONMENT = {
  production: "production",
  staging: "staging",
  local: "local"
};
const SUPPORTED_PORTAL_ABI_VERSION = define_process_env_default$2.SUPPORTED_PORTAL_ABI_VERSION;
var define_process_env_default$1 = { npm_package_scripts_build_source: "node scripts/copy-original-ts-files.mjs", npm_package_devDependencies__types_node: "^20.10.6", npm_package_devDependencies_ts_node: "^10.9.2", npm_package_dependencies__orangekit_sign_in_with_wallet: "1.0.0-beta.6", HOST_NODE_IP: "10.71.17.84", INTEGRATION_TEST: "", SITE_ID: "64ff34ae-c815-4397-9ed0-f7eabbfb7032", npm_package_scripts_lint_config: "prettier -c '**/*.@(json|yaml|toml|md)'", npm_package_dependencies__safe_global_safe_core_sdk_types: "4.0.1", LANGUAGE: "en_US:en", ENABLE_ZERO_LOCK_TIME: "false", npm_package_devDependencies_jest: "^29.7.0", npm_config_user_agent: "pnpm/8.13.1 npm/? node/v20.19.1 linux x64", ENABLE_SEPARATE_MEZO_CHAINS: "false", RVM_DIR: "/opt/buildhome/.rvm", SENTRY_AUTH_TOKEN: "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", CI: "true", NODE_VERSION: "v20.19.1", YARN_VERSION: "1.22.19", ENABLE_BORROW_PRICE_CHANGES: "false", GOLDSKY_MEZO_SUBGRAPH_URL: "https://api.goldsky.com/api/public/project_cm6ks2x8um4aj01uj8nwg1f6r/subgraphs/mezo-testnet/0.1.0-dev.3/gn", URL: "https://mezo.org", BRANCH: "matsnet", npm_package_devDependencies_tsc_alias: "^1.8.8", npm_package_devDependencies_vite: "^5.0.12", npm_node_execpath: "/opt/buildhome/.nvm/versions/node/v20.19.1/bin/node", GIMME_NO_ENV_ALIAS: "true", ENABLE_STAKE_WITHDRAWAL: "false", SHLVL: "1", NETLIFY_SUBSTAGE_TIMES: "/tmp/substage_times.txt", npm_package_devDependencies_eslint_import_resolver_typescript: "^3.6.1", HOME: "/opt/buildhome", GELATO_RELAY_API_KEY: "ITkU3BICAYLu744hA_t1rMdMcUtiGHTC2G4cODIUwuY_", OLDPWD: "/opt/build/repo/dapp", npm_package_dependencies_ethers: "^6.9.2", RPC_URL_ETHEREUM: "https://eth-mainnet.g.alchemy.com/v2/KxGOKqgpp4CeCSe0-4POLBBNVfAsACLi", ACCOUNT_ID: "60274f5a25e90375cffc9590", NVM_BIN: "/opt/buildhome/.nvm/versions/node/v22.14.0/bin", NVM_INC: "/opt/buildhome/.nvm/versions/node/v22.14.0/include/node", rvm_stored_umask: "0022", CACHED_COMMIT_REF: "56a8abcf8f205b33ed9430104ee066c1ce38beba", MEZO_MAINNET_URL: "https://mezo.org", COREPACK_ROOT: "/opt/buildhome/.nvm/versions/node/v20.19.1/lib/node_modules/corepack", npm_package_scripts_build_api: "cd ../api && pnpm build", npm_package_devDependencies_typedoc_plugin_markdown: "^3.17.1", NODE_OPTIONS: "--max-old-space-size=8192", GIMME_TYPE: "binary", GIMME_ENV_PREFIX: "/opt/buildhome/.gimme/env", API_ENDPOINT_V2: "https://api.matsnet.mezo.org/api/v2/", GATSBY_TELEMETRY_DISABLED: "1", npm_package_devDependencies__types_fs_extra: "^11.0.4", ENABLE_EXPLORE_PAGE: "false", rvm_user_install_flag: "1", TBTC_API_ENDPOINT: "https://tbtc.api.matsnet.mezo.org/tbtc-api/v1/", npm_package_devDependencies_vite_plugin_dts: "^3.7.2", npm_package_dependencies__mezo_org_orangekit: "1.0.0-beta.39", POSTHOG_KEY: "phc_VTMS7GzJYJWIIUR6ax8xtHXBxbEoNFGi3nijgVQ5bja", GOROOT: "/opt/buildhome/.gimme/versions/go1.19.13.linux.amd64", MEZO_NETWORK: "testnet", API_ENDPOINT: "https://api.matsnet.mezo.org/api/v1/", COMMIT_REF: "11b7c649fcbe302b3b82dd6e7097b316126b06b0", ENABLE_DISCORD_ONBOARDING: "false", SANITY_PROJECT: "9zunswfd", npm_package_devDependencies_typedoc: "^0.25.7", npm_package_devDependencies_typescript: "^5.2.2", NVM_DIR: "/opt/buildhome/.nvm", npm_package_types: "dist/index.d.ts", ENABLE_NEW_MARKET_PAGE: "false", GIMME_GO_VERSION: "1.19.13", CUSTOM_RUBY: "0", COREPACK_ENABLE_DOWNLOAD_PROMPT: "1", npm_package_devDependencies_prettier: "^3.1.1", npm_package_devDependencies_vite_node: "^1.3.0", NETLIFY_BUILD_BASE: "/opt/build", DEPLOY_URL: "https://6814aae11bc9800008fe2eee--mezo-dapp.netlify.app", FORCE_COLOR: "1", npm_package_type: "module", npm_package_devDependencies_eslint_plugin_import: "^2.29.1", _: "/opt/buildhome/.nvm/versions/node/v20.19.1/bin/pnpm", ENABLE_DISCORD_SIGNUP: "false", rvm_bin_path: "/opt/buildhome/.rvm/bin", ENABLE_GOVERNANCE_PAGE: "false", npm_package_devDependencies__types_jest: "^29.5.11", npm_package_devDependencies_ts_jest: "^29.1.1", RUBY_VERSION: "2.7.2", WALLET_CONNECT_PROJECT_ID: "b4cb11ecae1076f6a76cc85be61df9af", IRBRC: "/opt/buildhome/.rvm/rubies/ruby-2.7.2/.irbrc", npm_config_registry: "https://registry.npmjs.org/", POSTHOG_HOST: "https://us.i.posthog.com", ENABLE_STAKE_MANAGEMENT: "false", STORED_JS_WORKSPACE_LOCATIONS: "dapp/ sdk/ solidity/ api/ tbtc-api/", npm_package_dependencies__mezo_org_orangekit_smart_account: "1.0.0-beta.23", SDK_NETWORK: "mainnet", ENABLE_VAULT_PAGE: "false", npm_package_scripts_lint_eslint_fix: "eslint . --fix", npm_package_dependencies__sentry_browser: "^7.110.1", GO_VERSION: "1.19.x", ENABLE_OVERVIEW_PAGE: "false", npm_config_node_gyp: "/opt/buildhome/.cache/node/corepack/v1/pnpm/8.13.1/dist/node_modules/node-gyp/bin/node-gyp.js", PATH: "/opt/build/repo/sdk/node_modules/.bin:/opt/buildhome/.cache/node/corepack/v1/pnpm/8.13.1/dist/node-gyp-bin:/opt/build/repo/node_modules/.bin:/opt/build/repo/dapp/node_modules/.bin:/opt/buildhome/.cache/node/corepack/v1/pnpm/8.13.1/dist/node-gyp-bin:/opt/build/repo/node_modules/.bin:/opt/build/repo/dapp/node_modules/.bin:/opt/buildhome/.cache/node/corepack/v1/pnpm/8.13.1/dist/node-gyp-bin:/opt/build/repo/node_modules/.bin:/opt/build/repo/node_modules/.bin:/opt/build/node_modules/.bin:/opt/node_modules/.bin:/node_modules/.bin:/opt/buildhome/.nvm/versions/node/v20.19.1/bin:/opt/buildhome/.nvm/versions/node/v20.19.1/bin:/opt/buildhome/.gimme/versions/go1.19.13.linux.amd64/bin:/opt/buildhome/.rvm/gems/ruby-2.7.2/bin:/opt/buildhome/.rvm/gems/ruby-2.7.2@global/bin:/opt/buildhome/.rvm/rubies/ruby-2.7.2/bin:/opt/buildhome/.local/share/mise/installs/python/3.13.3/bin:/opt/buildhome/.local/share/mise/shims:/home/linuxbrew/.linuxbrew/bin:/opt/buildhome/.swiftenv/bin:/opt/buildhome/.swiftenv/shims:/opt/buildhome/.php:/opt/buildhome/.binrc/bin:/opt/buildhome/.local/bin:/opt/buildhome/.bun/bin:/opt/buildhome/.deno/bin:/usr/local/rvm/bin:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin:/opt/buildhome/.cask/bin:/opt/buildhome/.gimme/bin:/opt/buildhome/.dotnet/tools:/opt/buildhome/.dotnet:/opt/buildhome/.cargo/bin:/opt/buildhome/.rvm/bin:/opt/build/repo/node_modules/.bin", NEXT_TELEMETRY_DISABLED: "1", NODE: "/opt/buildhome/.nvm/versions/node/v20.19.1/bin/node", npm_package_name: "sdk", npm_config_store_dir: "/opt/buildhome/.pnpm-store", COREPACK_ENABLE_AUTO_PIN: "0", CONTEXT: "production", GIMME_CGO_ENABLED: "true", HEAD: "matsnet", PULL_REQUEST: "false", BUILD_ID: "6814aae11bc9800008fe2eec", npm_config_frozen_lockfile: "", SHOW_DEPOSIT_INFO: "false", MY_RUBY_HOME: "/opt/buildhome/.rvm/rubies/ruby-2.7.2", DEPLOY_PRIME_URL: "https://matsnet--mezo-dapp.netlify.app", npm_package_devDependencies_vite_plugin_node: "^3.1.0", LANG: "en_US.UTF-8", npm_package_scripts_docs_create: "typedoc --options ./typedoc.json && pnpm format:fix", npm_package_devDependencies_eslint: "^8.57.0", npm_package_dependencies__keep_network_tbtc_v2_ts: "2.5.0-dev.2", SEGMENT_WRITE_KEY: "cFt5yEByVw608oMUGx84jocJMEM6qTNO", CYPRESS_CACHE_FOLDER: "./node_modules/.cache/CypressBinary", npm_package_main: "dist/index.js", npm_package_scripts_format_fix: "pnpm run lint:eslint:fix && pnpm run lint:config:fix", npm_lifecycle_script: "pnpm build:api && pnpm build:typechain && vite build && pnpm build:source", npm_package_scripts_test: "jest", npm_package_scripts_lint_eslint: "eslint .", RPC_URL_MEZO: "https://rpc.test.mezo.org/", GOCACHE: "/opt/buildhome/.gimme_cache/gocache", GOPATH: "/opt/buildhome/.gimme_cache/gopath", npm_package_version: "0.1.0", npm_lifecycle_event: "build", NODE_PATH: "/opt/build/repo/node_modules/.pnpm/vite@5.0.13_@types+node@20.10.6/node_modules/vite/bin/node_modules:/opt/build/repo/node_modules/.pnpm/vite@5.0.13_@types+node@20.10.6/node_modules/vite/node_modules:/opt/build/repo/node_modules/.pnpm/vite@5.0.13_@types+node@20.10.6/node_modules:/opt/build/repo/node_modules/.pnpm/node_modules", rvm_prefix: "/opt/buildhome", rvm_loaded_flag: "1", VITE_GTM_ID: "GTM-WRZ2MKG7", npm_package_scripts_build: "pnpm build:api && pnpm build:typechain && vite build && pnpm build:source", npm_package_devDependencies__thesis_co_eslint_config: "^0.6.1", GEM_HOME: "/opt/buildhome/.rvm/gems/ruby-2.7.2", npm_package_dependencies__mezo_api: "workspace:api@*", npm_package_dependencies__mezo_contracts: "workspace:@mezo-org/contracts@*", DEPLOY_ID: "6814aae11bc9800008fe2eee", rvm_version: "1.29.12 (latest)", SENTRY_DSN: "https://cce8c24d266a6c14be70566e77b79280@o4507050091675648.ingest.us.sentry.io/4507050486267904", ENABLE_SWAPS: "false", BUGSNAG_KEY_BUILD_INFO: "8b2ab336661bf29d58011117d9c997d3", npm_package_license: "GPL-3.0", PASSPORT_API_URL: "https://api.matsnet.mezo.org", NETLIFY: "true", REPOSITORY_URL: "https://github.com/thesis/meso-portal", SITE_NAME: "mezo-dapp", ENABLE_BORROW_LIQUIDATIONS_PRICES: "false", npm_package_scripts_format: "pnpm run lint:eslint && pnpm run lint:config", PIPENV_VENV_IN_PROJECT: "1", PWD: "/opt/build/repo/sdk", SUPPORTED_PORTAL_ABI_VERSION: "migrations-upgrade", GEM_PATH: "/opt/buildhome/.rvm/gems/ruby-2.7.2:/opt/buildhome/.rvm/gems/ruby-2.7.2@global", LC_ALL: "en_US.UTF-8", npm_package_scripts_lint_config_fix: "prettier -w '**/*.@(json|yaml|toml|md)'", npm_execpath: "/opt/buildhome/.cache/node/corepack/v1/pnpm/8.13.1/bin/pnpm.cjs", DISABLED_ASSETS: '["LBTC", "aBTC", "intBTC"]', SANITY_DATASET: "production", NVM_CD_FLAGS: "", npm_package_devDependencies_fs_extra: "^11.2.0", npm_config_recursive: "true", SENTRY_ENV: "production", PNPM_SCRIPT_SRC_DIR: "/opt/build/repo/sdk", npm_package_scripts_build_typechain: "cd ../solidity && pnpm build", npm_command: "run-script", FEATURE_FLAGS: "bitballoon_site_labels_enabled,bitballoon_buildbot_cmd_as_env,bitballoon_background_envelope_request,project_razz_ui,project_snubbull_ui,cli_golang_use_al2,bitballoon_disable_domain_spam_protection,bitballoon-subscription-processing-flag,bitballoon_websocket_for_first_deploy,project_yanmega_ui,bitballoon_filter_deleted_builds,buildbot_firebase_bulk_flush,build_warn_upcoming_system_version_change,bitballoon_manifest_diff_comparison,verify_domain_using_edge_challenge,project_flamigo_ui,buildbot_gatsby_telemetry_flag,buildbot_auto_install_bun,bitballoon_increase_deploy_files_slice,project_roots_ui,proxy-remove-limit-on-streaming-response-size-for-functions,bitballoon_use_custom_domain_as_cn,project_lugia_ui,project_zubat_ui,project_rutherford_ui,project_goomy_ui,bitballoon_allow_adding_dns_zone_with_shared_ownership,bitballoon_new_default_functions_region_enabled,project_floatzel_ui,bitballoon_set_domain_capability_to_zero_hard_restriction,cli_integration_installations_meta,project_archen_ui,project_jiktomite_ui,project_dewgong_ui,zisi_fix_symlinks,bitballoon-include-new-authorized-resource-verbs,edge_functions_cache_cli,gatsby_plugin_prerelease,zisi_log_dynamic_imports,bitballoon_cert_purge_via_netlify_server,bitballoon_send_pro_trial_ended_email,bitballoon_do_not_error_ready_deploy,bitballoon-dev-server-tiers,edge_functions_bootstrap_cpu_timing_per_function,zisi_functions_api_v2,edge_functions_invalid_config_throw,bitballoon-remove-autosignup,edge_functions_bootstrap_log_passthrough_errors,project_bonsly_ui,bitballoon_save_all_members,bitballoon_account_level_custom_domain_suffix,project_shedinja_ui,project_lunatone_ui,project_toucannon_ui,bitballoon_use_analytics_for_functions_billing,bitballoon-disable-cache-network,bitballoon_in_memory_deploy_file_tracker,edge_functions_cache_deno_dir,project_wobbuffet_ui,project_electabuzz_ui,project_brambleghast_ui,bitballoon_disable_purge_related_certs,bitballoon_custom_deploy_retention_enabled,buildbot_zisi_system_log,project_marshadow_ui,bitballoon_restrict_sso_login_access,bitballoon_skip_create_proxy_routing,bitballoon_manifest_backfill,bitballoon_mime_type_use_marcel,buildbot_skip_retry,bitballoon_use_deploys_state_index,bitballoon-check-access-on-token-owner,bitballoon_silent_deploy_cancellation,bitballoon_delegate_subdomain_to_netlify,kafka_firebase_send_loglevel_to_firebase,project_therian_ui,dev_server_cache,bitballoon_sort_and_filter_sites,bitballoon_reprocess_processing_deploys,project_tinkatink_ui,edge_functions_config_export,edge_functions_correct_order,project_sunkern_ui,first-spirit-connector,project_togekiss_ui,netlify_build_updated_plugin_compatibility,bitballoon_netlify_employee_disable,zisi_golang_use_al2,project_kabutops_ui,bitballoon-feature-flag-test,bitballoon_mining_detection_enabled,bitballoon_zuora_contact_geolocation,project_samurott_ui,bitballoon_purge_via_netlify_server,project_snorlax_ui,project_deploy_configuration_api_use_per_function_configuration_files,bitballoon_apply_account_password_fix,bitballoon_soft_delete_errored_deploys,bitballoon_prevent_sites_using_envelope_from_calling_old_env,project_ceruledge_ui,bitballoon-developer-role-write-enabled,project_voltorb_ui,buildbot_js_workspace_cache,ops_sort_and_filter_sites_ui,project_shroomish_ui,project_lucario_bitballoon,bitballoon_exclude_deploy_previews_from_deploy_badge,bitballoon_delete_firebase_deploy_logs,buildbot_tracing_in_ntl_build,bitballoon_blobs_dynamodb,project_teddiursa_ui,edge_functions_npm_modules,purge_cache_on_site_transfer,bitballoon_hide_site_description,bitballoon_lambda_states_enabled,project_thwackey_ui,buildbot_fetch_integrations,netlify_build_reduced_output,bitballoon_disabled_cert_purge_via_nats,bitballoon_purge_only_branch_on_deploy,project_flabebe_ui,buildbot_stage_install_dependencies,edge_functions_bootstrap_strip_content_length,bitballoon_extended_domain_validations,project_plusle_ui,project_wishiwashi_ui,bitballoon-free-accounts-cannot-accrue-charges,build_inject_blobs_context,bitballoon_resolve_custom_domain_suffixes,project_stoutland_ui,bitballoon_use_expiry_based_cert_lookup,bitballoon_cleanup_assets_on_submission_delete,bitballoon-track-email-usage,bitballoon_force_in_memory_deploy_file_tracker,bitballoon_zuora_contact_geolocation_sandbox,project_skarmory_ui,bitballoon_auto_accept_git_committers,project_diglett_ui,project_palpitoad_ui,bitballoon-use-role-associations,remove-unused-site-capabilities,bitballoon_enforce_nf_use_mongo_secondary,bitballoon_blobs_dynamodb_for_zip_deploys,send_build_bot_token_to_jigsaw,edge_functions_bootstrap_bypass_response_headers,project_minun_ui,buildbot_tracing_in_ntl_build_via_preloading,bitballoon-unified-core-and-create-roles,bitballoon_disable_purge_via_nats,zisi_add_metadata_file,bitballoon_delete_function_schedules,bitballoon_org_owner_role_enabled,bitballoon_destroy_only_dns_records_on_cancel,bitballoon_switch_asset_blobstore_order,bitballoon_track_last_user_activity,project_yamper_ui,bitballoon_traffic_exceptions_enabled,bitballoon_use_analytics_for_build_minutes_top_queries,project_spheal_ui,bitballoon_deploy_retention_soft_delete,project_toxapex_ui,ops_advanced_deploy_filtering_ui,remove-org-owner-ids-field,zisi_use_latest_babel_version,bitballoon_site_spam_classification,set_user_registration_index,bitballoon-free-is-free,error_builds_on_extension_fetch_fail,bitballoon_autoban_pro_background_abusers,zisi_disallow_new_entry_name,bitballoon_show_deploy_expiry_enabled,bitballoon_disable_netlify_app_cert_lookup,bitballoon-noble,bitballoon_single_player_starter,project_greninja_ui,netlify_build_deploy_configuration_api,project_deoxys_ui,buildbot_node_modules_bin_no_precedence,bitballoon_get_new_zone_info_on_create,bitballoon_pass_active_feature_flags,edge_functions_system_logger,bitballoon_deploy_transition_notifications,project_alomomola_ui,buildbot_custom_build_cache,project_mewtwo_ui,bitballoon_build_settings_multiple_events,bitballoon_deploy_delete_notifications,bitballoon_kafka_firebase_kafka_delivery,configurable_sso_token_expiration,project_heliolisk_ui,bitballoon-read-site-ids-from-member,edge_functions_fail_unsupported_regex,project_sprigatito_ui,project_salamence_ui,zisi_go_drop_runtime_override,edge_functions_path_urlpattern,project_unown_ui,build_fetch_integrations,ops_scope_edge_function_logs_to_deploy_ui,zisi_add_version_file,soft_delete_dns_records,bitballoon_forced_zorb_migration,reviewer_as_a_member,netlify_build_frameworks_api,bitballoon-block-overused-email,project_audino_ui,edge_bundler_pcre_regexp,project_tadbulb_def_ui,cli_fetch_integrations,project_gardevoir_ui,cleanup_zone_when_disabling,bitballoon_branch_as_subdomain_for_buildbot_deploys,bitballoon_use_analytics_for_build_minutes_usage,project_ortegas_ui,no-prefix-cli-test-ff,functions_inherit_build_nodejs_version,project_omastar_ui,bitballoon-use-usage-exceeded-state,build_plugins_use_prerelease,bitballoon_new_accounts_use_envelope,project_fomantis_ui,project_cursola_ui,project_lucario_ui,bitballoon_enable_orb_for_new_customers,bitballoon_periodic_soft_delete_deploys,project_treecko_ui,bitballoon_custom_function_routes", ENABLE_DEFAULT_ANALYTICS_CONSENT: "false", SWIFTENV_ROOT: "/opt/buildhome/.swiftenv", rvm_path: "/opt/buildhome/.rvm", INIT_CWD: "/opt/build/repo/sdk", npm_package_dependencies_ethers_v5: "npm:ethers@^5.5.2", NODE_ENV: "production" };
const PORTAL_CONTRACT_ABI_VERSIONS = {
  "receipts-upgrade": portalAbiReceiptsUpgrade,
  // contracts version: 0.2.0
  "migrations-upgrade": portalAbiMigrationsUpgrade
  // contracts version: 0.3.0
};
const PORTAL_CONTRACT = {
  address: {
    local: define_process_env_default$1.LOCAL_PORTAL_CONTRACT ?? "",
    sepolia: "0x6978E3e11b8Bc34ea836C1706fC742aC4Cb6b0Db",
    mainnet: "0xAB13B8eecf5AA2460841d75da5d5D861fD5B8A39"
  },
  abi: PORTAL_CONTRACT_ABI_VERSIONS[SUPPORTED_PORTAL_ABI_VERSION]
};
const SUPPORTED_STABLECOIN_CONTRACTS = {
  thUSD: {
    decimals: 18n,
    address: {
      local: define_process_env_default$1.LOCAL_THUSD_CONTRACT ?? "",
      sepolia: "0x4b43b73aA4167dBa0ff6806C5f7B8Bb23a31464c",
      mainnet: "0xCFC5bD99915aAa815401C5a41A927aB7a38d29cf"
    },
    abi: thusdAbi
  },
  USDe: {
    decimals: 18n,
    address: {
      local: define_process_env_default$1.LOCAL_USDE_CONTRACT ?? "",
      sepolia: "0x07FcF6368d34D430aAFDc64435517842775fbF1B",
      mainnet: "0x4c9EDD5852cd905f086C759E8383e09bff1E68B3"
    },
    abi: usdeAbi
  },
  crvUSD: {
    decimals: 18n,
    address: {
      local: define_process_env_default$1.LOCAL_CRVUSD_CONTRACT ?? "",
      sepolia: "0x88d0Ccac65CE4110eDE01e29c5E70626378ae425",
      mainnet: "0xf939e0a03fb07f59a73314e73794be0e57ac1b4e"
    },
    abi: crvusdAbi
  },
  USDC: {
    decimals: 6n,
    address: {
      local: define_process_env_default$1.LOCAL_USDC_CONTRACT ?? "",
      sepolia: "0x2dEe9e2ac7c361aB50C5D19111D2B60743C9E9b3",
      mainnet: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48"
    },
    abi: usdcAbi
  },
  USDT: {
    decimals: 6n,
    address: {
      local: define_process_env_default$1.LOCAL_USDT_CONTRACT ?? "",
      sepolia: "0x5d211217D8311E2dEe17aE3F06Ce473922D1a7a4",
      mainnet: "0xdAC17F958D2ee523a2206206994597C13D831ec7"
    },
    abi: usdtAbi
  },
  DAI: {
    decimals: 18n,
    address: {
      local: define_process_env_default$1.LOCAL_DAI_CONTRACT ?? "",
      sepolia: "0x20fAeA18B6a1D0FCDBCcFfFe3d164314744baF30",
      mainnet: "0x6B175474E89094C44Da98b954EedeAC495271d0F"
    },
    abi: daiAbi
  },
  wM: {
    decimals: 6n,
    address: {
      local: define_process_env_default$1.LOCAL_WM_CONTRACT ?? "",
      sepolia: "0x98a942dD227841a325C05B6AC1f0021443e919AD",
      mainnet: "0x437cc33344a0B27A429f795ff6B469C72698B291"
    },
    abi: wMAbi
  },
  T: {
    decimals: 18n,
    address: {
      local: define_process_env_default$1.LOCAL_T_CONTRACT ?? "",
      sepolia: "0x46abDF5aD1726ba700794539C3dB8fE591854729",
      mainnet: "0xCdF7028ceAB81fA0C6971208e83fa7872994beE5"
    },
    abi: tAbi
  }
};
const STBTC_TOKEN_CONTRACTS = {
  stBTC: {
    decimals: 18n,
    address: {
      local: define_process_env_default$1.LOCAL_STBTC_CONTRACT ?? "",
      sepolia: "0x7e184179b1F95A9ca398E6a16127f06b81Cb37a3",
      mainnet: "0xdF217EFD8f3ecb5E837aedF203C28c1f06854017"
    },
    abi: crvStbtcAbi
  },
  "crv-stBTC": {
    decimals: 18n,
    address: {
      local: define_process_env_default$1.LOCAL_CRV_STBTC_CONTRACT ?? "",
      sepolia: "0x76e9AD0d6B132c336E758d04a95E488dD9C319a0",
      mainnet: "0xf7AcA11437476649663493aAa863AE047f94139F"
    },
    abi: crvStbtcAbi
  }
};
const SUPPORTED_TOKEN_CONTRACTS = {
  tBTC: {
    decimals: 18n,
    address: {
      local: define_process_env_default$1.LOCAL_TBTC_CONTRACT ?? "",
      sepolia: "0x517f2982701695D4E52f1ECFBEf3ba31Df470161",
      mainnet: "0x18084fbA666a33d37592fA2633fD49a74DD93a88"
    },
    abi: tbtcAbi
  },
  WBTC: {
    decimals: 8n,
    address: {
      local: define_process_env_default$1.LOCAL_WBTC_CONTRACT ?? "",
      sepolia: "0x1d489eB3066786738df2226e94Bbc85466D3E136",
      mainnet: "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599"
    },
    abi: wbtcAbi
  },
  fBTC: {
    decimals: 8n,
    address: {
      local: define_process_env_default$1.LOCAL_FBTC_CONTRACT ?? "",
      sepolia: "0x26aD7515F34e9B15ba5827302433d33FC5004D16",
      mainnet: "0xC96dE26018A54D51c097160568752c4E3BD6C364"
    },
    abi: fbtcAbi
  },
  SolvBTC: {
    decimals: 18n,
    address: {
      local: define_process_env_default$1.LOCAL_SOLVBTC_CONTRACT ?? "",
      sepolia: "0x39AB795D11FCC6CE1c340fbDc308cF1D42ca8f86",
      mainnet: "0x7A56E1C57C7475CCf742a1832B028F0456652F97"
    },
    abi: solvbtcAbi
  },
  xSolvBTC: {
    decimals: 18n,
    address: {
      local: define_process_env_default$1.LOCAL_XSOLVBTC_CONTRACT ?? "",
      sepolia: "0x64d92C98793C4a55B9a88c2BB9E356650D0d83F5",
      mainnet: "0xd9D920AA40f578ab794426F5C90F6C731D159DEf"
    },
    abi: xsolvbtcAbi
  },
  swBTC: {
    decimals: 8n,
    address: {
      local: define_process_env_default$1.LOCAL_SWBTC_CONTRACT ?? "",
      sepolia: "0x2EE9f779850c8a31c7d77Af0B8d0c91AF2Ea25fB",
      mainnet: "0x8DB2350D78aBc13f5673A411D4700BCF87864dDE"
    },
    abi: swBtcAbi
  },
  cbBTC: {
    decimals: 8n,
    address: {
      local: define_process_env_default$1.LOCAL_CBBTC_CONTRACT ?? "",
      sepolia: "0x50ea58658f2139766Bc80694f30005413997E743",
      mainnet: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf"
    },
    abi: cbBtcAbi
  },
  LBTC: {
    decimals: 8n,
    address: {
      local: define_process_env_default$1.LOCAL_LBTC_CONTRACT ?? "",
      sepolia: "0x278d6eab8C25F2B5Fc66F468e747dF6FbAA532B7",
      mainnet: "0x8236a87084f8B84306f72007F36F2618A5634494"
    },
    abi: lBtcAbi
  },
  aBTC: {
    decimals: 18n,
    address: {
      local: define_process_env_default$1.LOCAL_ABTC_CONTRACT ?? "",
      sepolia: "0xE8dc5dD0fCd6830F905a73236942985346Ee67CB",
      mainnet: "0x5E14FE5ea32eE54C6Cb3c237FFdcE1C57Df2A0bE"
    },
    abi: aBtcAbi
  },
  intBTC: {
    decimals: 18n,
    address: {
      local: define_process_env_default$1.LOCAL_INTBTC_CONTRACT ?? "",
      sepolia: "0xd1b84777dAb7B58f8C16e7110Bf5EC6dA66AF7fc",
      mainnet: "0x1AEe5EC60fc79B669f11FE368fDe789E267649e2"
    },
    abi: intBtcAbi
  },
  ...SUPPORTED_STABLECOIN_CONTRACTS,
  ...STBTC_TOKEN_CONTRACTS
};
const BITCOIN_DEPOSITOR_CONTRACT = {
  address: {
    local: define_process_env_default$1.LOCAL_BITCOIN_DEPOSITOR_CONTRACT ?? "",
    sepolia: "0x7205535961649C4F94e1b4BAfBe26d23e2bbDd84",
    mainnet: "0x1D50D75933b7b7C8AD94dbfb748B5756E3889C24"
  },
  abi: bitcoinDepositorAbi
};
const address$3 = "0x637e22A1EBbca50EA2d34027c238317fD10003eB";
const abi$3 = [
  {
    inputs: [
      {
        internalType: "string",
        name: "name",
        type: "string"
      },
      {
        internalType: "string",
        name: "symbol",
        type: "string"
      },
      {
        internalType: "address",
        name: "_troveManagerAddress",
        type: "address"
      },
      {
        internalType: "address",
        name: "_stabilityPoolAddress",
        type: "address"
      },
      {
        internalType: "address",
        name: "_borrowerOperationsAddress",
        type: "address"
      },
      {
        internalType: "address",
        name: "_interestRateManagerAddress",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_governanceTimeDelay",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    inputs: [],
    name: "ECDSAInvalidSignature",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "length",
        type: "uint256"
      }
    ],
    name: "ECDSAInvalidSignatureLength",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "ECDSAInvalidSignatureS",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "allowance",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "needed",
        type: "uint256"
      }
    ],
    name: "ERC20InsufficientAllowance",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "balance",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "needed",
        type: "uint256"
      }
    ],
    name: "ERC20InsufficientBalance",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "approver",
        type: "address"
      }
    ],
    name: "ERC20InvalidApprover",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "receiver",
        type: "address"
      }
    ],
    name: "ERC20InvalidReceiver",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address"
      }
    ],
    name: "ERC20InvalidSender",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address"
      }
    ],
    name: "ERC20InvalidSpender",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "ERC2612ExpiredSignature",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "signer",
        type: "address"
      },
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "ERC2612InvalidSigner",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "currentNonce",
        type: "uint256"
      }
    ],
    name: "InvalidAccountNonce",
    type: "error"
  },
  {
    inputs: [],
    name: "InvalidShortString",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "OwnableInvalidOwner",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "OwnableUnauthorizedAccount",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "str",
        type: "string"
      }
    ],
    name: "StringTooLong",
    type: "error"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_user",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      }
    ],
    name: "BalanceUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_newBorrowerOperationsAddress",
        type: "address"
      }
    ],
    name: "BorrowerOperationsAddressAdded",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [],
    name: "EIP712DomainChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_interestRateManagerAddress",
        type: "address"
      }
    ],
    name: "InterestRateManagerAddressAdded",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_newStabilityPoolAddress",
        type: "address"
      }
    ],
    name: "StabilityPoolAddressAdded",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_troveManagerAddress",
        type: "address"
      }
    ],
    name: "TroveManagerAddressAdded",
    type: "event"
  },
  {
    inputs: [],
    name: "DOMAIN_SEPARATOR",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "addContractsInitiated",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "addMintListInitiated",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        internalType: "address",
        name: "spender",
        type: "address"
      }
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      }
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "burnList",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "cancelAddContracts",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "cancelAddMintList",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "cancelRevokeBurnList",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "cancelRevokeMintList",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "eip712Domain",
    outputs: [
      {
        internalType: "bytes1",
        name: "fields",
        type: "bytes1"
      },
      {
        internalType: "string",
        name: "name",
        type: "string"
      },
      {
        internalType: "string",
        name: "version",
        type: "string"
      },
      {
        internalType: "uint256",
        name: "chainId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "verifyingContract",
        type: "address"
      },
      {
        internalType: "bytes32",
        name: "salt",
        type: "bytes32"
      },
      {
        internalType: "uint256[]",
        name: "extensions",
        type: "uint256[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "finalizeAddContracts",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "finalizeAddMintList",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "finalizeRevokeBurnList",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "finalizeRevokeMintList",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "governanceTimeDelay",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      }
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "mintList",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "nonces",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pendingAddedMintAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pendingBorrowerOperations",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pendingInterestRateManager",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pendingRevokedBurnAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pendingRevokedMintAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pendingStabilityPool",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pendingTroveManager",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "permit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "revokeBurnListInitiated",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "revokeMintListInitiated",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_troveManagerAddress",
        type: "address"
      },
      {
        internalType: "address",
        name: "_stabilityPoolAddress",
        type: "address"
      },
      {
        internalType: "address",
        name: "_borrowerOperationsAddress",
        type: "address"
      },
      {
        internalType: "address",
        name: "_interestRateManagerAddress",
        type: "address"
      }
    ],
    name: "startAddContracts",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address"
      }
    ],
    name: "startAddMintList",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address"
      }
    ],
    name: "startRevokeBurnList",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address"
      }
    ],
    name: "startRevokeMintList",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];
const address$2 = "0xD6626Dcca8Aa760b227E02B2391AaaECF9371c5d";
const abi$2 = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "target",
        type: "address"
      }
    ],
    name: "AddressEmptyCode",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "AddressInsufficientBalance",
    type: "error"
  },
  {
    inputs: [],
    name: "FailedInnerCall",
    type: "error"
  },
  {
    inputs: [],
    name: "IncorrectPaymentToken",
    type: "error"
  },
  {
    inputs: [],
    name: "InvalidInitialization",
    type: "error"
  },
  {
    inputs: [],
    name: "NotInitializing",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "OwnableInvalidOwner",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "OwnableUnauthorizedAccount",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "SafeERC20FailedOperation",
    type: "error"
  },
  {
    inputs: [],
    name: "UnknownProduct",
    type: "error"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint64",
        name: "version",
        type: "uint64"
      }
    ],
    name: "Initialized",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "customer",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "orderId",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "string",
        name: "productId",
        type: "string"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "price",
        type: "uint256"
      }
    ],
    name: "OrderPlaced",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "string",
        name: "productId",
        type: "string"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "price",
        type: "uint256"
      }
    ],
    name: "ProductPriceUpdated",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address"
      }
    ],
    name: "getAllOrders",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "orderId",
            type: "uint256"
          },
          {
            internalType: "string",
            name: "productId",
            type: "string"
          },
          {
            internalType: "uint256",
            name: "price",
            type: "uint256"
          }
        ],
        internalType: "struct MatsnetStore.Order[]",
        name: "",
        type: "tuple[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_paymentToken",
        type: "address"
      }
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "nextOrderId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "productId",
        type: "string"
      }
    ],
    name: "orderProduct",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "orders",
    outputs: [
      {
        internalType: "uint256",
        name: "orderId",
        type: "uint256"
      },
      {
        internalType: "string",
        name: "productId",
        type: "string"
      },
      {
        internalType: "uint256",
        name: "price",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "paymentToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    name: "productPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "productId",
        type: "string"
      },
      {
        internalType: "uint256",
        name: "price",
        type: "uint256"
      }
    ],
    name: "setProductPrice",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];
const address$1 = "0x7e77B75cdBA669fcf0F96D52Fc546cd4bF41Eebc";
const abi$1 = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "target",
        type: "address"
      }
    ],
    name: "AddressEmptyCode",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "AddressInsufficientBalance",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "installId",
        type: "string"
      }
    ],
    name: "AlreadyClaimed",
    type: "error"
  },
  {
    inputs: [],
    name: "ECDSAInvalidSignature",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "length",
        type: "uint256"
      }
    ],
    name: "ECDSAInvalidSignatureLength",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "ECDSAInvalidSignatureS",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "balance",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "needed",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "ERC1155InsufficientBalance",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "approver",
        type: "address"
      }
    ],
    name: "ERC1155InvalidApprover",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "idsLength",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "valuesLength",
        type: "uint256"
      }
    ],
    name: "ERC1155InvalidArrayLength",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address"
      }
    ],
    name: "ERC1155InvalidOperator",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "receiver",
        type: "address"
      }
    ],
    name: "ERC1155InvalidReceiver",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address"
      }
    ],
    name: "ERC1155InvalidSender",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "ERC1155MissingApprovalForAll",
    type: "error"
  },
  {
    inputs: [],
    name: "FailedInnerCall",
    type: "error"
  },
  {
    inputs: [],
    name: "InvalidAddress",
    type: "error"
  },
  {
    inputs: [],
    name: "InvalidInitialization",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recoveredSigner",
        type: "address"
      }
    ],
    name: "InvalidSignature",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      }
    ],
    name: "MaxTokensPerAddress",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      }
    ],
    name: "MissingBorrowRequirement",
    type: "error"
  },
  {
    inputs: [],
    name: "NotInitializing",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "OwnableInvalidOwner",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "OwnableUnauthorizedAccount",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "SafeERC20FailedOperation",
    type: "error"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool"
      }
    ],
    name: "ApprovalForAll",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint64",
        name: "version",
        type: "uint64"
      }
    ],
    name: "Initialized",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "claimerAddress",
        type: "address"
      },
      {
        indexed: false,
        internalType: "string",
        name: "installId",
        type: "string"
      }
    ],
    name: "Mint",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]"
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]"
      }
    ],
    name: "TransferBatch",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "TransferSingle",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "value",
        type: "string"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256"
      }
    ],
    name: "URI",
    type: "event"
  },
  {
    inputs: [],
    name: "NFT_ID",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "TOKEN_AMOUNT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "accounts",
        type: "address[]"
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]"
      }
    ],
    name: "balanceOfBatch",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    name: "claimedIds",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "uri",
        type: "string"
      },
      {
        internalType: "address",
        name: "_token",
        type: "address"
      },
      {
        internalType: "address",
        name: "_troveManager",
        type: "address"
      }
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        internalType: "address",
        name: "operator",
        type: "address"
      }
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "installId",
        type: "string"
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes"
      }
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]"
      },
      {
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "safeBatchTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool"
      }
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "newUri",
        type: "string"
      }
    ],
    name: "setURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newVerifier",
        type: "address"
      }
    ],
    name: "setVerifier",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4"
      }
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "token",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "transferTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "troveManager",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "uri",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "verifier",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  }
];
const address = "0xeC5cF08e480F724EAb5e18EC65f1d1bEbe27c2b2";
const abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "target",
        type: "address"
      }
    ],
    name: "AddressEmptyCode",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "AddressInsufficientBalance",
    type: "error"
  },
  {
    inputs: [],
    name: "FailedInnerCall",
    type: "error"
  },
  {
    inputs: [],
    name: "InvalidInitialization",
    type: "error"
  },
  {
    inputs: [],
    name: "NotInitializing",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "OwnableInvalidOwner",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "OwnableUnauthorizedAccount",
    type: "error"
  },
  {
    inputs: [],
    name: "PaymentTokenZeroAddress",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "SafeERC20FailedOperation",
    type: "error"
  },
  {
    inputs: [],
    name: "UnsupportedBeneficiary",
    type: "error"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "string",
        name: "beneficiaryId",
        type: "string"
      },
      {
        indexed: true,
        internalType: "address",
        name: "recipient",
        type: "address"
      }
    ],
    name: "BeneficiaryUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "donor",
        type: "address"
      },
      {
        indexed: true,
        internalType: "string",
        name: "beneficiaryId",
        type: "string"
      },
      {
        indexed: true,
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "Donated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint64",
        name: "version",
        type: "uint64"
      }
    ],
    name: "Initialized",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferStarted",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    inputs: [],
    name: "acceptOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    name: "beneficiaryIdToRecipient",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "beneficiaryId",
        type: "string"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "donate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "beneficiaryId",
        type: "string"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "donateWithPermit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "beneficiaryId",
        type: "string"
      }
    ],
    name: "getBeneficiaryRecipient",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_paymentToken",
        type: "address"
      }
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "paymentToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pendingOwner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "beneficiaryId",
        type: "string"
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      }
    ],
    name: "updateBeneficiary",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];
var define_process_env_default = { npm_package_scripts_build_source: "node scripts/copy-original-ts-files.mjs", npm_package_devDependencies__types_node: "^20.10.6", npm_package_devDependencies_ts_node: "^10.9.2", npm_package_dependencies__orangekit_sign_in_with_wallet: "1.0.0-beta.6", HOST_NODE_IP: "10.71.17.84", INTEGRATION_TEST: "", SITE_ID: "64ff34ae-c815-4397-9ed0-f7eabbfb7032", npm_package_scripts_lint_config: "prettier -c '**/*.@(json|yaml|toml|md)'", npm_package_dependencies__safe_global_safe_core_sdk_types: "4.0.1", LANGUAGE: "en_US:en", ENABLE_ZERO_LOCK_TIME: "false", npm_package_devDependencies_jest: "^29.7.0", npm_config_user_agent: "pnpm/8.13.1 npm/? node/v20.19.1 linux x64", ENABLE_SEPARATE_MEZO_CHAINS: "false", RVM_DIR: "/opt/buildhome/.rvm", SENTRY_AUTH_TOKEN: "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", CI: "true", NODE_VERSION: "v20.19.1", YARN_VERSION: "1.22.19", ENABLE_BORROW_PRICE_CHANGES: "false", GOLDSKY_MEZO_SUBGRAPH_URL: "https://api.goldsky.com/api/public/project_cm6ks2x8um4aj01uj8nwg1f6r/subgraphs/mezo-testnet/0.1.0-dev.3/gn", URL: "https://mezo.org", BRANCH: "matsnet", npm_package_devDependencies_tsc_alias: "^1.8.8", npm_package_devDependencies_vite: "^5.0.12", npm_node_execpath: "/opt/buildhome/.nvm/versions/node/v20.19.1/bin/node", GIMME_NO_ENV_ALIAS: "true", ENABLE_STAKE_WITHDRAWAL: "false", SHLVL: "1", NETLIFY_SUBSTAGE_TIMES: "/tmp/substage_times.txt", npm_package_devDependencies_eslint_import_resolver_typescript: "^3.6.1", HOME: "/opt/buildhome", GELATO_RELAY_API_KEY: "ITkU3BICAYLu744hA_t1rMdMcUtiGHTC2G4cODIUwuY_", OLDPWD: "/opt/build/repo/dapp", npm_package_dependencies_ethers: "^6.9.2", RPC_URL_ETHEREUM: "https://eth-mainnet.g.alchemy.com/v2/KxGOKqgpp4CeCSe0-4POLBBNVfAsACLi", ACCOUNT_ID: "60274f5a25e90375cffc9590", NVM_BIN: "/opt/buildhome/.nvm/versions/node/v22.14.0/bin", NVM_INC: "/opt/buildhome/.nvm/versions/node/v22.14.0/include/node", rvm_stored_umask: "0022", CACHED_COMMIT_REF: "56a8abcf8f205b33ed9430104ee066c1ce38beba", MEZO_MAINNET_URL: "https://mezo.org", COREPACK_ROOT: "/opt/buildhome/.nvm/versions/node/v20.19.1/lib/node_modules/corepack", npm_package_scripts_build_api: "cd ../api && pnpm build", npm_package_devDependencies_typedoc_plugin_markdown: "^3.17.1", NODE_OPTIONS: "--max-old-space-size=8192", GIMME_TYPE: "binary", GIMME_ENV_PREFIX: "/opt/buildhome/.gimme/env", API_ENDPOINT_V2: "https://api.matsnet.mezo.org/api/v2/", GATSBY_TELEMETRY_DISABLED: "1", npm_package_devDependencies__types_fs_extra: "^11.0.4", ENABLE_EXPLORE_PAGE: "false", rvm_user_install_flag: "1", TBTC_API_ENDPOINT: "https://tbtc.api.matsnet.mezo.org/tbtc-api/v1/", npm_package_devDependencies_vite_plugin_dts: "^3.7.2", npm_package_dependencies__mezo_org_orangekit: "1.0.0-beta.39", POSTHOG_KEY: "phc_VTMS7GzJYJWIIUR6ax8xtHXBxbEoNFGi3nijgVQ5bja", GOROOT: "/opt/buildhome/.gimme/versions/go1.19.13.linux.amd64", MEZO_NETWORK: "testnet", API_ENDPOINT: "https://api.matsnet.mezo.org/api/v1/", COMMIT_REF: "11b7c649fcbe302b3b82dd6e7097b316126b06b0", ENABLE_DISCORD_ONBOARDING: "false", SANITY_PROJECT: "9zunswfd", npm_package_devDependencies_typedoc: "^0.25.7", npm_package_devDependencies_typescript: "^5.2.2", NVM_DIR: "/opt/buildhome/.nvm", npm_package_types: "dist/index.d.ts", ENABLE_NEW_MARKET_PAGE: "false", GIMME_GO_VERSION: "1.19.13", CUSTOM_RUBY: "0", COREPACK_ENABLE_DOWNLOAD_PROMPT: "1", npm_package_devDependencies_prettier: "^3.1.1", npm_package_devDependencies_vite_node: "^1.3.0", NETLIFY_BUILD_BASE: "/opt/build", DEPLOY_URL: "https://6814aae11bc9800008fe2eee--mezo-dapp.netlify.app", FORCE_COLOR: "1", npm_package_type: "module", npm_package_devDependencies_eslint_plugin_import: "^2.29.1", _: "/opt/buildhome/.nvm/versions/node/v20.19.1/bin/pnpm", ENABLE_DISCORD_SIGNUP: "false", rvm_bin_path: "/opt/buildhome/.rvm/bin", ENABLE_GOVERNANCE_PAGE: "false", npm_package_devDependencies__types_jest: "^29.5.11", npm_package_devDependencies_ts_jest: "^29.1.1", RUBY_VERSION: "2.7.2", WALLET_CONNECT_PROJECT_ID: "b4cb11ecae1076f6a76cc85be61df9af", IRBRC: "/opt/buildhome/.rvm/rubies/ruby-2.7.2/.irbrc", npm_config_registry: "https://registry.npmjs.org/", POSTHOG_HOST: "https://us.i.posthog.com", ENABLE_STAKE_MANAGEMENT: "false", STORED_JS_WORKSPACE_LOCATIONS: "dapp/ sdk/ solidity/ api/ tbtc-api/", npm_package_dependencies__mezo_org_orangekit_smart_account: "1.0.0-beta.23", SDK_NETWORK: "mainnet", ENABLE_VAULT_PAGE: "false", npm_package_scripts_lint_eslint_fix: "eslint . --fix", npm_package_dependencies__sentry_browser: "^7.110.1", GO_VERSION: "1.19.x", ENABLE_OVERVIEW_PAGE: "false", npm_config_node_gyp: "/opt/buildhome/.cache/node/corepack/v1/pnpm/8.13.1/dist/node_modules/node-gyp/bin/node-gyp.js", PATH: "/opt/build/repo/sdk/node_modules/.bin:/opt/buildhome/.cache/node/corepack/v1/pnpm/8.13.1/dist/node-gyp-bin:/opt/build/repo/node_modules/.bin:/opt/build/repo/dapp/node_modules/.bin:/opt/buildhome/.cache/node/corepack/v1/pnpm/8.13.1/dist/node-gyp-bin:/opt/build/repo/node_modules/.bin:/opt/build/repo/dapp/node_modules/.bin:/opt/buildhome/.cache/node/corepack/v1/pnpm/8.13.1/dist/node-gyp-bin:/opt/build/repo/node_modules/.bin:/opt/build/repo/node_modules/.bin:/opt/build/node_modules/.bin:/opt/node_modules/.bin:/node_modules/.bin:/opt/buildhome/.nvm/versions/node/v20.19.1/bin:/opt/buildhome/.nvm/versions/node/v20.19.1/bin:/opt/buildhome/.gimme/versions/go1.19.13.linux.amd64/bin:/opt/buildhome/.rvm/gems/ruby-2.7.2/bin:/opt/buildhome/.rvm/gems/ruby-2.7.2@global/bin:/opt/buildhome/.rvm/rubies/ruby-2.7.2/bin:/opt/buildhome/.local/share/mise/installs/python/3.13.3/bin:/opt/buildhome/.local/share/mise/shims:/home/linuxbrew/.linuxbrew/bin:/opt/buildhome/.swiftenv/bin:/opt/buildhome/.swiftenv/shims:/opt/buildhome/.php:/opt/buildhome/.binrc/bin:/opt/buildhome/.local/bin:/opt/buildhome/.bun/bin:/opt/buildhome/.deno/bin:/usr/local/rvm/bin:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin:/opt/buildhome/.cask/bin:/opt/buildhome/.gimme/bin:/opt/buildhome/.dotnet/tools:/opt/buildhome/.dotnet:/opt/buildhome/.cargo/bin:/opt/buildhome/.rvm/bin:/opt/build/repo/node_modules/.bin", NEXT_TELEMETRY_DISABLED: "1", NODE: "/opt/buildhome/.nvm/versions/node/v20.19.1/bin/node", npm_package_name: "sdk", npm_config_store_dir: "/opt/buildhome/.pnpm-store", COREPACK_ENABLE_AUTO_PIN: "0", CONTEXT: "production", GIMME_CGO_ENABLED: "true", HEAD: "matsnet", PULL_REQUEST: "false", BUILD_ID: "6814aae11bc9800008fe2eec", npm_config_frozen_lockfile: "", SHOW_DEPOSIT_INFO: "false", MY_RUBY_HOME: "/opt/buildhome/.rvm/rubies/ruby-2.7.2", DEPLOY_PRIME_URL: "https://matsnet--mezo-dapp.netlify.app", npm_package_devDependencies_vite_plugin_node: "^3.1.0", LANG: "en_US.UTF-8", npm_package_scripts_docs_create: "typedoc --options ./typedoc.json && pnpm format:fix", npm_package_devDependencies_eslint: "^8.57.0", npm_package_dependencies__keep_network_tbtc_v2_ts: "2.5.0-dev.2", SEGMENT_WRITE_KEY: "cFt5yEByVw608oMUGx84jocJMEM6qTNO", CYPRESS_CACHE_FOLDER: "./node_modules/.cache/CypressBinary", npm_package_main: "dist/index.js", npm_package_scripts_format_fix: "pnpm run lint:eslint:fix && pnpm run lint:config:fix", npm_lifecycle_script: "pnpm build:api && pnpm build:typechain && vite build && pnpm build:source", npm_package_scripts_test: "jest", npm_package_scripts_lint_eslint: "eslint .", RPC_URL_MEZO: "https://rpc.test.mezo.org/", GOCACHE: "/opt/buildhome/.gimme_cache/gocache", GOPATH: "/opt/buildhome/.gimme_cache/gopath", npm_package_version: "0.1.0", npm_lifecycle_event: "build", NODE_PATH: "/opt/build/repo/node_modules/.pnpm/vite@5.0.13_@types+node@20.10.6/node_modules/vite/bin/node_modules:/opt/build/repo/node_modules/.pnpm/vite@5.0.13_@types+node@20.10.6/node_modules/vite/node_modules:/opt/build/repo/node_modules/.pnpm/vite@5.0.13_@types+node@20.10.6/node_modules:/opt/build/repo/node_modules/.pnpm/node_modules", rvm_prefix: "/opt/buildhome", rvm_loaded_flag: "1", VITE_GTM_ID: "GTM-WRZ2MKG7", npm_package_scripts_build: "pnpm build:api && pnpm build:typechain && vite build && pnpm build:source", npm_package_devDependencies__thesis_co_eslint_config: "^0.6.1", GEM_HOME: "/opt/buildhome/.rvm/gems/ruby-2.7.2", npm_package_dependencies__mezo_api: "workspace:api@*", npm_package_dependencies__mezo_contracts: "workspace:@mezo-org/contracts@*", DEPLOY_ID: "6814aae11bc9800008fe2eee", rvm_version: "1.29.12 (latest)", SENTRY_DSN: "https://cce8c24d266a6c14be70566e77b79280@o4507050091675648.ingest.us.sentry.io/4507050486267904", ENABLE_SWAPS: "false", BUGSNAG_KEY_BUILD_INFO: "8b2ab336661bf29d58011117d9c997d3", npm_package_license: "GPL-3.0", PASSPORT_API_URL: "https://api.matsnet.mezo.org", NETLIFY: "true", REPOSITORY_URL: "https://github.com/thesis/meso-portal", SITE_NAME: "mezo-dapp", ENABLE_BORROW_LIQUIDATIONS_PRICES: "false", npm_package_scripts_format: "pnpm run lint:eslint && pnpm run lint:config", PIPENV_VENV_IN_PROJECT: "1", PWD: "/opt/build/repo/sdk", SUPPORTED_PORTAL_ABI_VERSION: "migrations-upgrade", GEM_PATH: "/opt/buildhome/.rvm/gems/ruby-2.7.2:/opt/buildhome/.rvm/gems/ruby-2.7.2@global", LC_ALL: "en_US.UTF-8", npm_package_scripts_lint_config_fix: "prettier -w '**/*.@(json|yaml|toml|md)'", npm_execpath: "/opt/buildhome/.cache/node/corepack/v1/pnpm/8.13.1/bin/pnpm.cjs", DISABLED_ASSETS: '["LBTC", "aBTC", "intBTC"]', SANITY_DATASET: "production", NVM_CD_FLAGS: "", npm_package_devDependencies_fs_extra: "^11.2.0", npm_config_recursive: "true", SENTRY_ENV: "production", PNPM_SCRIPT_SRC_DIR: "/opt/build/repo/sdk", npm_package_scripts_build_typechain: "cd ../solidity && pnpm build", npm_command: "run-script", FEATURE_FLAGS: "bitballoon_site_labels_enabled,bitballoon_buildbot_cmd_as_env,bitballoon_background_envelope_request,project_razz_ui,project_snubbull_ui,cli_golang_use_al2,bitballoon_disable_domain_spam_protection,bitballoon-subscription-processing-flag,bitballoon_websocket_for_first_deploy,project_yanmega_ui,bitballoon_filter_deleted_builds,buildbot_firebase_bulk_flush,build_warn_upcoming_system_version_change,bitballoon_manifest_diff_comparison,verify_domain_using_edge_challenge,project_flamigo_ui,buildbot_gatsby_telemetry_flag,buildbot_auto_install_bun,bitballoon_increase_deploy_files_slice,project_roots_ui,proxy-remove-limit-on-streaming-response-size-for-functions,bitballoon_use_custom_domain_as_cn,project_lugia_ui,project_zubat_ui,project_rutherford_ui,project_goomy_ui,bitballoon_allow_adding_dns_zone_with_shared_ownership,bitballoon_new_default_functions_region_enabled,project_floatzel_ui,bitballoon_set_domain_capability_to_zero_hard_restriction,cli_integration_installations_meta,project_archen_ui,project_jiktomite_ui,project_dewgong_ui,zisi_fix_symlinks,bitballoon-include-new-authorized-resource-verbs,edge_functions_cache_cli,gatsby_plugin_prerelease,zisi_log_dynamic_imports,bitballoon_cert_purge_via_netlify_server,bitballoon_send_pro_trial_ended_email,bitballoon_do_not_error_ready_deploy,bitballoon-dev-server-tiers,edge_functions_bootstrap_cpu_timing_per_function,zisi_functions_api_v2,edge_functions_invalid_config_throw,bitballoon-remove-autosignup,edge_functions_bootstrap_log_passthrough_errors,project_bonsly_ui,bitballoon_save_all_members,bitballoon_account_level_custom_domain_suffix,project_shedinja_ui,project_lunatone_ui,project_toucannon_ui,bitballoon_use_analytics_for_functions_billing,bitballoon-disable-cache-network,bitballoon_in_memory_deploy_file_tracker,edge_functions_cache_deno_dir,project_wobbuffet_ui,project_electabuzz_ui,project_brambleghast_ui,bitballoon_disable_purge_related_certs,bitballoon_custom_deploy_retention_enabled,buildbot_zisi_system_log,project_marshadow_ui,bitballoon_restrict_sso_login_access,bitballoon_skip_create_proxy_routing,bitballoon_manifest_backfill,bitballoon_mime_type_use_marcel,buildbot_skip_retry,bitballoon_use_deploys_state_index,bitballoon-check-access-on-token-owner,bitballoon_silent_deploy_cancellation,bitballoon_delegate_subdomain_to_netlify,kafka_firebase_send_loglevel_to_firebase,project_therian_ui,dev_server_cache,bitballoon_sort_and_filter_sites,bitballoon_reprocess_processing_deploys,project_tinkatink_ui,edge_functions_config_export,edge_functions_correct_order,project_sunkern_ui,first-spirit-connector,project_togekiss_ui,netlify_build_updated_plugin_compatibility,bitballoon_netlify_employee_disable,zisi_golang_use_al2,project_kabutops_ui,bitballoon-feature-flag-test,bitballoon_mining_detection_enabled,bitballoon_zuora_contact_geolocation,project_samurott_ui,bitballoon_purge_via_netlify_server,project_snorlax_ui,project_deploy_configuration_api_use_per_function_configuration_files,bitballoon_apply_account_password_fix,bitballoon_soft_delete_errored_deploys,bitballoon_prevent_sites_using_envelope_from_calling_old_env,project_ceruledge_ui,bitballoon-developer-role-write-enabled,project_voltorb_ui,buildbot_js_workspace_cache,ops_sort_and_filter_sites_ui,project_shroomish_ui,project_lucario_bitballoon,bitballoon_exclude_deploy_previews_from_deploy_badge,bitballoon_delete_firebase_deploy_logs,buildbot_tracing_in_ntl_build,bitballoon_blobs_dynamodb,project_teddiursa_ui,edge_functions_npm_modules,purge_cache_on_site_transfer,bitballoon_hide_site_description,bitballoon_lambda_states_enabled,project_thwackey_ui,buildbot_fetch_integrations,netlify_build_reduced_output,bitballoon_disabled_cert_purge_via_nats,bitballoon_purge_only_branch_on_deploy,project_flabebe_ui,buildbot_stage_install_dependencies,edge_functions_bootstrap_strip_content_length,bitballoon_extended_domain_validations,project_plusle_ui,project_wishiwashi_ui,bitballoon-free-accounts-cannot-accrue-charges,build_inject_blobs_context,bitballoon_resolve_custom_domain_suffixes,project_stoutland_ui,bitballoon_use_expiry_based_cert_lookup,bitballoon_cleanup_assets_on_submission_delete,bitballoon-track-email-usage,bitballoon_force_in_memory_deploy_file_tracker,bitballoon_zuora_contact_geolocation_sandbox,project_skarmory_ui,bitballoon_auto_accept_git_committers,project_diglett_ui,project_palpitoad_ui,bitballoon-use-role-associations,remove-unused-site-capabilities,bitballoon_enforce_nf_use_mongo_secondary,bitballoon_blobs_dynamodb_for_zip_deploys,send_build_bot_token_to_jigsaw,edge_functions_bootstrap_bypass_response_headers,project_minun_ui,buildbot_tracing_in_ntl_build_via_preloading,bitballoon-unified-core-and-create-roles,bitballoon_disable_purge_via_nats,zisi_add_metadata_file,bitballoon_delete_function_schedules,bitballoon_org_owner_role_enabled,bitballoon_destroy_only_dns_records_on_cancel,bitballoon_switch_asset_blobstore_order,bitballoon_track_last_user_activity,project_yamper_ui,bitballoon_traffic_exceptions_enabled,bitballoon_use_analytics_for_build_minutes_top_queries,project_spheal_ui,bitballoon_deploy_retention_soft_delete,project_toxapex_ui,ops_advanced_deploy_filtering_ui,remove-org-owner-ids-field,zisi_use_latest_babel_version,bitballoon_site_spam_classification,set_user_registration_index,bitballoon-free-is-free,error_builds_on_extension_fetch_fail,bitballoon_autoban_pro_background_abusers,zisi_disallow_new_entry_name,bitballoon_show_deploy_expiry_enabled,bitballoon_disable_netlify_app_cert_lookup,bitballoon-noble,bitballoon_single_player_starter,project_greninja_ui,netlify_build_deploy_configuration_api,project_deoxys_ui,buildbot_node_modules_bin_no_precedence,bitballoon_get_new_zone_info_on_create,bitballoon_pass_active_feature_flags,edge_functions_system_logger,bitballoon_deploy_transition_notifications,project_alomomola_ui,buildbot_custom_build_cache,project_mewtwo_ui,bitballoon_build_settings_multiple_events,bitballoon_deploy_delete_notifications,bitballoon_kafka_firebase_kafka_delivery,configurable_sso_token_expiration,project_heliolisk_ui,bitballoon-read-site-ids-from-member,edge_functions_fail_unsupported_regex,project_sprigatito_ui,project_salamence_ui,zisi_go_drop_runtime_override,edge_functions_path_urlpattern,project_unown_ui,build_fetch_integrations,ops_scope_edge_function_logs_to_deploy_ui,zisi_add_version_file,soft_delete_dns_records,bitballoon_forced_zorb_migration,reviewer_as_a_member,netlify_build_frameworks_api,bitballoon-block-overused-email,project_audino_ui,edge_bundler_pcre_regexp,project_tadbulb_def_ui,cli_fetch_integrations,project_gardevoir_ui,cleanup_zone_when_disabling,bitballoon_branch_as_subdomain_for_buildbot_deploys,bitballoon_use_analytics_for_build_minutes_usage,project_ortegas_ui,no-prefix-cli-test-ff,functions_inherit_build_nodejs_version,project_omastar_ui,bitballoon-use-usage-exceeded-state,build_plugins_use_prerelease,bitballoon_new_accounts_use_envelope,project_fomantis_ui,project_cursola_ui,project_lucario_ui,bitballoon_enable_orb_for_new_customers,bitballoon_periodic_soft_delete_deploys,project_treecko_ui,bitballoon_custom_function_routes", ENABLE_DEFAULT_ANALYTICS_CONSENT: "false", SWIFTENV_ROOT: "/opt/buildhome/.swiftenv", rvm_path: "/opt/buildhome/.rvm", INIT_CWD: "/opt/build/repo/sdk", npm_package_dependencies_ethers_v5: "npm:ethers@^5.5.2", NODE_ENV: "production" };
const BORROWER_OPERATIONS_CONTRACT = {
  address: {
    local: define_process_env_default.LOCAL_BORROWER_OPERATIONS_CONTRACT ?? "",
    testnet: "0x20fAeA18B6a1D0FCDBCcFfFe3d164314744baF30",
    mezo: "0x20fAeA18B6a1D0FCDBCcFfFe3d164314744baF30"
    // TODO: Add correct contract address after deployment
  },
  abi: borrowerOperationsAbi
};
const PRICE_FEED_CONTRACT = {
  address: {
    local: define_process_env_default.LOCAL_PRICE_FEED_CONTRACT ?? "",
    testnet: "0x601bB278B0F180569A60CAb526ad6Cd34bC0B290",
    mezo: "0x601bB278B0F180569A60CAb526ad6Cd34bC0B290"
    // TODO: Add correct contract address after deployment
  },
  abi: priceFeedAbi
};
const MUSD_TOKEN_CONTRACT = {
  address: {
    local: define_process_env_default.LOCAL_MUSD_TOKEN_CONTRACT ?? "",
    testnet: address$3,
    mezo: address$3
    // TODO: Add correct contract address after deployment
  },
  abi: abi$3
};
const TROVE_MANAGER_CONTRACT = {
  address: {
    local: define_process_env_default.LOCAL_TROVE_MANAGER_CONTRACT ?? "",
    testnet: "0xD374631405613990d62984a08663A28248678975",
    mezo: "0xD374631405613990d62984a08663A28248678975"
    // TODO: Add correct contract address after deployment
  },
  abi: troveManagerAbi
};
const SORTED_TROVES_CONTRACT = {
  address: {
    local: define_process_env_default.LOCAL_SORTED_TROVES_CONTRACT ?? "",
    testnet: "0xD54700Ad42fc49A829DCD3C377aD7B9ed176656A",
    mezo: "0xD54700Ad42fc49A829DCD3C377aD7B9ed176656A"
    // TODO: Add correct contract address after deployment
  },
  abi: sortedTrovesAbi
};
const HINT_HELPERS_CONTRACT = {
  address: {
    local: define_process_env_default.LOCAL_HINT_HELPERS_CONTRACT ?? "",
    testnet: "0x6B5E940705C918c8D44FF67bc0F98aa5Adb57516",
    mezo: "0x6B5E940705C918c8D44FF67bc0F98aa5Adb57516"
    // TODO: Add correct contract address after deployment
  },
  abi: hintHelpersAbi
};
const STORE_CONTRACT = {
  address: {
    local: define_process_env_default.LOCAL_STORE_CONTRACT ?? "",
    testnet: address$2,
    mezo: address$2
    // TODO: Add correct contract address after deployment
  },
  abi: abi$2
};
const TAHO_NFT_CONTRACT = {
  address: {
    local: define_process_env_default.LOCAL_TAHO_NFT_CONTRACT ?? "",
    testnet: address$1,
    mezo: address$1
    // TODO: Add correct contract address after deployment
  },
  abi: abi$1
};
const DONATIONS_CONTRACT = {
  address: {
    local: define_process_env_default.LOCAL_DONATIONS_CONTRACT ?? "",
    testnet: address,
    mezo: address
  },
  abi
};
const MEZO_SESSION_EXPIRATION_TIME = 1e9;
const catchAsync = async (func, fallbackValue, captureError = false) => {
  try {
    return await func();
  } catch (err) {
    if (captureError && Sentry.isInitialized()) {
      Sentry.captureException(err);
    }
    console.error(err);
    return fallbackValue;
  }
};
const fetchWithRetry = async (url, options, retries = 3, waitTime = 3e3) => {
  let response = await fetch(url, options);
  let count = 0;
  while (!response.ok && response.status > 499 && count < retries) {
    console.warn(
      `Request failed, retrying... #${count + 1}`,
      "path:",
      url.pathname
    );
    count += 1;
    await new Promise((resolve) => setTimeout(resolve, waitTime));
    response = await fetch(url, options);
  }
  return response;
};
const createError = (title, account, details = "") => new Error(
  `SDK: ${title}, account: ${account}, ${typeof details === "object" ? `details: ${JSON.stringify(details)}` : details}`
);
const getTokenName = (address2) => {
  const tokenName = Object.entries(SUPPORTED_TOKEN_CONTRACTS).find(
    ([_, contract]) => Object.values(contract.address).includes(address2)
  );
  return tokenName ? tokenName[0] : void 0;
};
const getTokenAddress = (token, network) => SUPPORTED_TOKEN_CONTRACTS[token] ? SUPPORTED_TOKEN_CONTRACTS[token].address[network] : null;
const convertFixedPoint = (fixedPoint, fixedPointDecimals, targetDecimals) => {
  if (fixedPointDecimals >= targetDecimals) {
    return fixedPoint / 10n ** BigInt(fixedPointDecimals - targetDecimals);
  }
  return fixedPoint * 10n ** BigInt(targetDecimals - fixedPointDecimals);
};
const createSignInWithWalletMessage = (address2, networkFamily, chainId, nonce) => {
  const { host: domain, origin: uri } = window.location;
  const message = new SignInWithWalletMessage({
    domain,
    address: address2,
    // if "bitcoin" this should be btc address, not underlaying eth address
    uri,
    nonce,
    issuedAt: (/* @__PURE__ */ new Date()).toISOString(),
    expirationTime: new Date(
      Date.now() + MEZO_SESSION_EXPIRATION_TIME
    ).toISOString(),
    version: "1",
    chainId: networkFamily === "evm" ? chainId : void 0,
    networkFamily
  });
  return message.prepareMessage();
};
const getOutputScriptFromAddress = (address2, network) => BitcoinAddressConverter.addressToOutputScript(
  address2,
  network === "mainnet" ? BitcoinNetwork.Mainnet : BitcoinNetwork.Testnet
);
const isNestedSegwitAddress = (address2, network) => {
  try {
    const script = getOutputScriptFromAddress(address2, network);
    return BitcoinScriptUtils.isP2SHScript(script) || BitcoinScriptUtils.isP2WSHScript(script);
  } catch (err) {
    return false;
  }
};
const isNativeSegwitAddress = (address2, network) => {
  try {
    const script = getOutputScriptFromAddress(address2, network);
    return BitcoinScriptUtils.isP2WPKHScript(script);
  } catch (err) {
    return false;
  }
};
const isLegacyAddress = (address2, network) => {
  try {
    const script = getOutputScriptFromAddress(address2, network);
    return BitcoinScriptUtils.isP2PKHScript(script);
  } catch (err) {
    return false;
  }
};
const isSupportedBitcoinAddress = (address2, network) => {
  try {
    return isLegacyAddress(address2, network) || isNativeSegwitAddress(address2, network) || isNestedSegwitAddress(address2, network);
  } catch (err) {
    return false;
  }
};
class PersistentContractWrapper extends BaseContract {
  constructor(config, deployment) {
    const contractAddress = config.address ?? deployment.address;
    super(contractAddress, deployment.abi, config.signer);
    __publicField(this, "instanceReadOnly");
    __publicField(this, "instanceWrite");
    __publicField(this, "address");
    __publicField(this, "signer");
    __publicField(this, "provider");
    this.instanceWrite = new BaseContract(
      contractAddress,
      JSON.stringify(deployment.abi),
      config.signer
    );
    this.instanceReadOnly = new BaseContract(
      contractAddress,
      JSON.stringify(deployment.abi),
      config.provider
    );
    this.signer = config.signer;
    this.provider = config.provider;
    this.address = contractAddress;
  }
  /**
   * Function to retrieve protected signer's value
   * @returns this contract's signer
   */
  getSigner() {
    return this.signer;
  }
  // eslint-disable-next-line class-methods-use-this
  async handleTransaction(transaction) {
    if (!transaction)
      return null;
    await transaction.wait();
    return transaction;
  }
  // eslint-disable-next-line class-methods-use-this
  async handleApproval(transaction) {
    if (!transaction)
      return false;
    await transaction.wait();
    return true;
  }
}
class Portal extends PersistentContractWrapper {
  constructor(signer, provider, network) {
    const { address: address2, abi: abi2 } = PORTAL_CONTRACT;
    super({ signer, provider }, { address: address2[network], abi: abi2 });
  }
  /**
   * Function to retrieve chosen deposit lock time
   * @param tokenAddress locked token address
   * @param depositId deposit's depositId
   * @returns deposit's lock period and unlock time
   */
  async getDepositLockTime(tokenAddress, depositId) {
    const response = await catchAsync(async () => {
      const signerAddress = await this.signer.getAddress();
      const locks = await this.instanceReadOnly.queryFilter(
        this.instanceReadOnly.filters.Locked(
          signerAddress,
          tokenAddress,
          depositId
        )
      );
      const lockEvent = locks.map((event) => event.args);
      if (!lockEvent.length)
        return null;
      const { lockPeriod } = lockEvent[0];
      return lockPeriod;
    }, null);
    return response;
  }
  async estimateGas(contractMethod, methodArguments) {
    const fallbackResponse = {
      gasEstimation: 0n,
      gasPrice: 0n
    };
    const response = catchAsync(async () => {
      const { provider } = this.signer;
      if (!provider)
        return fallbackResponse;
      const transaction = await this.instanceWrite[contractMethod].populateTransaction(
        ...methodArguments
      );
      if (!transaction)
        return fallbackResponse;
      const gasEstimation = await this.signer.estimateGas(transaction);
      const { gasPrice, maxPriorityFeePerGas } = await provider.getFeeData();
      const estimation = (gasEstimation ?? 0n) * ((gasPrice ?? 0n) + (maxPriorityFeePerGas ?? 0n));
      return { gasEstimation: estimation, gasPrice: gasPrice ?? 0n };
    }, fallbackResponse);
    return response;
  }
  async getGasFeeData() {
    const response = catchAsync(
      async () => {
        const { provider } = this.signer;
        if (!provider) {
          throw new Error("Provider not found");
        }
        const { gasPrice, maxFeePerGas, maxPriorityFeePerGas } = await provider.getFeeData();
        return { gasPrice, maxFeePerGas, maxPriorityFeePerGas };
      },
      {
        gasPrice: null,
        maxFeePerGas: null,
        maxPriorityFeePerGas: null
      }
    );
    return response;
  }
}
class SupportedToken extends PersistentContractWrapper {
  constructor(signer, provider, portalContract, token) {
    super({ signer, provider }, { ...token });
    __privateAdd(this, _portalContract, void 0);
    __privateSet(this, _portalContract, portalContract);
  }
  /**
   * Function approves a token amount to be used by the Portal contract
   * @param amount amount of deposit token
   */
  async approveTokenForPortal(amount) {
    const response = await catchAsync(async () => {
      const address2 = await __privateGet(this, _portalContract).instanceReadOnly.getAddress();
      const approval = await this.instanceWrite.approve(address2, amount);
      await approval.wait();
      return approval;
    }, null);
    return response;
  }
  /**
   * Function to retrieve balance of current token for selected address
   * @returns balance for token for current signer address
   */
  async getTokenBalance() {
    const response = await catchAsync(async () => {
      const signerAddress = await this.signer.getAddress();
      const balance = await this.instanceReadOnly.balanceOf(signerAddress);
      return balance;
    }, 0n);
    return response;
  }
}
_portalContract = new WeakMap();
class BitcoinDepositor extends PersistentContractWrapper {
  constructor(signer, provider, network) {
    const { address: address2, abi: abi2 } = BITCOIN_DEPOSITOR_CONTRACT;
    super({ signer, provider }, { address: address2[network], abi: abi2 });
  }
  /**
   * Gets the chain-specific identifier of this contract, which is
   * BitcoinDepositor contract.
   */
  getChainIdentifier() {
    return EthereumAddress.from(this.address);
  }
  // eslint-disable-next-line class-methods-use-this
  revealDeposit() {
    throw new Error("Unsupported");
  }
  /**
   * Encodes extra data for given deposit. The extra data is a 32-byte keccak256
   * hash of abi-encoded deposit owner address and deposit lock tim in seconds,
   * normalized to weeks
   * For more information you can check `deposit` method in `BitcoinDepositor`
   * contract when such data is encoded.
   * @param depositOwner The eth address of the account that should own the
   * deposit. Should be prefixed with `0x`.
   * @param depositLockPeriod The deposit lock period in seconds, normalized to
   * weeks (meaning only full weeks in second are valid. e.g. 8.5 weeks
   * [in seconds] will be converted to 8 weeks [in seconds] on the contract
   * side). 0 if there should be no lock time.
   * @returns Encoded extra data
   */
  // eslint-disable-next-line class-methods-use-this
  encodeExtraData(depositOwner, depositLockPeriod) {
    if (!utils.isAddress(depositOwner)) {
      throw new Error(
        "Failed to encode extra data: depositOwner is not an eth address!"
      );
    }
    const extraData = utils.keccak256(
      utils.defaultAbiCoder.encode(
        ["address", "uint32"],
        [depositOwner, depositLockPeriod]
      )
    );
    return extraData;
  }
  /**
   * Creates deposit key for given btc transaction hash and btc output index.
   * @param btcTransactionId btc transaction hash of the bitcoin deposit transaction
   * @param btcOutputIndex btc output index of the bitcoin deposit transaction
   * @returns Encoded deposit key
   */
  // eslint-disable-next-line class-methods-use-this
  encodeDepositKey(btcTransactionId, btcOutputIndex) {
    return EthereumBridge.buildDepositKey(
      BitcoinTxHash.from(btcTransactionId),
      btcOutputIndex
    );
  }
  /**
   * Extracts the information about the deposit from the DepositFinalized event.
   * @param depositKey hashed btc transaction id and output index
   * @returns Information about the deposit on the ethereum side:
   * - ethTransactionId: The ethereum tx hash of the deposit to the Portal contract,
   *   or null if the deposit has not been finalized
   * - tbtcAmount: The amount of tbtc minted for the deposit or null if the deposit
   *   has not been finalized
   */
  async getDepositFinalizedDetails(depositKey) {
    const defaultResponse = {
      ethTransactionId: null,
      tbtcAmount: null
    };
    const response = await catchAsync(async () => {
      const depositFinalizedFilter = await this.instanceReadOnly.queryFilter(
        this.instanceReadOnly.filters.DepositFinalized(depositKey)
      );
      if (!depositFinalizedFilter.length) {
        return defaultResponse;
      }
      const [depositEvent] = depositFinalizedFilter;
      const ethTransactionId = depositEvent.transactionHash;
      const tbtcAmount = depositEvent.args[2];
      return { ethTransactionId, tbtcAmount };
    }, defaultResponse);
    return response;
  }
}
const MAX_FEE_PERCENTAGE = 10n ** 18n;
class BorrowerOperationsContract extends PersistentContractWrapper {
  constructor(signer, provider, network) {
    const { address: address2, abi: abi2 } = BORROWER_OPERATIONS_CONTRACT;
    super({ signer, provider }, { address: address2[network], abi: abi2 });
  }
  async openTrove(data) {
    const response = await catchAsync(async () => {
      const { debtAmount, assetAmount, upperHint, lowerHint } = data;
      const transaction = await this.instanceWrite.openTrove(
        MAX_FEE_PERCENTAGE,
        debtAmount,
        assetAmount,
        upperHint,
        lowerHint,
        // Custom gas limit is a workaround for this method running out of gas
        // from time to time. The gas limit is set to 700k to ensure the transaction
        // goes through. Gas for openTrove is usually around 500k.
        { value: assetAmount, gasLimit: 700000n }
      );
      return this.handleTransaction(transaction);
    }, null);
    return response;
  }
  async adjustTrove(data) {
    const response = await catchAsync(async () => {
      const {
        collateralWithdrawal,
        debtChange,
        isDebtIncrease,
        assetAmount,
        upperHint,
        lowerHint
      } = data;
      const transaction = await this.instanceWrite.adjustTrove(
        MAX_FEE_PERCENTAGE,
        collateralWithdrawal,
        debtChange,
        isDebtIncrease,
        assetAmount,
        upperHint,
        lowerHint,
        { value: assetAmount }
      );
      return this.handleTransaction(transaction);
    }, null);
    return response;
  }
  async addCollateral(data) {
    const response = await catchAsync(async () => {
      const { amount, upperHint, lowerHint } = data;
      const transaction = await this.instanceWrite.addColl(
        amount,
        upperHint,
        lowerHint,
        { value: amount }
      );
      return this.handleTransaction(transaction);
    }, null);
    return response;
  }
  async withdrawCollateral(data) {
    const response = await catchAsync(async () => {
      const { amount, upperHint, lowerHint } = data;
      const transaction = await this.instanceWrite.withdrawColl(
        amount,
        upperHint,
        lowerHint
      );
      return this.handleTransaction(transaction);
    }, null);
    return response;
  }
  async repayMUSD(data) {
    const response = await catchAsync(async () => {
      const { amount, upperHint, lowerHint } = data;
      const transaction = await this.instanceWrite.repayMUSD(
        amount,
        upperHint,
        lowerHint
      );
      return this.handleTransaction(transaction);
    }, null);
    return response;
  }
  async withdrawMUSD(data) {
    const response = await catchAsync(async () => {
      const { amount, upperHint, lowerHint } = data;
      const transaction = await this.instanceWrite.withdrawMUSD(
        MAX_FEE_PERCENTAGE,
        amount,
        upperHint,
        lowerHint
      );
      return this.handleTransaction(transaction);
    }, null);
    return response;
  }
  async closeTrove() {
    const response = await catchAsync(async () => {
      const transaction = await this.instanceWrite.closeTrove();
      return this.handleTransaction(transaction);
    }, null);
    return response;
  }
}
class PriceFeedContract extends PersistentContractWrapper {
  constructor(signer, provider, network) {
    const { address: address2, abi: abi2 } = PRICE_FEED_CONTRACT;
    super({ signer, provider }, { address: address2[network], abi: abi2 });
  }
  async fetchCollateralPrice() {
    const response = await catchAsync(async () => {
      const collateralPrice = await this.instanceReadOnly.fetchPrice();
      return collateralPrice;
    }, 0n);
    return response;
  }
}
var TroveStatus = /* @__PURE__ */ ((TroveStatus2) => {
  TroveStatus2[TroveStatus2["NON_EXISTENT"] = 0] = "NON_EXISTENT";
  TroveStatus2[TroveStatus2["ACTIVE"] = 1] = "ACTIVE";
  TroveStatus2[TroveStatus2["CLOSED_BY_OWNER"] = 2] = "CLOSED_BY_OWNER";
  TroveStatus2[TroveStatus2["CLOSED_BY_LIQUIDATION"] = 3] = "CLOSED_BY_LIQUIDATION";
  TroveStatus2[TroveStatus2["CLOSED_BY_REDEMPTION"] = 4] = "CLOSED_BY_REDEMPTION";
  return TroveStatus2;
})(TroveStatus || {});
const fallbackTroveDebtValue = {
  status: 0,
  debtAmount: 0n,
  collateralAmount: 0n,
  principalAmount: 0n,
  interestAmount: 0n,
  interestRate: 0n,
  maxBorrowingCapacity: 0n,
  pendingCollateral: 0n,
  pendingDebt: 0n,
  pendingInterest: 0n,
  stakeAmount: 0n
};
class TroveManagerContract extends PersistentContractWrapper {
  constructor(signer, provider, network) {
    const { address: address2, abi: abi2 } = TROVE_MANAGER_CONTRACT;
    super({ signer, provider }, { address: address2[network], abi: abi2 });
  }
  async getDebt(address2) {
    const response = await catchAsync(async () => {
      const [
        collateral,
        principal,
        interest,
        pendingCollateral,
        pendingDebt,
        pendingInterest
      ] = await this.instanceReadOnly.getEntireDebtAndColl(address2);
      const maxBorrowingCapacity = await this.instanceReadOnly.getTroveMaxBorrowingCapacity(address2);
      const interestRate = await this.instanceReadOnly.getTroveInterestRate(address2);
      const status = await this.instanceReadOnly.getTroveStatus(address2);
      const totalDebt = await this.instanceReadOnly.getTroveDebt(address2);
      const stake = await this.instanceReadOnly.getTroveStake(address2);
      return {
        status: Number(status),
        debtAmount: totalDebt,
        collateralAmount: collateral,
        principalAmount: principal,
        interestAmount: interest,
        interestRate,
        maxBorrowingCapacity,
        pendingCollateral,
        pendingDebt,
        pendingInterest,
        stakeAmount: stake
      };
    }, fallbackTroveDebtValue);
    return response;
  }
}
class MusdToken extends PersistentContractWrapper {
  constructor(signer, provider, network) {
    const { address: address2, abi: abi2 } = MUSD_TOKEN_CONTRACT;
    super({ signer, provider }, { address: address2[network], abi: abi2 });
    __publicField(this, "network");
    this.network = network;
  }
  async getBalance() {
    const response = await catchAsync(async () => {
      const signerAddress = await this.signer.getAddress();
      const tokenBalance = await this.instanceReadOnly.balanceOf(signerAddress);
      return tokenBalance;
    }, 0n);
    return response;
  }
  async approveTokenForStore(amount) {
    const response = await catchAsync(async () => {
      const { address: address2 } = STORE_CONTRACT;
      const signerAddress = await this.signer.getAddress();
      const existingAllowance = await this.instanceReadOnly.allowance(
        signerAddress,
        address2[this.network]
      );
      if (existingAllowance >= amount)
        return true;
      const approval = await this.instanceWrite.approve(
        address2[this.network],
        amount
      );
      return this.handleApproval(approval);
    }, false);
    return response;
  }
  async approveTokenForBorrowerOperations(amount) {
    const response = await catchAsync(async () => {
      const { address: address2 } = BORROWER_OPERATIONS_CONTRACT;
      const signerAddress = await this.signer.getAddress();
      const existingAllowance = await this.instanceReadOnly.allowance(
        signerAddress,
        address2[this.network]
      );
      if (existingAllowance >= amount)
        return true;
      const approval = await this.instanceWrite.approve(
        address2[this.network],
        amount
      );
      return this.handleApproval(approval);
    }, false);
    return response;
  }
  /**
   * Retrieves the `name` of the ERC-20 token, as defined in the contract.
   *
   * @see {@link https://eips.ethereum.org/EIPS/eip-2612}
   * @returns A Promise that resolves to the name of the token
   */
  async getName() {
    const response = await catchAsync(
      async () => this.instanceReadOnly.name(),
      null
    );
    return response;
  }
  /**
   * Retrieves the current nonce, for an address of a connected signer, from the
   * ERC-20 Permit contract.
   *
   * This is used in the EIP-2612 permit flow to ensure each signature is unique
   * and cannot be replayed. The nonce increments every time a valid permit is
   * used.
   * @see {@link https://eips.ethereum.org/EIPS/eip-2612}
   * @returns A Promise that resolves to the current nonce
   */
  async getNonce() {
    const response = await catchAsync(async () => {
      const signerAddress = await this.signer.getAddress();
      return this.instanceReadOnly.nonces(signerAddress);
    }, null);
    return response;
  }
  /**
   * Asks user to sign a permit message off-chain.
   * @see {@link https://eips.ethereum.org/EIPS/eip-2612}
   *
   * @param amount Amount we want to approve
   * @param spender Address of the spender
   * @param expiresIn Number of seconds, after which the signature is expired.
   * Based on this parameter, the expiration timestamp is returned as deadline.
   * Default value is 3600
   * @reutnrs Signature and it's deadline
   */
  async generatePermitSignatureWithDeadline(amount, spender, expiresIn = 3600) {
    return catchAsync(
      async () => {
        var _a;
        const name = await this.getName();
        const version = "1";
        const { provider } = this.signer;
        if (!provider) {
          throw new Error("Provider not found");
        }
        const { chainId } = await provider.getNetwork();
        const owner = await this.getSigner().getAddress();
        const latestBlockTimestamp = (_a = await provider.getBlock("latest")) == null ? void 0 : _a.timestamp;
        const deadline = latestBlockTimestamp ? latestBlockTimestamp + expiresIn : 0;
        const domain = {
          name,
          version,
          chainId,
          verifyingContract: this.address
        };
        const types = {
          Permit: [
            { name: "owner", type: "address" },
            { name: "spender", type: "address" },
            { name: "value", type: "uint256" },
            { name: "nonce", type: "uint256" },
            { name: "deadline", type: "uint256" }
          ]
        };
        const nonce = await this.getNonce();
        if (!nonce) {
          throw new Error("Couldn't get nonce");
        }
        const message = {
          owner,
          spender,
          value: amount,
          nonce: nonce.toString(),
          deadline: BigInt(deadline)
        };
        const signatureString = await this.getSigner().signTypedData(
          domain,
          types,
          message
        );
        return {
          deadline,
          signature: Signature.from(signatureString)
        };
      },
      {
        deadline: null,
        signature: null
      }
    );
  }
}
class TahoNFTClaim extends PersistentContractWrapper {
  constructor(signer, provider, network) {
    const { address: address2, abi: abi2 } = TAHO_NFT_CONTRACT;
    super({ signer, provider }, { address: address2[network], abi: abi2 });
  }
  async mint(installId, authSignature) {
    return catchAsync(async () => {
      const transaction = await this.instanceWrite.mint(
        installId,
        authSignature
      );
      return this.handleTransaction(transaction);
    }, false);
  }
}
class DonationsContract extends PersistentContractWrapper {
  constructor(signer, provider, network) {
    const { address: address2, abi: abi2 } = DONATIONS_CONTRACT;
    super({ signer, provider }, { address: address2[network], abi: abi2 });
  }
  /**
   * Donates ERC20 tokens to a predefined beneficiary using a permit - approval
   * for the token signed off-chain. Thanks to this user only has to sign the
   * message, instead of sending a separate approval transaction. Approve and
   * donations will be made in one transaction, after message is signed.
   *
   * To obtain a signature for MUSD token please use
   * {@link generatePermitSignatureWithDeadline} method from `musd-token` lib.
   *
   * As of now it only supports donating with the token set during
   * initialization of the contract, which is MUSD.
   * @dev this will not work for BTC wallets.
   * @param beneficiaryId Id of the beneficiary
   * @param amount Amount to donate
   * @param deadline Deadline of the permit
   * @param signature Signature/permit with v, r, and s components
   * @returns Transaction hash
   */
  async donateWithPermit(beneficiaryId, amount, deadline, signature) {
    return catchAsync(async () => {
      const transaction = await this.instanceWrite.donateWithPermit(
        beneficiaryId,
        amount,
        deadline,
        signature.v,
        signature.r,
        signature.s
      );
      const transactionResponse = await this.handleTransaction(transaction);
      return (transactionResponse == null ? void 0 : transactionResponse.hash) || null;
    }, null);
  }
  /**
   * Donates ERC20 tokens to a predefined beneficiary. The approval of the token
   * is required to successfully make a donation with this method.
   *
   * As of now it only supports donating with the token set during
   * initialization of the contract, which is MUSD.
   * @param beneficiaryId Id of the beneficiary
   * @param amount Amount to donate
   * @returns Transaction hash
   */
  async donate(beneficiaryId, amount) {
    return catchAsync(async () => {
      const transaction = await this.instanceWrite.donate(beneficiaryId, amount);
      const transactionResponse = await this.handleTransaction(transaction);
      return (transactionResponse == null ? void 0 : transactionResponse.hash) || null;
    }, null);
  }
}
class Module {
  constructor(wallet, network) {
    __publicField(this, "wallet");
    __publicField(this, "network");
    this.wallet = wallet;
    this.network = network;
  }
}
class EthereumModule extends Module {
  constructor(wallet, network) {
    super(wallet, network);
    __publicField(this, "portalContract");
    __publicField(this, "bitcoinDepositorContract");
    this.portalContract = new Portal(
      this.wallet.signer,
      this.wallet.ethereumStaticProvider,
      network
    );
    this.bitcoinDepositorContract = new BitcoinDepositor(
      this.wallet.signer,
      this.wallet.ethereumStaticProvider,
      network
    );
  }
  /**
   * Function to get the currently deposited/withdrawn token
   * @param token token contract address and abi
   * @returns token contract and its address
   */
  getTokenData(token) {
    const tokenContract = new SupportedToken(
      this.wallet.signer,
      this.wallet.ethereumStaticProvider,
      this.portalContract,
      token
    );
    const { address: address2 } = tokenContract;
    return { tokenContract, tokenAddress: address2 };
  }
  /**
   * Factory method for running transactions on Portal contract
   * @param contractMethod Portal contract's chosen method
   * @param args arguments required by selected contract method
   */
  async transaction(contractMethod, ...args) {
    const response = await catchAsync(async () => {
      const transactionResponse = await this.portalContract.instanceWrite[contractMethod](...args);
      return transactionResponse;
    }, null);
    return response;
  }
}
class DepositMigrationModule extends EthereumModule {
  constructor(wallet, network, apiDepositMigration) {
    super(wallet, network);
    __privateAdd(this, _apiDepositMigration, void 0);
    __privateSet(this, _apiDepositMigration, apiDepositMigration);
  }
  async requestTbtcMigration(depositUuid, depositId, token) {
    const response = await catchAsync(async () => {
      const { evmAddress } = this.wallet;
      const { tokenAddress } = this.getTokenData(token);
      const tokenName = getTokenName(tokenAddress);
      if (!tokenName || !evmAddress || !depositId)
        return null;
      const requestTransaction = await this.transaction(
        "requestTbtcMigration",
        tokenAddress,
        depositId
      );
      if (!requestTransaction)
        return null;
      const depositMigrationInfo = await __privateGet(this, _apiDepositMigration).saveDepositMigration({
        depositUuid,
        requestTransactionId: requestTransaction.hash
      });
      if (!depositMigrationInfo)
        return null;
      return requestTransaction.hash;
    }, null);
    return response;
  }
}
_apiDepositMigration = new WeakMap();
class DepositModule extends EthereumModule {
  constructor(wallet, network, apiDeposit) {
    super(wallet, network);
    __privateAdd(this, _approveAndDeposit);
    __privateAdd(this, _getDepositIdFromTransaction);
    __privateAdd(this, _apiDeposit, void 0);
    __privateSet(this, _apiDeposit, apiDeposit);
  }
  /**
   * Function to initialize token deposit flow and save deposit to database
   * @param token deposited token contract address and abi
   * @param amount amount of token to be deposited
   * @param lockStart current timestamp
   * @param lockEnd timestamp for token lock end
   * @param lockupTime token locking time period (optional)
   */
  async deposit(token, amount, lockData) {
    const response = await catchAsync(async () => {
      const { tokenAddress, tokenContract } = this.getTokenData(token);
      const { lockStart, lockEnd, lockupTime } = lockData;
      const tokenName = getTokenName(tokenAddress);
      if (!tokenName)
        return null;
      const tokenDecimals = await tokenContract.instanceReadOnly.decimals();
      let deposit;
      if (tokenName && APPROVE_AND_CALL_TOKENS.includes(tokenName)) {
        deposit = await __privateMethod(this, _approveAndDeposit, approveAndDeposit_fn).call(this, token, amount, lockupTime);
      } else {
        deposit = await this.transaction(
          "deposit",
          tokenAddress,
          amount,
          lockupTime ?? 0
        );
      }
      if (!deposit)
        return null;
      const parsedAmount = convertFixedPoint(amount, Number(tokenDecimals), 18);
      const depositCreationInfo = await __privateGet(this, _apiDeposit).createDeposit({
        amount: parsedAmount.toString(),
        lockStart,
        lockEnd,
        transactionId: deposit.hash,
        token: tokenName
      });
      deposit.wait();
      if (!depositCreationInfo)
        return null;
      const depositId = await __privateMethod(this, _getDepositIdFromTransaction, getDepositIdFromTransaction_fn).call(this, deposit.hash);
      if (!depositId)
        return deposit;
      await __privateGet(this, _apiDeposit).updateDeposit(depositCreationInfo.id, {
        depositId: depositId.toString()
      });
      return deposit;
    }, null);
    return response;
  }
  /**
   * Function to initialize token approval
   * @param token deposited token contract address and abi
   * @param amount amount of token to be deposited
   */
  async approveForDeposit(token, amount) {
    const response = await catchAsync(async () => {
      const { tokenContract } = this.getTokenData(token);
      const approval = await tokenContract.approveTokenForPortal(amount);
      if (!approval)
        return null;
      return approval;
    }, null);
    return response;
  }
  /**
   * Function to sync ERC20 deposit with the blockchain state.
   * To confirm the deposit was successful and reference it in the future
   * transactions we need to update and store `depositId` in the database.
   * @param deposit deposit data from the database to be synced with the blockchain
   */
  async syncERC20Deposit(deposit) {
    await catchAsync(async () => {
      const { id: databaseId, transactionId, amount } = deposit;
      if (!transactionId) {
        throw new Error("Can't sync ERC20 deposit without transaction hash");
      }
      const depositId = await __privateMethod(this, _getDepositIdFromTransaction, getDepositIdFromTransaction_fn).call(this, transactionId);
      if (depositId) {
        await __privateGet(this, _apiDeposit).updateDeposit(databaseId, {
          transactionId,
          amount,
          depositId: depositId.toString()
        });
      }
    }, null);
  }
  /**
   * Function to sync Bitcoin deposit with the blockchain state.
   * As Bitcoin deposits are bridged to Ethereum, we need to check if the deposit
   * is confirmed on the Ethereum side. If it is then we can:
   * - extract the Ethereum transaction hash
   * - update deposit amount - bridging will consume some of the deposited amount
   * - update depositId as a confirmation of successful deposit
   * @param deposit deposit data from the database to be synced with the blockchain
   */
  async syncBitcoinDeposit(deposit) {
    await catchAsync(async () => {
      const { btcTransactionId, btcOutputIndex } = deposit;
      if (!btcTransactionId) {
        throw new Error("Can't sync Bitcoin deposit without transaction hash");
      }
      if (typeof btcOutputIndex !== "number") {
        throw new Error("Can't sync Bitcoin deposit without output index");
      }
      const bridgedBitcoinDepositKey = this.bitcoinDepositorContract.encodeDepositKey(
        btcTransactionId,
        btcOutputIndex
      );
      const { ethTransactionId, tbtcAmount } = await this.bitcoinDepositorContract.getDepositFinalizedDetails(
        bridgedBitcoinDepositKey
      );
      if (ethTransactionId && tbtcAmount) {
        await this.syncERC20Deposit({
          ...deposit,
          transactionId: ethTransactionId,
          amount: tbtcAmount.toString()
        });
      }
    }, null);
  }
  /**
   * Function updating deposit database entries with the on chain state.
   * @param deposits array of deposits existing in the database to be updated
   */
  async syncExistingDeposits(deposits) {
    await catchAsync(async () => {
      if (!deposits)
        return;
      await Promise.allSettled(
        deposits.map(async (deposit) => {
          const { depositId, transactionId, btcTransactionId } = deposit;
          if (depositId) {
            return;
          }
          if (btcTransactionId && !transactionId) {
            await this.syncBitcoinDeposit(deposit);
          } else if (transactionId && !depositId) {
            await this.syncERC20Deposit(deposit);
          } else {
            throw Error("Deposit is in an unknown state");
          }
        })
      );
    }, null);
  }
  /**
   * Function to retrieve chosen deposit and its unlock time
   * @param tokenAddress deposited token contract address
   * @param depositId deposit depositId
   * @returns balance and unlock time for deposit of selected depositId
   */
  async getDepositFromChain(tokenAddress, depositId) {
    const response = await catchAsync(async () => {
      const { evmAddress } = this.wallet;
      const deposit = await this.portalContract.instanceReadOnly.getDeposit(
        evmAddress,
        tokenAddress,
        depositId
      );
      if (!deposit)
        return null;
      const { unlockAt, balance, receiptMinted, feeOwed, lastFeeIntegral } = deposit;
      return {
        amount: balance,
        unlockAt: Number(unlockAt),
        receiptMinted: receiptMinted ?? 0n,
        feeOwed: feeOwed ?? 0n,
        lastFeeIntegral: lastFeeIntegral ?? 0n
      };
    }, null);
    return response;
  }
  /**
   * Function to retrieve all deposits fee data for current user
   * @returns all deposits fee data for current user
   */
  async getFeeDataForChainDeposits() {
    const response = await catchAsync(async () => {
      const { evmAddress, isBitcoinWallet } = this.wallet;
      if (isBitcoinWallet)
        return [];
      const deposits = (await this.portalContract.instanceReadOnly.queryFilter(
        this.portalContract.instanceReadOnly.filters.Deposited(evmAddress)
      )).filter((deposit) => {
        const tokenName = getTokenName(deposit.args.token);
        return tokenName && SUPERSTACK_TOKENS.includes(tokenName);
      });
      if (!deposits.length)
        return [];
      const depositsData = await Promise.all(
        deposits.map(async (deposit) => {
          const { token, depositId } = deposit.args;
          const selectedDeposit = await this.getDepositFromChain(
            token,
            depositId
          );
          return {
            depositId,
            feeOwed: (selectedDeposit == null ? void 0 : selectedDeposit.feeOwed) ?? 0n,
            lastFeeIntegral: (selectedDeposit == null ? void 0 : selectedDeposit.lastFeeIntegral) ?? 0n
          };
        })
      );
      return depositsData;
    }, []);
    return response;
  }
  async relockDeposit(depositDbId, token, depositId, lockData) {
    const response = await catchAsync(async () => {
      const { tokenAddress } = this.getTokenData(token);
      const { lockEnd, lockupTime } = lockData;
      const relock = await this.transaction(
        "lock",
        tokenAddress,
        depositId,
        lockupTime
      );
      if (!relock)
        return null;
      const updateResult = await __privateGet(this, _apiDeposit).updateDeposit(depositDbId, {
        newDepositLock: true,
        lockEnd,
        lockupTime
      });
      return !!relock && !!updateResult;
    }, null);
    return response;
  }
}
_apiDeposit = new WeakMap();
_approveAndDeposit = new WeakSet();
approveAndDeposit_fn = async function(token, amount, lockupTime) {
  const response = await catchAsync(async () => {
    const { tokenContract } = this.getTokenData(token);
    const extraData = ethers.AbiCoder.defaultAbiCoder().encode(
      ["uint32"],
      [lockupTime ?? 0]
    );
    const deposit = await tokenContract.instanceWrite.approveAndCall(
      this.portalContract.address,
      amount,
      extraData
    );
    return deposit;
  }, null);
  return response;
};
_getDepositIdFromTransaction = new WeakSet();
getDepositIdFromTransaction_fn = async function(transactionHash) {
  const response = await catchAsync(async () => {
    const { provider } = this.wallet.signer;
    if (!provider)
      return null;
    const txReceipt = await provider.getTransactionReceipt(transactionHash);
    if (!txReceipt)
      return null;
    const { logs } = txReceipt;
    let depositId = null;
    logs.forEach((log) => {
      var _a;
      const event = this.portalContract.instanceReadOnly.interface.parseLog({
        topics: log.topics.slice(),
        data: log.data
      });
      if ((event == null ? void 0 : event.name) === "Deposited") {
        depositId = ((_a = event.args) == null ? void 0 : _a[2]) ?? null;
      }
    });
    return depositId;
  }, null);
  return response;
};
class WithdrawalModule extends EthereumModule {
  constructor(wallet, network, apiWithdrawal) {
    super(wallet, network);
    __privateAdd(this, _apiWithdrawal, void 0);
    __privateSet(this, _apiWithdrawal, apiWithdrawal);
  }
  /**
   * Function to initialize the withdrawal flow
   * @param withdrawnDepositUuid database id of the deposit to be withdrawn
   * @param token deposited token contract address and abi
   * @param depositId id for deposit to be withdrawn
   * @param amount amount of token to be deposited
   * @param isBitcoinDeposit flag to check if deposit was made using BTC
   */
  async withdraw(withdrawnDepositUuid, token, depositId, amount, isBitcoinDeposit) {
    const response = await catchAsync(async () => {
      const { evmAddress } = this.wallet;
      const { tokenAddress, tokenContract } = this.getTokenData(token);
      const tokenName = getTokenName(tokenAddress);
      if (!tokenName || !evmAddress || !depositId)
        return null;
      const tokenDecimals = await tokenContract.instanceReadOnly.decimals();
      const withdrawal = await this.transaction(
        "withdraw",
        tokenAddress,
        depositId
      );
      if (!withdrawal)
        return null;
      const parsedAmount = convertFixedPoint(amount, Number(tokenDecimals), 18);
      const withdrawalCreationInfo = await __privateGet(this, _apiWithdrawal).createWithdrawal(
        {
          amount: parsedAmount.toString(),
          withdrawnDepositUuid
        }
      );
      if (!withdrawalCreationInfo)
        return null;
      if (tokenName === "tBTC" && isBitcoinDeposit) {
        const { success: withdrawalUpdateSucess } = await __privateGet(this, _apiWithdrawal).updateWithdrawalRedemptionStatus(
          withdrawnDepositUuid,
          { redemptionRequested: false, redemptionSkipped: true }
        );
        if (!withdrawalUpdateSucess)
          return null;
      }
      return withdrawal;
    }, null);
    return response;
  }
}
_apiWithdrawal = new WeakMap();
class TbtcModule extends EthereumModule {
  constructor(wallet, ethersV5Signer, network, apiTbtc, apiDeposit, apiWithdrawal) {
    super(wallet, network);
    __privateAdd(this, _getTbtcSdk);
    __privateAdd(this, _apiTbtc, void 0);
    __privateAdd(this, _apiDeposit2, void 0);
    __privateAdd(this, _apiWithdrawal2, void 0);
    __privateAdd(this, _tbtcSdkPromise, void 0);
    __privateSet(this, _apiTbtc, apiTbtc);
    __privateSet(this, _apiDeposit2, apiDeposit);
    __privateSet(this, _apiWithdrawal2, apiWithdrawal);
    const initializeTBtc = network === "mainnet" ? TBTC.initializeMainnet : TBTC.initializeSepolia;
    __privateSet(this, _tbtcSdkPromise, initializeTBtc(ethersV5Signer));
  }
  /**
   * Function to initialize bitcoin deposit. It will save the reveal data to the
   * database
   * @param depositLockPeriod deposit locking time period
   * @param bitcoinRecoveryAddress P2PKH or P2WPKH Bitcoin address that can be
   *        used for emergency recovery of the deposited funds.
   */
  async initiateBitcoinDeposit(depositLockPeriod, bitcoinRecoveryAddress) {
    const response = await catchAsync(async () => {
      const { evmAddress: depositOwner, btcAddress: btcDepositOwner } = this.wallet;
      if (!depositOwner || !bitcoinRecoveryAddress) {
        throw new Error(
          "Ethereum address or Bitcoin recovery address is not available."
        );
      }
      const extraData = this.bitcoinDepositorContract.encodeExtraData(
        depositOwner,
        depositLockPeriod
      );
      const tbtcSdk = await __privateMethod(this, _getTbtcSdk, getTbtcSdk_fn).call(this);
      const deposit = await tbtcSdk.deposits.initiateDepositWithProxy(
        bitcoinRecoveryAddress,
        this.bitcoinDepositorContract,
        Hex.from(extraData)
      );
      const txReceipt = deposit.getReceipt();
      const revealData = {
        address: depositOwner,
        revealInfo: {
          depositor: txReceipt.depositor.identifierHex,
          blindingFactor: txReceipt.blindingFactor.toString(),
          walletPublicKeyHash: txReceipt.walletPublicKeyHash.toString(),
          refundPublicKeyHash: txReceipt.refundPublicKeyHash.toString(),
          refundLocktime: txReceipt.refundLocktime.toString(),
          extraData: txReceipt.extraData.toString()
        },
        metadata: {
          depositOwner,
          depositLockPeriod
        },
        application: "mezo",
        loggedInUser: btcDepositOwner ?? depositOwner
      };
      const revealSaved = await __privateGet(this, _apiTbtc).saveReveal(revealData);
      if (!revealSaved)
        throw new Error("Reveal not saved properly in the database.");
      const btcDepositAddress = await deposit.getBitcoinAddress();
      return {
        btcDepositAddress,
        revealData
      };
    }, null);
    return response;
  }
  /**
   * Function to create bitcoin deposit on the backend side.
   * It should be called after the bitcoin transaction is made to deposit address
   * @param revealData reveal data returned from `initiateBitcoinDeposit`
   * function
   * @param amount amount of bitcoin to deposit
   * @param lockData deposit locking time period, lock start and lock end
   * @returns bitcoin deposit object or null if btc transaction can't be
   * found in the mempool
   */
  async createBitcoinDeposit(revealData, amount, lockData) {
    const response = await catchAsync(async () => {
      const { revealInfo, metadata } = revealData;
      const { depositOwner, depositLockPeriod } = metadata;
      const { lockStart, lockEnd } = lockData;
      const createBitcoinDepositData = {
        depositReceipt: revealInfo,
        depositOwner,
        depositLockPeriod
      };
      const bitcoinDeposit = await __privateGet(this, _apiTbtc).createBitcoinDeposit(
        createBitcoinDepositData
      );
      if (!bitcoinDeposit)
        return null;
      const parsedAmount = convertFixedPoint(BigInt(amount), 8, 18);
      await __privateGet(this, _apiDeposit2).createDeposit({
        amount: parsedAmount.toString(),
        lockStart,
        lockEnd,
        btcTransactionId: bitcoinDeposit.transactionHash,
        btcOutputIndex: bitcoinDeposit.outputIndex,
        token: "BTC"
      });
      return { bitcoinDeposit };
    }, null);
    return response;
  }
  validateWithdrawalInputs({
    withdrawnDepositUuid,
    depositId,
    amount,
    bitcoinRedeemerAddress = this.wallet.btcAddress
  }) {
    if (!withdrawnDepositUuid || !depositId || !amount) {
      throw new Error("Invalid withdrawal parameters.");
    }
    if (!bitcoinRedeemerAddress) {
      throw new Error("Bitcoin redeemer address is not available.");
    }
    if (!isSupportedBitcoinAddress(bitcoinRedeemerAddress, this.network)) {
      throw new Error("Invalid Bitcoin redeemer address.");
    }
  }
  async withdrawBitcoinDepositToTBTC({
    withdrawnDepositUuid,
    depositId,
    amount,
    bitcoinRedeemerAddress = this.wallet.btcAddress
  }) {
    const response = await catchAsync(async () => {
      this.validateWithdrawalInputs({
        withdrawnDepositUuid,
        depositId,
        amount,
        bitcoinRedeemerAddress
      });
      const tbtcAddress = SUPPORTED_TOKEN_CONTRACTS.tBTC.address[this.network];
      const withdrawalToEth = await this.transaction(
        "withdraw",
        tbtcAddress,
        depositId
      );
      if (!withdrawalToEth)
        return null;
      const withdrawalCreationInfo = await __privateGet(this, _apiWithdrawal2).createWithdrawal(
        {
          amount: amount.toString(),
          withdrawnDepositUuid
        }
      );
      if (!withdrawalCreationInfo)
        return null;
      return withdrawalCreationInfo;
    }, null);
    return response;
  }
  async requestBitcoinRedemption({
    withdrawnDepositUuid,
    depositId,
    amount,
    bitcoinRedeemerAddress = this.wallet.btcAddress
  }) {
    const response = await catchAsync(async () => {
      this.validateWithdrawalInputs({
        withdrawnDepositUuid,
        depositId,
        amount,
        bitcoinRedeemerAddress
      });
      const tbtcSdk = await __privateMethod(this, _getTbtcSdk, getTbtcSdk_fn).call(this);
      const redemption = await tbtcSdk.redemptions.requestRedemption(
        bitcoinRedeemerAddress,
        BigNumber.from(amount)
      );
      if (!redemption)
        return null;
      const { success: withdrawalUpdateSucess } = await __privateGet(this, _apiWithdrawal2).updateWithdrawalRedemptionStatus(
        withdrawnDepositUuid,
        { redemptionRequested: true, redemptionSkipped: false }
      );
      if (!withdrawalUpdateSucess)
        return null;
      return redemption;
    }, null);
    return response;
  }
  async sendBitcoinToAddress(btcAddress, amount) {
    const response = await catchAsync(async () => {
      var _a, _b, _c;
      if (!((_a = this.wallet) == null ? void 0 : _a.isBitcoinWallet) || !((_c = (_b = this.wallet) == null ? void 0 : _b.signer) == null ? void 0 : _c.sendBitcoin)) {
        return null;
      }
      const txHash = await this.wallet.signer.sendBitcoin(btcAddress, amount);
      return txHash;
    }, null);
    return response;
  }
  async findAllUnspentTransactionOutputs(address2) {
    const response = await catchAsync(async () => {
      const tbtcSdk = await __privateMethod(this, _getTbtcSdk, getTbtcSdk_fn).call(this);
      const utxos = await tbtcSdk.bitcoinClient.findAllUnspentTransactionOutputs(address2);
      return utxos;
    }, []);
    return response;
  }
}
_apiTbtc = new WeakMap();
_apiDeposit2 = new WeakMap();
_apiWithdrawal2 = new WeakMap();
_tbtcSdkPromise = new WeakMap();
_getTbtcSdk = new WeakSet();
getTbtcSdk_fn = async function() {
  const tbtcSdk = await __privateGet(this, _tbtcSdkPromise);
  return tbtcSdk;
};
class ReceiptTokenModule extends EthereumModule {
  constructor(wallet, network, apiReceiptToken) {
    super(wallet, network);
    __privateAdd(this, _apiReceiptToken, void 0);
    __privateSet(this, _apiReceiptToken, apiReceiptToken);
  }
  /**
   * Mints a receipt token for a given deposit.
   *
   * @param depositUuid - The database identifier for the deposit.
   * @param token - The contract deployment details of the token.
   * @param depositId - The unique identifier for the deposit in bigint format.
   * @param amount - The amount to mint in bigint format.
   * @returns A promise that resolves to a ContractTransactionResponse if successful, or null if any step fails.
   */
  async mint(depositUuid, token, depositId, amount) {
    const response = await catchAsync(
      async () => {
        const { evmAddress } = this.wallet;
        const { tokenAddress } = this.getTokenData(token);
        const tokenName = getTokenName(tokenAddress);
        if (!tokenName || !evmAddress || !depositId)
          return null;
        const minted = await this.transaction(
          "mintReceipt",
          tokenAddress,
          depositId,
          amount
        );
        if (!minted)
          return null;
        const mintSaveInfo = await __privateGet(this, _apiReceiptToken).saveMint({
          depositUuid,
          amount
        });
        if (!mintSaveInfo)
          return null;
        return minted;
      },
      null,
      true
    );
    return response;
  }
  /**
   * Repays a receipt token for a given deposit.
   * @param depositUuid - The database identifier for the deposit.
   * @param token - The contract deployment details of the token.
   * @param depositId - The unique identifier for the deposit in bigint format.
   * @param amount - The amount to repay in bigint format.
   * @returns A promise that resolves to a ContractTransactionResponse if successful, or null if any step fails.
   */
  async repay(depositUuid, token, depositId, amount) {
    const response = await catchAsync(
      async () => {
        const { evmAddress } = this.wallet;
        const { tokenAddress } = this.getTokenData(token);
        const tokenName = getTokenName(tokenAddress);
        if (!tokenName || !evmAddress || !depositId)
          return null;
        const repaid = await this.transaction(
          "repayReceipt",
          tokenAddress,
          depositId,
          amount
        );
        if (!repaid)
          return null;
        const repaySaveInfo = await __privateGet(this, _apiReceiptToken).saveRepay({
          depositUuid,
          amount
        });
        if (!repaySaveInfo)
          return null;
        return repaid;
      },
      null,
      true
    );
    return response;
  }
  /**
   * Retrieves fee information for minting a receipt token.
   * @param token - The supported token contract address and ABI.
   * @returns - Returns `null` if the token is not supported.
   *          - Otherwise, returns an object containing:
   *            - `receiptTokenAddress`: The address of the receipt token contract.
   *            - `annualFeePercentage`: The annual fee for minting the receipt token, expressed as a percentage.
   *            - `mintCapPercentage`: The maximum percentage of the deposit amount that can be minted as a receipt token.
   */
  async getMintFeeInfo(token) {
    const response = await catchAsync(
      async () => {
        const { tokenAddress } = this.getTokenData(token);
        const tokenName = getTokenName(tokenAddress);
        if (!tokenName || this.wallet.isBitcoinWallet)
          return null;
        const feeInfo = await this.portalContract.instanceReadOnly.feeInfo(tokenAddress);
        return {
          receiptToken: feeInfo.receiptToken,
          annualFee: feeInfo.annualFee,
          mintCap: feeInfo.mintCap,
          lastFeeUpdateAt: feeInfo.lastFeeUpdateAt,
          feeIntegral: feeInfo.feeIntegral
        };
      },
      null,
      true
    );
    return response;
  }
}
_apiReceiptToken = new WeakMap();
class MezoModule extends Module {
}
class MusdModule extends MezoModule {
  constructor(wallet, network, contracts) {
    super(wallet, network);
    __privateAdd(this, _calculateNominalCollateralRatio);
    __privateAdd(this, _calculateNominalCollateralRatioForExistingLoan);
    __privateAdd(this, _calculateHint);
    __privateAdd(this, _calculateHintsForExistingLoan);
    __privateAdd(this, _contracts, void 0);
    __privateSet(this, _contracts, contracts);
  }
  async borrow(debtAmount, assetAmount) {
    const response = await catchAsync(async () => {
      const hint = await __privateMethod(this, _calculateHint, calculateHint_fn).call(this, debtAmount, assetAmount);
      if (!hint)
        return false;
      const borrowed = await __privateGet(this, _contracts).borrowerOperations.openTrove({
        debtAmount,
        assetAmount,
        upperHint: hint.upperHint,
        lowerHint: hint.lowerHint
      });
      return !!borrowed;
    }, false);
    return response;
  }
  async increaseDebt(amount) {
    const response = await catchAsync(async () => {
      const hint = await __privateMethod(this, _calculateHintsForExistingLoan, calculateHintsForExistingLoan_fn).call(this, amount, 0n);
      if (!hint)
        return false;
      const increased = await __privateGet(this, _contracts).borrowerOperations.withdrawMUSD({
        amount,
        upperHint: hint.upperHint,
        lowerHint: hint.lowerHint
      });
      return !!increased;
    }, false);
    return response;
  }
  async increaseDebtAndCollateral(debtChange, collateralAmount) {
    const response = await catchAsync(async () => {
      const hint = await __privateMethod(this, _calculateHintsForExistingLoan, calculateHintsForExistingLoan_fn).call(this, debtChange, collateralAmount);
      if (!hint)
        return false;
      const adjusted = await __privateGet(this, _contracts).borrowerOperations.adjustTrove({
        collateralWithdrawal: 0n,
        debtChange,
        isDebtIncrease: true,
        assetAmount: collateralAmount,
        upperHint: hint.upperHint,
        lowerHint: hint.lowerHint
      });
      return !!adjusted;
    }, false);
    return response;
  }
  async repayDebtAndWithdrawCollateral(debtChange, collateralAmount) {
    const response = await catchAsync(async () => {
      const approval = await __privateGet(this, _contracts).musd.approveTokenForBorrowerOperations(debtChange);
      if (!approval)
        return false;
      const hint = await __privateMethod(this, _calculateHintsForExistingLoan, calculateHintsForExistingLoan_fn).call(this, -debtChange, -collateralAmount);
      if (!hint)
        return false;
      const adjusted = await __privateGet(this, _contracts).borrowerOperations.adjustTrove({
        collateralWithdrawal: collateralAmount,
        debtChange,
        isDebtIncrease: false,
        assetAmount: 0n,
        upperHint: hint.upperHint,
        lowerHint: hint.lowerHint
      });
      return !!adjusted;
    }, false);
    return response;
  }
  async depositCollateral(amount) {
    const response = await catchAsync(async () => {
      const hint = await __privateMethod(this, _calculateHintsForExistingLoan, calculateHintsForExistingLoan_fn).call(this, 0n, amount);
      if (!hint)
        return false;
      const deposited = await __privateGet(this, _contracts).borrowerOperations.addCollateral({
        amount,
        upperHint: hint.upperHint,
        lowerHint: hint.lowerHint
      });
      return !!deposited;
    }, false);
    return response;
  }
  async withdrawCollateral(amount) {
    const response = await catchAsync(async () => {
      const hint = await __privateMethod(this, _calculateHintsForExistingLoan, calculateHintsForExistingLoan_fn).call(this, 0n, -amount);
      if (!hint)
        return false;
      const withdrawn = await __privateGet(this, _contracts).borrowerOperations.withdrawCollateral({
        amount,
        upperHint: hint.upperHint,
        lowerHint: hint.lowerHint
      });
      return !!withdrawn;
    }, false);
    return response;
  }
  async repayPartialDebt(amount) {
    const response = await catchAsync(async () => {
      const approval = await __privateGet(this, _contracts).musd.approveTokenForBorrowerOperations(amount);
      if (!approval)
        return false;
      const hint = await __privateMethod(this, _calculateHintsForExistingLoan, calculateHintsForExistingLoan_fn).call(this, -amount, 0n);
      if (!hint)
        return false;
      const repaid = await __privateGet(this, _contracts).borrowerOperations.repayMUSD({
        amount,
        upperHint: hint.upperHint,
        lowerHint: hint.lowerHint
      });
      return !!repaid;
    }, false);
    return response;
  }
  async closeLoan() {
    const response = await catchAsync(async () => {
      const gasCompensation = await __privateGet(this, _contracts).borrowerOperations.instanceReadOnly.MUSD_GAS_COMPENSATION();
      const signerAddress = await this.wallet.mezoSigner.getAddress();
      const debtInfo = await __privateGet(this, _contracts).troveManager.getDebt(signerAddress);
      const debtAmountToRepay = debtInfo.debtAmount - gasCompensation;
      const approval = await __privateGet(this, _contracts).musd.approveTokenForBorrowerOperations(
        debtAmountToRepay
      );
      if (!approval)
        return false;
      const closed = await __privateGet(this, _contracts).borrowerOperations.closeTrove();
      return !!closed;
    }, false);
    return response;
  }
  async getDebtForAddress() {
    const response = await catchAsync(async () => {
      const signerAddress = await this.wallet.mezoSigner.getAddress();
      const debtInfo = await __privateGet(this, _contracts).troveManager.getDebt(signerAddress);
      return debtInfo;
    }, fallbackTroveDebtValue);
    return response;
  }
  async fetchCollateralPrice() {
    const response = await catchAsync(async () => {
      const collateralPrice = await __privateGet(this, _contracts).priceFeed.fetchCollateralPrice();
      return collateralPrice;
    }, 0n);
    return response;
  }
  async getMusdTokenBalance() {
    const response = await catchAsync(async () => {
      const tokenBalance = await __privateGet(this, _contracts).musd.getBalance();
      return tokenBalance;
    }, 0n);
    return response;
  }
  async getMusdLiquityProps() {
    const fallbackValue = {
      isRecoveryModeEnabled: false,
      criticalCollateralRatio: 0n,
      minimumCollateralRatio: 0n,
      gasCompensation: 0n,
      borrowingFeeRate: 0n,
      minimumDebt: 0n,
      minimumNetDebt: 0n
    };
    const response = await catchAsync(async () => {
      const collateralPrice = await this.fetchCollateralPrice();
      const isRecoveryModeEnabled = await __privateGet(this, _contracts).troveManager.instanceReadOnly.checkRecoveryMode(
        collateralPrice
      );
      const criticalCollateralRatio = await __privateGet(this, _contracts).borrowerOperations.instanceReadOnly.CCR();
      const minimumCollateralRatio = await __privateGet(this, _contracts).borrowerOperations.instanceReadOnly.MCR();
      const gasCompensation = await __privateGet(this, _contracts).borrowerOperations.instanceReadOnly.MUSD_GAS_COMPENSATION();
      const borrowingFeeRate = await __privateGet(this, _contracts).troveManager.instanceReadOnly.getBorrowingRateWithDecay();
      const minimumNetDebt = await __privateGet(this, _contracts).borrowerOperations.instanceReadOnly.MIN_NET_DEBT();
      return {
        isRecoveryModeEnabled,
        minimumCollateralRatio,
        criticalCollateralRatio,
        gasCompensation,
        borrowingFeeRate,
        minimumNetDebt,
        // Can't repay partially below this value
        minimumDebt: minimumNetDebt + gasCompensation
        // Can't open a loan below this value
      };
    }, fallbackValue);
    return response;
  }
}
_contracts = new WeakMap();
_calculateNominalCollateralRatio = new WeakSet();
calculateNominalCollateralRatio_fn = async function(debtAmount, assetAmount) {
  const response = await catchAsync(async () => {
    const { gasCompensation, borrowingFeeRate } = await this.getMusdLiquityProps();
    const borrowingFee = borrowingFeeRate * debtAmount / 10n ** 18n;
    const debt = debtAmount + borrowingFee + gasCompensation;
    return assetAmount * 10n ** 20n / debt;
  }, 0n);
  return response;
};
_calculateNominalCollateralRatioForExistingLoan = new WeakSet();
calculateNominalCollateralRatioForExistingLoan_fn = async function(previousDebtAmount, debtAmountChange, previousCollateralAmount, collateralAmountChange) {
  const response = await catchAsync(async () => {
    const { borrowingFeeRate } = await this.getMusdLiquityProps();
    const borrowingFee = debtAmountChange > 0n ? borrowingFeeRate * debtAmountChange / 10n ** 18n : 0n;
    const debt = previousDebtAmount + debtAmountChange + borrowingFee;
    return (previousCollateralAmount + collateralAmountChange) * 10n ** 20n / debt;
  }, 0n);
  return response;
};
_calculateHint = new WeakSet();
calculateHint_fn = async function(debtAmount, assetAmount) {
  const response = await catchAsync(async () => {
    const nominalCollateralRatio = await __privateMethod(this, _calculateNominalCollateralRatio, calculateNominalCollateralRatio_fn).call(this, debtAmount, assetAmount);
    const loansCount = await __privateGet(this, _contracts).sortedTroves.getLoansCount();
    const approximateHint = await __privateGet(this, _contracts).hintHelpers.getApproximateHint(
      nominalCollateralRatio,
      loansCount
    );
    if (!approximateHint)
      return null;
    const insertPositions = await __privateGet(this, _contracts).sortedTroves.findTroveInsertPosition(
      nominalCollateralRatio,
      approximateHint
    );
    if (!insertPositions)
      return null;
    return {
      upperHint: insertPositions.upperHint,
      lowerHint: insertPositions.lowerHint
    };
  }, null);
  return response;
};
_calculateHintsForExistingLoan = new WeakSet();
calculateHintsForExistingLoan_fn = async function(debtAmountChange, collateralAmountChange) {
  const response = await catchAsync(async () => {
    const signerAddress = await this.wallet.mezoSigner.getAddress();
    const debtInfo = await __privateGet(this, _contracts).troveManager.getDebt(signerAddress);
    if (!debtInfo.debtAmount)
      return null;
    const nominalCollateralRatio = await __privateMethod(this, _calculateNominalCollateralRatioForExistingLoan, calculateNominalCollateralRatioForExistingLoan_fn).call(this, debtInfo.debtAmount, debtAmountChange, debtInfo.collateralAmount, collateralAmountChange);
    const loansCount = await __privateGet(this, _contracts).sortedTroves.getLoansCount();
    const approximateHint = await __privateGet(this, _contracts).hintHelpers.getApproximateHint(
      nominalCollateralRatio,
      loansCount
    );
    if (!approximateHint)
      return null;
    const insertPositions = await __privateGet(this, _contracts).sortedTroves.findTroveInsertPosition(
      nominalCollateralRatio,
      approximateHint
    );
    if (!insertPositions)
      return null;
    return {
      upperHint: insertPositions.upperHint,
      lowerHint: insertPositions.lowerHint
    };
  }, null);
  return response;
};
class DonationsModule extends MezoModule {
  constructor(wallet, network, contracts) {
    super(wallet, network);
    __privateAdd(this, _contracts2, void 0);
    __privateSet(this, _contracts2, contracts);
  }
  /**
   * General method for donating MUSD to a beneficiary. This method can be used
   * for both BTC and EVM wallets, although the flow will be little different.
   *
   * EVM wallet flow (see {@link donateMusdWithPermit})
   * 1. User is asked to sign a permit message off-chain
   * 2. User is asked to send transaction. Using the signature from point 1,
   * this will cover approve + donate in a single on-chain transaction:
   *
   * BTC wallet flow (see {@link approveAndDonateMusd})
   * 1. User is asked to send approve transaction
   * 2. User is asked to send donate transaction
   *
   * Making BTC flow the same as EVM flow requires a deeper look into passport,
   * so for now we are keeping it this way.
   *
   * @param beneficiaryId Id of the beneficiary for which we want to send a
   * donation
   * @param amount Amount of MUSD to donate
   */
  async donateMusd(beneficiaryId, amount) {
    const response = await catchAsync(async () => {
      if (this.wallet.isBitcoinWallet) {
        return this.approveAndDonateMusd(beneficiaryId, amount);
      }
      return this.donateMusdWithPermit(beneficiaryId, amount);
    }, null);
    return response;
  }
  /**
   * Donates MUSD amount with permit to a beneficiary. User won't have to send a
   * separate approval transaction - instead, he will be asked to sign the
   * message off-chain and then send only one transaction for approval and
   * donation.
   * @dev This will not work for BTC wallets.
   * @param beneficiaryId Id of the beneficiary for which we want to send a
   * donation
   * @param amount Amount of MUSD to donate
   */
  async donateMusdWithPermit(beneficiaryId, amount) {
    const response = await catchAsync(async () => {
      const { signature, deadline } = await __privateGet(this, _contracts2).musd.generatePermitSignatureWithDeadline(
        amount,
        __privateGet(this, _contracts2).donations.address
      );
      if (!signature || !deadline) {
        return null;
      }
      return __privateGet(this, _contracts2).donations.donateWithPermit(
        beneficiaryId,
        amount,
        BigInt(deadline),
        signature
      );
    }, null);
    return response;
  }
  /**
   * Donates MUSD amount to a beneficiary. User will be asked to allow the
   * tokens if his allowance for Donations contract is less than the amount.
   * @dev This should be used only for btc wallets. For EVM wallets please use
   * {@link donateMusdWithPermit} to avoid sending two transactions (approve +
   * donation).
   * @param beneficiaryId Id of the beneficiary for which we want to send a
   * donation
   * @param amount Amount of MUSD to donate
   */
  async approveAndDonateMusd(beneficiaryId, amount) {
    const response = await catchAsync(async () => {
      const allowance = await __privateGet(this, _contracts2).musd.instanceReadOnly.allowance(
        this.wallet.evmAddress,
        __privateGet(this, _contracts2).donations.address
      );
      if (allowance < amount) {
        const approval = await __privateGet(this, _contracts2).musd.instanceWrite.approve(
          __privateGet(this, _contracts2).donations.address,
          amount
        );
        await approval.wait();
      }
      return __privateGet(this, _contracts2).donations.donate(beneficiaryId, amount);
    }, null);
    return response;
  }
}
_contracts2 = new WeakMap();
class MezoApi {
  constructor(apiUrl) {
    __privateAdd(this, _apiUrl, void 0);
    __privateAdd(this, _wallet, null);
    __privateSet(this, _apiUrl, apiUrl);
  }
  setWallet(wallet) {
    __privateSet(this, _wallet, wallet);
  }
  getMainAddress() {
    var _a;
    if (!__privateGet(this, _wallet)) {
      console.error("Mezo SDK: Wallet connection doesn't exist yet.");
    }
    return ((_a = __privateGet(this, _wallet)) == null ? void 0 : _a.mainAddress) ?? null;
  }
  getEvmAddress() {
    var _a;
    if (!__privateGet(this, _wallet)) {
      console.error("Mezo SDK: Wallet connection doesn't exist yet.");
    }
    return ((_a = __privateGet(this, _wallet)) == null ? void 0 : _a.evmAddress) ?? null;
  }
  /**
   * Factory function for running GET requests
   * @param endpoint api endpoint
   * @param requestInit additional data passed to request
   * @returns api response
   */
  async getRequest(endpoint, requestInit) {
    const getRequest = await catchAsync(async () => {
      const data = await fetch(new URL(endpoint, __privateGet(this, _apiUrl)), {
        credentials: "include",
        ...requestInit
      });
      return data;
    }, null);
    return getRequest;
  }
  /**
   * Factory function for running POST requests
   * @param endpoint api endpoint
   * @param body data passed to POST request
   * @param requestInit additional data passed to request
   * @returns api response
   */
  async postRequest(endpoint, body = {}, requestInit) {
    const request = await catchAsync(async () => {
      const data = await fetchWithRetry(new URL(endpoint, __privateGet(this, _apiUrl)), {
        method: "POST",
        body: JSON.stringify(body),
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        ...requestInit
      });
      return data;
    }, null);
    return request;
  }
  async deleteRequest(endpoint, requestInit) {
    const request = await catchAsync(async () => {
      const data = await fetchWithRetry(new URL(endpoint, __privateGet(this, _apiUrl)), {
        method: "DELETE",
        credentials: "include",
        ...requestInit
      });
      return data;
    }, null);
    return request;
  }
  async patchRequest(endpoint, body, requestInit) {
    const request = await catchAsync(async () => {
      const data = await fetchWithRetry(new URL(endpoint, __privateGet(this, _apiUrl)), {
        method: "PATCH",
        body: JSON.stringify(body),
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        ...requestInit
      });
      return data;
    }, null);
    return request;
  }
}
_apiUrl = new WeakMap();
_wallet = new WeakMap();
class MezoApiAccount extends MezoApi {
  /**
   * Function to retrieve account data from api
   * @returns account data
   */
  async getAccount() {
    const response = await catchAsync(async () => {
      const address2 = this.getMainAddress();
      const data = await this.getRequest(`accounts/${address2}`);
      if (!data || !data.ok)
        return null;
      const account = await data.json();
      if (!account.evmAddress) {
        await this.updateEvmAddress();
      }
      return account;
    }, null);
    return response;
  }
  /**
   * Function used to create acccount in database
   * @param code referral code
   * @returns created account from database
   */
  async createAccount(code) {
    const response = await catchAsync(
      async () => {
        const address2 = this.getMainAddress();
        const data = await this.postRequest("accounts", { address: address2, code });
        if (!data) {
          return {
            hasError: true,
            message: "Something went wrong - account not created"
          };
        }
        if (!data.ok) {
          const errorData = await data.json();
          return { hasError: true, message: errorData.error };
        }
        const account = await data.json();
        if (!account.evmAddress) {
          await this.updateEvmAddress();
        }
        return account;
      },
      {
        hasError: true,
        message: "Something went wrong - account not created"
      }
    );
    return response;
  }
  async updateAccount(username) {
    const response = await catchAsync(async () => {
      const address2 = this.getMainAddress();
      const data = await this.patchRequest(`accounts/${address2}`, { username });
      if (!data || !data.ok)
        return null;
      const updatedAccount = await data.json();
      return updatedAccount;
    }, null);
    return response;
  }
  async updateEvmAddress() {
    const response = await catchAsync(
      async () => {
        const address2 = this.getMainAddress();
        const evmAddress = this.getEvmAddress();
        const data = await this.patchRequest(`accounts/evm/${address2}`, {
          evmAddress
        });
        if (!data || !data.ok)
          return { success: false };
        const { success } = await data.json();
        return { success };
      },
      { success: false }
    );
    return response;
  }
  async getAccountTransactions() {
    const fallbackValue = { deposits: [], withdrawals: [] };
    const response = await catchAsync(async () => {
      const address2 = this.getMainAddress();
      const data = await this.getRequest(`accounts/${address2}/transactions`);
      if (!data || !data.ok)
        return fallbackValue;
      const transactions = await data.json();
      return transactions;
    }, fallbackValue);
    return response;
  }
  /**
   * Function to retrieve mats associated with provided address
   * @returns total mats for account
   */
  async getMats() {
    const response = await catchAsync(async () => {
      const address2 = this.getMainAddress();
      const data = await this.getRequest(`accounts/${address2}/mats`);
      if (!data || !data.ok)
        return null;
      const totalMats = await data.json();
      return totalMats;
    }, null);
    return response;
  }
  /**
   * Function used for adding contact information to the database
   * @param contactIdentifier the email address, twitter handle, etc
   * @param identifierType the type of contact identifier, like "email", "twitter", etc
   * @returns true or false based on if email was added successfuly
   */
  async addContactIdentifier(contactIdentifier, identifierType) {
    const response = await catchAsync(async () => {
      const address2 = this.getMainAddress();
      const data = await this.postRequest(`accounts/${address2}/contact-info`, {
        contactIdentifier,
        identifierType
      });
      if (!data || !data.ok)
        return false;
      return true;
    }, false);
    return response;
  }
  async getContactIdentifier() {
    const response = await catchAsync(async () => {
      const address2 = this.getMainAddress();
      const data = await this.getRequest(`accounts/${address2}/contact-info`);
      if (!data || !data.ok)
        return [];
      const contactIdentifier = await data.json();
      return contactIdentifier;
    }, []);
    return response;
  }
  async checkAvailableUsername(username) {
    const response = await catchAsync(async () => {
      const data = await this.getRequest(`available-usernames/${username}`);
      if (!data || !data.ok)
        return false;
      const { available } = await data.json();
      return available;
    }, false);
    return response;
  }
  async getPartnerAccount(partnerSlug) {
    const response = await catchAsync(async () => {
      const data = await this.getRequest(`partners/${partnerSlug}`);
      if (!data || !data.ok)
        return null;
      const partnerAccount = await data.json();
      return partnerAccount;
    }, null);
    return response;
  }
}
class MezoApiDepositMigration extends MezoApi {
  async saveDepositMigration({
    depositUuid,
    requestTransactionId
  }) {
    const response = await catchAsync(
      async () => {
        const address2 = this.getMainAddress();
        const data = await this.postRequest(
          `accounts/${address2}/deposits/${depositUuid}/migrations`,
          {
            requestTransactionId
          }
        );
        const depositMigrationResponse = await (data == null ? void 0 : data.json());
        if (!data || !data.ok) {
          throw createError("Deposit migration failed", address2, {
            response: depositMigrationResponse
          });
        }
        return depositMigrationResponse;
      },
      { success: false },
      true
    );
    return response;
  }
}
class MezoApiDeposit extends MezoApi {
  /**
   * Function to populate database with deposit
   * @param depositData depositing account, amount and lock period for deposit
   * @returns deposit data
   */
  async createDeposit(depositData) {
    const response = await catchAsync(
      async () => {
        const {
          transactionId = null,
          btcTransactionId = null,
          btcOutputIndex = null,
          ...depositDetailsData
        } = depositData;
        const address2 = this.getMainAddress();
        const data = await this.postRequest("deposits", {
          ...depositDetailsData,
          transactionId,
          btcTransactionId,
          btcOutputIndex,
          address: address2
        });
        const depositResponse = await (data == null ? void 0 : data.json());
        if (!data || !data.ok) {
          throw createError("Create deposit failed", address2, {
            transaction: transactionId ?? btcTransactionId,
            depositData,
            response: depositResponse
          });
        }
        return depositResponse;
      },
      null,
      true
    );
    return response;
  }
  async updateDeposit(depositDbId, depositData) {
    const response = await catchAsync(
      async () => {
        const address2 = this.getMainAddress();
        const data = await this.patchRequest(
          `accounts/${address2}/deposits/${depositDbId}`,
          depositData
        );
        if (!data || !data.ok) {
          throw createError("Update deposit failed", address2, {
            depositDbId,
            depositData,
            response: await (data == null ? void 0 : data.json())
          });
        }
        return { success: true };
      },
      { success: false },
      true
    );
    return response;
  }
}
class MezoApiReferralCodes extends MezoApiAccount {
  async getReferralCode(code) {
    const response = await catchAsync(async () => {
      const data = await this.getRequest(`referral-codes/${code}`);
      if (!data || !data.ok)
        return null;
      const referralCode = await data.json();
      return referralCode;
    }, null);
    return response;
  }
  /**
   * Function to retrieve referral codes associated with provided address
   * @returns referral code data including account referral codes and mats earned from referrals
   */
  async getAccountReferralCodeData() {
    const response = await catchAsync(async () => {
      const address2 = this.getMainAddress();
      const data = await this.getRequest(`accounts/${address2}/referrals`);
      if (!data || !data.ok)
        return [];
      const referralCodes = await data.json();
      return referralCodes;
    }, []);
    return response;
  }
  /**
   * Function used to generate referral codes for account
   * @returns generated referral codes
   */
  async generateReferralCodes() {
    const address2 = this.getMainAddress();
    const fallbackResponse = { account: address2 ?? "", codes: [] };
    const reponse = await catchAsync(
      async () => {
        const data = await this.postRequest(
          `accounts/${address2}/generate-referral-codes`,
          address2
        );
        const generatedReferralCodes = await (data == null ? void 0 : data.json());
        if (!data || !data.ok) {
          throw createError("Generate referral codes failed", address2, {
            response: generatedReferralCodes
          });
        }
        return generatedReferralCodes;
      },
      fallbackResponse,
      true
    );
    return reponse;
  }
}
class MezoApiSession extends MezoApi {
  async createSession(message, signature) {
    const response = catchAsync(
      async () => {
        const data = await this.postRequest("session", { message, signature });
        if (!data || !data.ok)
          return { success: false };
        const session = await data.json();
        return session;
      },
      { success: false }
    );
    return response;
  }
  async getSession(requestNewSession = false) {
    const response = catchAsync(async () => {
      if (requestNewSession) {
        const data2 = await this.deleteRequest("session");
        if (!data2 || !data2.ok)
          return null;
      }
      const data = await this.getRequest("session");
      if (!data || !data.ok)
        return null;
      const session = await data.json();
      return session;
    }, null);
    return response;
  }
}
class MezoApiLeaderboard extends MezoApi {
  async getLeaderboard(start = 0, end = 20) {
    const fallbackValue = {
      leaderboard: [],
      users: 0
    };
    const response = await catchAsync(async () => {
      const data = await this.getRequest(
        `leaderboard?start=${start}&end=${end}`
      );
      if (!data || !data.ok)
        return fallbackValue;
      const leaderboard = await data.json();
      return leaderboard;
    }, fallbackValue);
    return response;
  }
  async getUserLeaderboardRank() {
    const fallbackValue = { rank: null, score: 0 };
    const response = await catchAsync(async () => {
      const address2 = this.getMainAddress();
      const data = await this.getRequest(`leaderboard/${address2}`);
      if (!data || !data.ok)
        return fallbackValue;
      const userRank = await data.json();
      return userRank;
    }, fallbackValue);
    return response;
  }
}
class MezoApiStatistics extends MezoApi {
  async getPortalStatistics() {
    const fallbackResponse = {
      hodlers: 0,
      tvl: 0,
      depositedBitcoin: "0",
      currentUsdPerBtc: 0,
      currentUsdPerEth: 0,
      currentUsdPerTToken: 0,
      usdPerBtc24hChange: 0
    };
    const response = await catchAsync(async () => {
      const data = await this.getRequest("statistics");
      if (!data || !data.ok)
        return fallbackResponse;
      const {
        hodlers,
        tvl,
        depositedBitcoin,
        currentUsdPerBtc,
        currentUsdPerEth,
        currentUsdPerTToken,
        usdPerBtc24hChange
      } = await data.json();
      return {
        hodlers,
        tvl,
        depositedBitcoin,
        currentUsdPerEth,
        currentUsdPerBtc,
        currentUsdPerTToken,
        usdPerBtc24hChange
      };
    }, fallbackResponse);
    return response;
  }
}
class MezoApiTbtc extends MezoApi {
  /**
   * Function to populate database with reveal
   * @param revealData Data needed to save the reveal to the database
   * @returns True if the reveal was successfully saved to the database, false
   * otherwise
   */
  async saveReveal(revealData) {
    const response = await catchAsync(
      async () => {
        const data = await this.postRequest("reveals", revealData);
        const revealResponse = await (data == null ? void 0 : data.json());
        if (!data || !data.ok) {
          throw createError("Save reveal failed", revealData.address, {
            revealData,
            response: revealResponse
          });
        }
        const { success } = revealResponse;
        return success;
      },
      false,
      true
    );
    return response;
  }
  /**
   * Function to initiate the reveal of a given deposit
   * @param bitcoinDepositData Data of the bitcoin deposit
   * @returns Object with details about bitcoin deposit - database id, tx hash,
   * output index, tbtc deposit status
   */
  async createBitcoinDeposit(bitcoinDepositData) {
    const response = await catchAsync(
      async () => {
        const data = await this.postRequest("deposits", bitcoinDepositData);
        const depositResponse = await (data == null ? void 0 : data.json());
        if (!data || !data.ok) {
          throw createError(
            "Create bitcoin deposit failed",
            bitcoinDepositData.depositOwner,
            { bitcoinDepositData, response: depositResponse }
          );
        }
        return depositResponse;
      },
      null,
      true
    );
    return response;
  }
}
class MezoApiWithdrawal extends MezoApi {
  async createWithdrawal(withdrawalData) {
    const response = await catchAsync(
      async () => {
        const address2 = this.getMainAddress();
        const data = await this.postRequest(`withdrawals/${address2}`, {
          ...withdrawalData,
          withdrawnAt: /* @__PURE__ */ new Date()
        });
        const withdrawal = await (data == null ? void 0 : data.json());
        if (!data || !data.ok) {
          throw createError("Withdrawal failed", address2, {
            withdrawalData,
            response: withdrawal
          });
        }
        return withdrawal;
      },
      null,
      true
    );
    return response;
  }
  async updateWithdrawalRedemptionStatus(id, redemptionData) {
    const response = await catchAsync(
      async () => {
        const address2 = this.getMainAddress();
        const data = await this.patchRequest(
          `accounts/${address2}/withdrawals/${id}`,
          redemptionData
        );
        if (!data || !data.ok)
          return { success: false };
        return { success: true };
      },
      { success: false }
    );
    return response;
  }
}
class MezoApiReceiptToken extends MezoApi {
  async saveMint({
    depositUuid,
    amount
  }) {
    const response = await catchAsync(
      async () => {
        const address2 = this.getMainAddress();
        const data = await this.postRequest(`receipts/mint/${address2}`, {
          depositUuid,
          amount: amount.toString()
        });
        const receipt = await (data == null ? void 0 : data.json());
        if (!data || !data.ok) {
          throw createError("Mint failed", address2, {
            response: receipt
          });
        }
        return receipt;
      },
      { success: false },
      true
    );
    return response;
  }
  async saveRepay({
    depositUuid,
    amount
  }) {
    const response = await catchAsync(
      async () => {
        const address2 = this.getMainAddress();
        const data = await this.postRequest(`receipts/repay/${address2}`, {
          depositUuid,
          amount: amount.toString()
        });
        const receipt = await (data == null ? void 0 : data.json());
        if (!data || !data.ok) {
          throw createError("Repay failed", address2, {
            response: receipt
          });
        }
        return receipt;
      },
      { success: false },
      true
    );
    return response;
  }
  async getReceipts() {
    const response = await catchAsync(async () => {
      const address2 = this.getMainAddress();
      const data = await this.getRequest(`accounts/${address2}/receipts`);
      if (!data || !data.ok)
        return [];
      const receipts = await data.json();
      return receipts;
    }, []);
    return response;
  }
}
class MezoApiMatsnet extends MezoApi {
  async getMatsnetLeaderboard(start = 0, end = 20) {
    const fallbackValue = { leaderboard: [], users: 0 };
    const response = await catchAsync(async () => {
      const data = await this.getRequest(
        `matsnet/leaderboard?start=${start}&end=${end}`
      );
      if (!data || !data.ok)
        return fallbackValue;
      const leaderboard = await data.json();
      return leaderboard;
    }, fallbackValue);
    return response;
  }
  async stackMatsnetBtc(mats) {
    const response = await catchAsync(
      async () => {
        const mainAddress = this.getMainAddress();
        const evmAddress = this.getEvmAddress();
        if (!mainAddress || !evmAddress) {
          return { success: false };
        }
        const data = await this.postRequest(
          `stack-matsnet-btc/${mainAddress}`,
          {
            evmAddress,
            mats
          }
        );
        if (!data || !data.ok) {
          throw createError("Stacking matsnet btc failed: ", mainAddress, {
            mainAddress,
            evmAddress,
            mats,
            response: await (data == null ? void 0 : data.json())
          });
        }
        const stackMatsnetBtcResponse = await data.json();
        return stackMatsnetBtcResponse;
      },
      { success: false }
    );
    return response;
  }
  async getUserLeaderboardRank() {
    const fallbackValue = { rank: null, positionChange: 0 };
    const response = await catchAsync(async () => {
      const address2 = this.getEvmAddress();
      const data = await this.getRequest(`matsnet/leaderboard/${address2}`);
      if (!data || !data.ok)
        return fallbackValue;
      const userRank = await data.json();
      return userRank;
    }, fallbackValue);
    return response;
  }
}
class MezoApiMats extends MezoApi {
  async getMatsForBorrow() {
    const response = await catchAsync(async () => {
      const address2 = this.getEvmAddress();
      if (!address2)
        return null;
      const data = await this.getRequest(`mats/${address2}/borrow`);
      if (!data || !data.ok)
        return null;
      const { mats } = await data.json();
      return mats ?? null;
    }, null);
    return response;
  }
  async claimMatsForBorrow() {
    const response = await catchAsync(async () => {
      const address2 = this.getEvmAddress();
      if (!address2)
        return false;
      const data = await this.postRequest(`mats/${address2}/borrow`);
      if (!data || !data.ok)
        return false;
      const { success } = await data.json();
      return success;
    }, false);
    return response;
  }
  async grantMatsForSignUp() {
    const response = await catchAsync(async () => {
      const address2 = this.getMainAddress();
      if (!address2)
        return false;
      const data = await this.postRequest(`mats/${address2}/sign-up`);
      if (!data || !data.ok)
        return false;
      const { success } = await data.json();
      return success;
    }, false);
    return response;
  }
}
class MezoApiCampaigns extends MezoApi {
  async getClaimData(installId, address2) {
    const response = await catchAsync(async () => {
      const data = await this.getRequest(
        `campaigns/mezoification/taho-claim?id=${installId}&address=${address2}`
      );
      if (!data || !data.ok)
        return "not-eligible";
      const result = await data.json();
      return result;
    }, "not-eligible");
    return response;
  }
}
class MezoApiBorrow extends MezoApi {
  async getBorrowHistory() {
    const response = await catchAsync(async () => {
      const mainAddress = this.getMainAddress();
      if (!mainAddress)
        return [];
      const data = await this.getRequest(`borrow/${mainAddress}/history`);
      if (!data || !data.ok)
        return [];
      const history = await data.json();
      return history;
    }, []);
    return response;
  }
}
class MezoApiDonations extends MezoApi {
  /**
   * Gets donations made by currently authenticated user.
   */
  async getDonations() {
    const response = await catchAsync(async () => {
      const address2 = this.getEvmAddress();
      if (!address2)
        return [];
      const data = await this.getRequest("donations");
      if (!data || !data.ok)
        return [];
      const donations = await data.json();
      return donations;
    }, []);
    return response;
  }
}
class StoreContract extends PersistentContractWrapper {
  constructor(signer, provider, network) {
    const { address: address2, abi: abi2 } = STORE_CONTRACT;
    super({ signer, provider }, { address: address2[network], abi: abi2 });
  }
  async orderProduct(productId) {
    const response = await catchAsync(async () => {
      const transaction = await this.instanceWrite.orderProduct(productId);
      return this.handleTransaction(transaction);
    }, null);
    return response;
  }
  async getOrders(address2) {
    const response = await catchAsync(async () => {
      const orders = [];
      for (let i = 0; i < 3; i += 1) {
        try {
          const order = await this.instanceReadOnly.orders(address2, i);
          if (order && order.orderId !== 0n) {
            orders.push(order);
          }
        } catch (error) {
        }
      }
      return orders;
    }, []);
    return response;
  }
}
class StoreModule extends MezoModule {
  constructor(wallet, network, contracts) {
    super(wallet, network);
    __privateAdd(this, _contracts3, void 0);
    __privateSet(this, _contracts3, contracts);
  }
  async collect(productId, price) {
    const response = await catchAsync(async () => {
      const approval = await __privateGet(this, _contracts3).musd.approveTokenForStore(price);
      if (!approval)
        return false;
      const order = await __privateGet(this, _contracts3).store.orderProduct(productId);
      if (!order)
        return false;
      return !!order;
    }, false);
    return response;
  }
  async claimTahoNFT(installId, authSignature) {
    return catchAsync(async () => {
      const requiredAllowance = 100n * 10n ** 18n;
      const allowance = await __privateGet(this, _contracts3).musd.instanceReadOnly.allowance(
        this.wallet.evmAddress,
        __privateGet(this, _contracts3).tahoNFT.address
      );
      if (allowance < requiredAllowance) {
        const approval = await __privateGet(this, _contracts3).musd.instanceWrite.approve(
          __privateGet(this, _contracts3).tahoNFT.address,
          requiredAllowance
        );
        await approval.wait();
      }
      const success = await __privateGet(this, _contracts3).tahoNFT.mint(
        installId,
        authSignature
      );
      return success;
    }, false);
  }
  async getOrders() {
    const response = await catchAsync(async () => {
      const signerAddress = this.wallet.evmAddress;
      const orders = await __privateGet(this, _contracts3).store.getOrders(signerAddress);
      return orders;
    }, []);
    return response;
  }
}
_contracts3 = new WeakMap();
class SortedTrovesContract extends PersistentContractWrapper {
  constructor(signer, provider, network) {
    const { address: address2, abi: abi2 } = SORTED_TROVES_CONTRACT;
    super({ signer, provider }, { address: address2[network], abi: abi2 });
  }
  async getLoansCount() {
    const response = await catchAsync(async () => {
      const loansCount = await this.instanceReadOnly.getSize();
      return loansCount;
    }, 0n);
    return response;
  }
  async findTroveInsertPosition(nominalCollateralRatio, hint) {
    const response = await catchAsync(async () => {
      const [upperHint, lowerHint] = await this.instanceReadOnly.findInsertPosition(
        nominalCollateralRatio,
        hint,
        hint
      );
      return { upperHint, lowerHint };
    }, null);
    return response;
  }
}
class HintHelpersContract extends PersistentContractWrapper {
  constructor(signer, provider, network) {
    const { address: address2, abi: abi2 } = HINT_HELPERS_CONTRACT;
    super({ signer, provider }, { address: address2[network], abi: abi2 });
  }
  async calculateApproximateHint(nicr, loansCount) {
    const response = await catchAsync(async () => {
      const trialsCount = BigInt(
        Math.min(Math.ceil(Math.sqrt(Number(loansCount)) * 15), 899)
      );
      const seed = Math.ceil(Math.random() * 1e7);
      const [approximateHint] = await this.instanceReadOnly.getApproxHint(
        nicr,
        trialsCount,
        seed
      );
      return approximateHint;
    }, null);
    return response;
  }
  async getApproximateHint(nicr, loansCount) {
    let retries = 0;
    while (retries < 20) {
      const response = await this.calculateApproximateHint(nicr, loansCount);
      if (response)
        return response;
      retries += 1;
    }
    return null;
  }
}
const _OrangeKitEthersSigner = class _OrangeKitEthersSigner extends AbstractSigner {
  constructor(provider, ethAddress, bitcoinWallet, orangekitSmartAccount) {
    super(provider);
    __privateAdd(this, _bitcoinWallet, void 0);
    __privateAdd(this, _address, void 0);
    __privateAdd(this, _orangekitSmartAccount, void 0);
    // We must add this to be compatible with ethers v5 and tbtc-v2.ts lib.
    __publicField(this, "_isSigner", true);
    __privateSet(this, _address, ethAddress);
    __privateSet(this, _bitcoinWallet, bitcoinWallet);
    __privateSet(this, _orangekitSmartAccount, orangekitSmartAccount);
  }
  static init(provider, ethAddress, bitcoinWallet, orangekitSmartAccount) {
    return new _OrangeKitEthersSigner(
      provider,
      ethAddress,
      bitcoinWallet,
      orangekitSmartAccount
    );
  }
  async signMessage(_message) {
    return __privateGet(this, _bitcoinWallet).signMessage(_message.toString());
  }
  async sendBitcoin(address2, amount) {
    return __privateGet(this, _bitcoinWallet).sendBitcoin(address2, amount);
  }
  async getAddress() {
    return Promise.resolve(__privateGet(this, _address));
  }
  async getBalance() {
    return Promise.resolve(__privateGet(this, _bitcoinWallet).getBalance());
  }
  async getBitcoinAddress() {
    return Promise.resolve(__privateGet(this, _bitcoinWallet).getAddress());
  }
  connect(provider) {
    return new _OrangeKitEthersSigner(
      provider,
      __privateGet(this, _address),
      __privateGet(this, _bitcoinWallet),
      __privateGet(this, _orangekitSmartAccount)
    );
  }
  async waitForTransactionResponse(hash, maxRetries = 30, delayMs = 1e3) {
    let retries = 0;
    this._checkProvider();
    while (retries < maxRetries) {
      const txResponse = (
        // eslint-disable-next-line no-await-in-loop
        await this.provider.getTransaction(hash)
      );
      if (txResponse) {
        return txResponse;
      }
      await new Promise((resolve) => {
        setTimeout(resolve, delayMs);
      });
      retries += 1;
    }
    throw new Error(`Transaction not found after ${maxRetries} retries.`);
  }
  async sendTransaction(transactionRequest, maxRetries, delayMs) {
    const hash = await __privateGet(this, _orangekitSmartAccount).sendTransaction(
      transactionRequest.to ?? "",
      (transactionRequest.value ?? 0n).toString(),
      transactionRequest.data ?? "",
      await __privateGet(this, _bitcoinWallet).getAddress(),
      await __privateGet(this, _bitcoinWallet).getPublicKey(),
      (message) => __privateGet(this, _bitcoinWallet).signMessage(message)
    );
    return this.waitForTransactionResponse(hash, maxRetries, delayMs);
  }
  // eslint-disable-next-line class-methods-use-this
  signTransaction() {
    throw new Error("Unsupported method");
  }
  // eslint-disable-next-line class-methods-use-this
  signTypedData() {
    throw new Error("Unsupported method");
  }
  // We must add this to be compatible with ethers v5 and tbtc-v2.ts lib.
  getNetwork() {
    var _a;
    return (_a = this.provider) == null ? void 0 : _a.getNetwork();
  }
  // We must add this to be compatible with ethers v5 and tbtc-v2.ts lib.
  // eslint-disable-next-line no-underscore-dangle
  _checkProvider() {
    if (!this.provider)
      throw new Error("Provider not available");
  }
  // We must add this to be compatible with ethers v5 and tbtc-v2.ts lib.
  async getChainId() {
    this._checkProvider();
    const network = await this.provider.getNetwork();
    return Number(network.chainId);
  }
};
_bitcoinWallet = new WeakMap();
_address = new WeakMap();
_orangekitSmartAccount = new WeakMap();
let OrangeKitEthersSigner = _OrangeKitEthersSigner;
const _Mezo = class _Mezo {
  constructor() {
    __privateAdd(this, _initializeContracts);
    __publicField(this, "api");
    __publicField(this, "chain", null);
    __publicField(this, "wallet", null);
    __privateAdd(this, _contracts4, null);
    this.api = {
      account: new MezoApiAccount(API_ENDPOINT),
      depositMigration: new MezoApiDepositMigration(API_ENDPOINT),
      deposit: new MezoApiDeposit(API_ENDPOINT),
      referralCodes: new MezoApiReferralCodes(API_ENDPOINT),
      session: new MezoApiSession(API_ENDPOINT),
      leaderboard: new MezoApiLeaderboard(API_ENDPOINT),
      statistics: new MezoApiStatistics(API_ENDPOINT),
      withdrawal: new MezoApiWithdrawal(API_ENDPOINT),
      receiptToken: new MezoApiReceiptToken(API_ENDPOINT),
      tbtc: new MezoApiTbtc(TBTC_API_ENDPOINT),
      matsnet: new MezoApiMatsnet(API_ENDPOINT),
      mats: new MezoApiMats(API_ENDPOINT_V2),
      campaigns: new MezoApiCampaigns(API_ENDPOINT_V2),
      borrow: new MezoApiBorrow(API_ENDPOINT_V2),
      donations: new MezoApiDonations(API_ENDPOINT_V2)
    };
  }
  async connectSigner(signer, ethersV5Signer, ethereumStaticProvider, mezoSigner, mezoStaticProvider, ethereumNetwork, mezoNetwork, isBitcoinWallet) {
    var _a;
    __privateMethod(this, _initializeContracts, initializeContracts_fn).call(this, signer, ethereumStaticProvider, mezoSigner, mezoStaticProvider, ethereumNetwork, mezoNetwork);
    if (!__privateGet(this, _contracts4))
      return;
    const supportedTokens = __privateMethod(_a = _Mezo, _getSupportedTokens, getSupportedTokens_fn).call(_a, signer, ethereumStaticProvider, ethereumNetwork, __privateGet(this, _contracts4).portalContract);
    const evmAddress = await signer.getAddress();
    const btcAddress = isBitcoinWallet ? await signer.getBitcoinAddress() : null;
    const mainAddress = isBitcoinWallet ? btcAddress : evmAddress;
    this.wallet = {
      signer,
      ethersV5Signer,
      ethereumStaticProvider,
      mezoSigner,
      mezoStaticProvider,
      mainAddress,
      evmAddress,
      btcAddress,
      ethereumNetwork,
      mezoNetwork,
      isBitcoinWallet
    };
    this.api.account.setWallet(this.wallet);
    this.api.depositMigration.setWallet(this.wallet);
    this.api.deposit.setWallet(this.wallet);
    this.api.referralCodes.setWallet(this.wallet);
    this.api.session.setWallet(this.wallet);
    this.api.leaderboard.setWallet(this.wallet);
    this.api.statistics.setWallet(this.wallet);
    this.api.withdrawal.setWallet(this.wallet);
    this.api.receiptToken.setWallet(this.wallet);
    this.api.tbtc.setWallet(this.wallet);
    this.api.matsnet.setWallet(this.wallet);
    this.api.mats.setWallet(this.wallet);
    this.api.borrow.setWallet(this.wallet);
    this.api.donations.setWallet(this.wallet);
    const depositMigrationModule = new DepositMigrationModule(
      this.wallet,
      ethereumNetwork,
      this.api.depositMigration
    );
    const depositModule = new DepositModule(
      this.wallet,
      ethereumNetwork,
      this.api.deposit
    );
    const withdrawalModule = new WithdrawalModule(
      this.wallet,
      ethereumNetwork,
      this.api.withdrawal
    );
    const receiptTokenModule = new ReceiptTokenModule(
      this.wallet,
      ethereumNetwork,
      this.api.receiptToken
    );
    const tbtcModule = new TbtcModule(
      this.wallet,
      ethersV5Signer,
      ethereumNetwork,
      this.api.tbtc,
      this.api.deposit,
      this.api.withdrawal
    );
    const musdModule = new MusdModule(this.wallet, mezoNetwork, {
      priceFeed: __privateGet(this, _contracts4).priceFeedContract,
      borrowerOperations: __privateGet(this, _contracts4).borrowerOperationsContract,
      troveManager: __privateGet(this, _contracts4).troveManagerContract,
      musd: __privateGet(this, _contracts4).musdContract,
      sortedTroves: __privateGet(this, _contracts4).sortedTrovesContract,
      hintHelpers: __privateGet(this, _contracts4).hintHelpersContract
    });
    const storeModule = new StoreModule(this.wallet, mezoNetwork, {
      store: __privateGet(this, _contracts4).storeContract,
      musd: __privateGet(this, _contracts4).musdContract,
      tahoNFT: __privateGet(this, _contracts4).tahoNFTContract,
      donations: __privateGet(this, _contracts4).donationsContract
    });
    const donationsModule = new DonationsModule(this.wallet, mezoNetwork, {
      musd: __privateGet(this, _contracts4).musdContract,
      donations: __privateGet(this, _contracts4).donationsContract
    });
    this.chain = {
      depositMigrationModule,
      depositModule,
      withdrawalModule,
      receiptTokenModule,
      tbtcModule,
      musdModule,
      storeModule,
      donationsModule,
      supportedTokens,
      portalContract: __privateGet(this, _contracts4).portalContract,
      bitcoinDepositorContract: __privateGet(this, _contracts4).bitcoinDepositorContract
    };
  }
  disconnectSigner() {
    this.api.account.setWallet(null);
    this.api.deposit.setWallet(null);
    this.api.referralCodes.setWallet(null);
    this.api.session.setWallet(null);
    this.api.leaderboard.setWallet(null);
    this.api.statistics.setWallet(null);
    this.api.withdrawal.setWallet(null);
    this.api.tbtc.setWallet(null);
    this.api.receiptToken.setWallet(null);
    this.api.matsnet.setWallet(null);
    this.api.mats.setWallet(null);
    this.api.borrow.setWallet(null);
    this.wallet = null;
    this.chain = null;
  }
  /**
   * Function to initialize Mezo SDK
   * @returns instance of Mezo SDK
   */
  static initialize(sentryConfig) {
    if (sentryConfig) {
      const { sentryDsn, sentryEnv, sentryOptions } = sentryConfig;
      if (sentryDsn && sentryEnv) {
        Sentry.init({ ...sentryOptions });
      }
    }
    return new _Mezo();
  }
  /**
   * Function to retrieve supported token balances
   * @returns token balances as an object => {[key: token]: { balance, decimals }}
   */
  async getSupportedTokenBalances() {
    var _a;
    const fallbackTokenBalances = Object.fromEntries(
      Object.keys(((_a = this.chain) == null ? void 0 : _a.supportedTokens) ?? {}).map((key) => {
        const { decimals } = SUPPORTED_TOKEN_CONTRACTS[key];
        return [key, { balance: 0n, decimals }];
      })
    );
    const response = await catchAsync(async () => {
      var _a2, _b;
      const supportedTokenBalances = await Promise.all(
        Object.entries(((_a2 = this.chain) == null ? void 0 : _a2.supportedTokens) ?? {}).map(
          async ([token, { contract }]) => {
            const tokenBalance = await contract.getTokenBalance();
            const { decimals } = SUPPORTED_TOKEN_CONTRACTS[token];
            return [token, { balance: tokenBalance, decimals }];
          }
        )
      );
      if ((_b = this.wallet) == null ? void 0 : _b.isBitcoinWallet) {
        const bitcoinBalance = await this.wallet.ethersV5Signer.getBalance();
        const bitcoinToken = {
          // @ts-expect-error FIX-ME adjust return types in orangekit
          BTC: { balance: BigInt(bitcoinBalance.total), decimals: 8n }
        };
        return {
          ...Object.fromEntries(supportedTokenBalances),
          ...bitcoinToken
        };
      }
      return Object.fromEntries(
        supportedTokenBalances
      );
    }, fallbackTokenBalances);
    return response;
  }
  /**
   * Function to retrieve matsnet tokens balances
   * @returns token balances as an object => {[key: token]: { balance, decimals }}
   */
  async getMezoTokenBalances() {
    const fallbackMezoBalance = {
      mBTC: { balance: 0n, decimals: 18n },
      MUSD: { balance: 0n, decimals: 18n }
    };
    const response = await catchAsync(async () => {
      var _a;
      if (!this.wallet)
        return fallbackMezoBalance;
      const mezoBalanceInWei = await this.wallet.mezoStaticProvider.getBalance(
        this.wallet.evmAddress
      );
      const musdBalance = await ((_a = this.chain) == null ? void 0 : _a.musdModule.getMusdTokenBalance());
      const mezoBalance = {
        mBTC: { balance: mezoBalanceInWei || 0n, decimals: 18n },
        MUSD: { balance: musdBalance || 0n, decimals: 18n }
      };
      return mezoBalance;
    }, fallbackMezoBalance);
    return response;
  }
  /**
   * Function to retrieve portal transactions
   * @returns portal deposits and withdrawals
   */
  async getPortalTransactions() {
    const response = await catchAsync(async () => {
      var _a;
      if (!this.wallet)
        return null;
      const { deposits, withdrawals } = await this.api.account.getAccountTransactions();
      (_a = this.chain) == null ? void 0 : _a.depositModule.syncExistingDeposits(deposits);
      return {
        deposits: deposits.filter((deposit) => !!(deposit == null ? void 0 : deposit.amount)),
        withdrawals
      };
    }, null);
    return response;
  }
  async getTokenAllowance() {
    var _a;
    const fallbackTokenAllowances = Object.fromEntries(
      Object.keys(((_a = this.chain) == null ? void 0 : _a.supportedTokens) ?? {}).map((key) => [key, 0n])
    );
    if (!this.wallet || !this.chain)
      return fallbackTokenAllowances;
    const { portalContract } = this.chain;
    const { signer } = this.wallet;
    const response = catchAsync(async () => {
      var _a2;
      const tokenAllowances = await Promise.all(
        Object.entries(((_a2 = this.chain) == null ? void 0 : _a2.supportedTokens) ?? {}).map(
          async ([token, { contract }]) => {
            const allowance = await contract.instanceReadOnly.allowance(
              signer,
              portalContract.address
            );
            return [token, allowance];
          }
        )
      );
      return Object.fromEntries(tokenAllowances);
    }, fallbackTokenAllowances);
    return response;
  }
  static async toEthersSigner(provider, account, orangeKitSmartAccount, bitcoinWalletProvider) {
    const providerChainId = Number((await provider.getNetwork()).chainId);
    const orangeKitSmartAccountChainId = Number(orangeKitSmartAccount.chainId);
    if (providerChainId !== orangeKitSmartAccountChainId) {
      throw new Error(
        "Provider chain id does not match orangekit smart account chain id"
      );
    }
    const ethersSigner = OrangeKitEthersSigner.init(
      null,
      account,
      bitcoinWalletProvider,
      orangeKitSmartAccount
    );
    return ethersSigner.connect(provider);
  }
  // TODO: We need to refactor it to handle on Mezo mainnet. We are missing chain ID right now
  static async toMezoEthersSigner(provider, account, bitcoinWalletProvider) {
    const providerChainId = Number((await provider.getNetwork()).chainId);
    if (providerChainId !== mezoMatsnetTestnet.id) {
      throw new Error(
        "Provider chain id does not match Mezo Matsnet Testnet chain id"
      );
    }
    const orangeKitSmartAccountForMatsnet = await OrangeKitSmartAccount.init(
      mezoMatsnetTestnet.id,
      mezoMatsnetTestnet.rpcUrls.default.http[0],
      new MezoTransactionSender()
    );
    return this.toEthersSigner(
      provider,
      account,
      orangeKitSmartAccountForMatsnet,
      bitcoinWalletProvider
    );
  }
};
_contracts4 = new WeakMap();
_initializeContracts = new WeakSet();
initializeContracts_fn = function(signer, ethereumStaticProvider, mezoSigner, mezoStaticProvider, ethereumNetwork, mezoNetwork) {
  __privateSet(this, _contracts4, {
    portalContract: new Portal(
      signer,
      ethereumStaticProvider,
      ethereumNetwork
    ),
    bitcoinDepositorContract: new BitcoinDepositor(
      signer,
      ethereumStaticProvider,
      ethereumNetwork
    ),
    priceFeedContract: new PriceFeedContract(
      mezoSigner,
      mezoStaticProvider,
      mezoNetwork
    ),
    borrowerOperationsContract: new BorrowerOperationsContract(
      mezoSigner,
      mezoStaticProvider,
      mezoNetwork
    ),
    troveManagerContract: new TroveManagerContract(
      mezoSigner,
      mezoStaticProvider,
      mezoNetwork
    ),
    storeContract: new StoreContract(
      mezoSigner,
      mezoStaticProvider,
      mezoNetwork
    ),
    musdContract: new MusdToken(mezoSigner, mezoStaticProvider, mezoNetwork),
    sortedTrovesContract: new SortedTrovesContract(
      mezoSigner,
      mezoStaticProvider,
      mezoNetwork
    ),
    hintHelpersContract: new HintHelpersContract(
      mezoSigner,
      mezoStaticProvider,
      mezoNetwork
    ),
    tahoNFTContract: new TahoNFTClaim(
      mezoSigner,
      mezoStaticProvider,
      mezoNetwork
    ),
    donationsContract: new DonationsContract(
      mezoSigner,
      mezoStaticProvider,
      mezoNetwork
    )
  });
};
_getSupportedTokens = new WeakSet();
getSupportedTokens_fn = function(signer, provider, network, portalContract) {
  const supportedTokens = Object.entries(SUPPORTED_TOKEN_CONTRACTS).map(
    ([token, { address: address2, abi: abi2 }]) => {
      const contractAddress = address2[network];
      const tokenContract = contractAddress ? new SupportedToken(signer, provider, portalContract, {
        address: contractAddress,
        abi: abi2
      }) : null;
      return tokenContract && tokenContract.target ? [token, { contract: tokenContract, address: address2 }] : null;
    }
  );
  return Object.fromEntries(
    supportedTokens.filter(
      (token) => token !== null
    )
  );
};
/**
 * Function to retrieve tokens supported by Portal contract
 * @param signer current transaction signer
 * @param network current network (local, sepolia, mainnet)
 * @param portalContract instance of portal contract
 * @returns list of supported tokens
 */
__privateAdd(_Mezo, _getSupportedTokens);
let Mezo = _Mezo;
export {
  API_ENDPOINT,
  API_ENDPOINT_V2,
  APPROVE_AND_CALL_TOKENS,
  BITCOIN_DEPOSITOR_CONTRACT,
  BORROWER_OPERATIONS_CONTRACT,
  BitcoinDepositor,
  BorrowerOperationsContract,
  CHAIN_ID,
  DAY,
  DONATIONS_CONTRACT,
  DepositMigrationModule,
  DepositModule,
  DonationsContract,
  DonationsModule,
  EthereumModule,
  HINT_HELPERS_CONTRACT,
  HOUR,
  MEZO_SESSION_EXPIRATION_TIME,
  MEZO_STABLECOINS,
  MIGRATABLE_TOKENS,
  MINUTE,
  MUSD_TOKEN_CONTRACT,
  Mezo,
  MezoApi,
  MezoApiAccount,
  MezoApiBorrow,
  MezoApiCampaigns,
  MezoApiDeposit,
  MezoApiDepositMigration,
  MezoApiDonations,
  MezoApiLeaderboard,
  MezoApiMats,
  MezoApiMatsnet,
  MezoApiReceiptToken,
  MezoApiReferralCodes,
  MezoApiSession,
  MezoApiStatistics,
  MezoApiTbtc,
  MezoApiWithdrawal,
  MezoModule,
  Module,
  MusdModule,
  MusdToken,
  PORTAL_CONTRACT,
  PORTAL_CONTRACT_ABI_VERSIONS,
  PRICE_FEED_CONTRACT,
  PersistentContractWrapper,
  Portal,
  PriceFeedContract,
  ReceiptTokenModule,
  SECOND,
  SENTRY_ENVIRONMENT,
  SORTED_TROVES_CONTRACT,
  STBTC_TOKENS,
  STBTC_TOKEN_CONTRACTS,
  STORE_CONTRACT,
  SUPERSTACK_TOKENS,
  SUPPORTED_PORTAL_ABI_VERSION,
  SUPPORTED_STABLECOIN_CONTRACTS,
  SUPPORTED_TOKEN_CONTRACTS,
  SupportedToken,
  TAHO_NFT_CONTRACT,
  TBTC_API_ENDPOINT,
  TROVE_MANAGER_CONTRACT,
  TahoNFTClaim as TahoNFTContract,
  TbtcModule,
  TroveManagerContract,
  TroveStatus,
  WEEK,
  WithdrawalModule,
  YEAR,
  ZERO_ADDRESS,
  aBtcAbi,
  bitcoinDepositorAbi,
  borrowerOperationsAbi,
  catchAsync,
  cbBtcAbi,
  convertFixedPoint,
  createError,
  createSignInWithWalletMessage,
  crvStbtcAbi,
  crvusdAbi,
  daiAbi,
  fallbackTroveDebtValue,
  fbtcAbi,
  fetchWithRetry,
  getOutputScriptFromAddress,
  getTokenAddress,
  getTokenName,
  hintHelpersAbi,
  intBtcAbi,
  isLegacyAddress,
  isNativeSegwitAddress,
  isNestedSegwitAddress,
  isSupportedBitcoinAddress,
  lBtcAbi,
  portalAbiMigrationsUpgrade,
  portalAbiReceiptsUpgrade,
  priceFeedAbi,
  solvbtcAbi,
  sortedTrovesAbi,
  swBtcAbi,
  tAbi,
  tbtcAbi,
  thusdAbi,
  troveManagerAbi,
  usdcAbi,
  usdeAbi,
  usdtAbi,
  wMAbi,
  wbtcAbi,
  xsolvbtcAbi
};
//# sourceMappingURL=index.js.map
